/**
 *
 * All java script logic for the application.
 *    (c) 2009-2012 Demandware Inc.
 *    Subject to standard usage terms and conditions
 * The code relies on the jQuery JS library to
 * be also loaded.
 *    For all details and documentation:
 *    https://github.com/Demandware/Site-Genesis
 */
// semi-colon to assure functionality upon script concatenation and minification

// if jQuery has not been loaded, load from google cdn
if (!window.jQuery) {
	var s = document.createElement('script');
	s.setAttribute('src', 'https://ajax.googleapis.com/ajax/libs/jquery/1.7.1/jquery.min.js');
	s.setAttribute('type', 'text/javascript');
	document.getElementsByTagName('head')[0].appendChild(s);
}
/** @namespace */
var app = (function (app, $) {
	//allows the use of $ within this function without conflicting with other JavaScript libraries which are using it (JQuery extension)
	document.cookie="dw=1";
	/******** private functions & vars **********/

	/**
	 * @private
	 * @function
	 * @description Cache dom elements which are being accessed multiple times.<br/>app.ui holds globally available elements.
	 */
	function initUiCache() {
		app.ui = {
			searchContainer : $("#navigation .header-search"),
			printPage		: $("a.print-page"),
			reviewsContainer: $("#pwrwritediv"),
			main			: $("#main"),
			primary			: $("#primary"),
			secondary		: $("#secondary"),
			// elements found in content slots
			slots : {
				subscribeEmail : $(".subscribe-email")
			}
		};
	}

	/**
	 * @private
	 * @function
	 * @description Apply dialogify event handler to all elements that match one or more of the specified selectors.
	 */
	function initializeEvents() {
		$('body').on("click", ".dialogify, [data-dlg-options], [data-dlg-action]", app.util.setDialogify)
		.on("mousewheel", "input[type='number'", function(e) {
			e.preventDefault();
		})
		.on("keydown", "input[type='number'", function(e) {
			if(e.which == 38 || e.which == 40) {
				e.preventDefault();
			}
		});

		$(document).on('click.header', '.header-top-message .close', function(e){
			e.preventDefault();
			$('.header-top-message').slideUp();
		});

		//initialize search suggestions
		app.searchsuggest.init(app.ui.searchContainer, app.resources.SIMPLE_SEARCH);

		// print handler
		app.ui.printPage.on("click", function () { window.print(); return false; });


		// add show/hide navigation elements
		$('.secondary-navigation .toggle').click(function(){
			$(this).toggleClass('expanded').next('ul').toggle();
		});

		// add generic toggle functionality
		$('.toggle').next('.toggle-content').hide();
		$('.toggle').click(function(){
			$(this).toggleClass('expanded').next('.toggle-content').toggle();
		});
		
		// subscribe email box
		if (app.ui.slots.subscribeEmail.length > 0)	{
			app.ui.slots.subscribeEmail.focus(function () {
				var val = $(this.val());
				if(val.length > 0 && val !== app.resources.SUBSCRIBE_EMAIL_DEFAULT) {
					return; // do not animate when contains non-default value
				}

				$(this).animate({ color: '#999999'}, 500, 'linear', function () {
					$(this).val('').css('color','#333333');
				});
			}).blur(function () {
				var val = $.trim($(this.val()));
				if(val.length > 0) {
					return; // do not animate when contains value
				}

				$(this).val(app.resources.SUBSCRIBE_EMAIL_DEFAULT)
					   .css('color','#999999')
					   .animate({color: '#333333'}, 500, 'linear');

			});
		}


		var oldState = '',
			customCountValidate = function(element){
				var inputs = $(element);
				var maxcount = parseInt($(element).attr("maxlength"));
				var maximumByte = maxcount * 1;
				var strLength = 0;
				var cbyte = 0;
				var limitStr = 0;
				var strRemoveEnmoji = '';
				var enmojiLength = 0;
				if(app.util.hasContainSpecialCharacter( inputs.val())){
					strRemoveEnmoji = inputs.val().replace(/(?:0\u20E3|1\u20E3|2\u20E3|3\u20E3|4\u20E3|5\u20E3|6\u20E3|7\u20E3|8\u20E3|9\u20E3|#\u20E3|\*\u20E3|\uD83C(?:\uDDE6\uD83C(?:\uDDE8|\uDDE9|\uDDEA|\uDDEB|\uDDEC|\uDDEE|\uDDF1|\uDDF2|\uDDF4|\uDDF6|\uDDF7|\uDDF8|\uDDF9|\uDDFA|\uDDFC|\uDDFD|\uDDFF)|\uDDE7\uD83C(?:\uDDE6|\uDDE7|\uDDE9|\uDDEA|\uDDEB|\uDDEC|\uDDED|\uDDEE|\uDDEF|\uDDF1|\uDDF2|\uDDF3|\uDDF4|\uDDF6|\uDDF7|\uDDF8|\uDDF9|\uDDFB|\uDDFC|\uDDFE|\uDDFF)|\uDDE8\uD83C(?:\uDDE6|\uDDE8|\uDDE9|\uDDEB|\uDDEC|\uDDED|\uDDEE|\uDDF0|\uDDF1|\uDDF2|\uDDF3|\uDDF4|\uDDF5|\uDDF7|\uDDFA|\uDDFB|\uDDFC|\uDDFD|\uDDFE|\uDDFF)|\uDDE9\uD83C(?:\uDDEA|\uDDEC|\uDDEF|\uDDF0|\uDDF2|\uDDF4|\uDDFF)|\uDDEA\uD83C(?:\uDDE6|\uDDE8|\uDDEA|\uDDEC|\uDDED|\uDDF7|\uDDF8|\uDDF9|\uDDFA)|\uDDEB\uD83C(?:\uDDEE|\uDDEF|\uDDF0|\uDDF2|\uDDF4|\uDDF7)|\uDDEC\uD83C(?:\uDDE6|\uDDE7|\uDDE9|\uDDEA|\uDDEB|\uDDEC|\uDDED|\uDDEE|\uDDF1|\uDDF2|\uDDF3|\uDDF5|\uDDF6|\uDDF7|\uDDF8|\uDDF9|\uDDFA|\uDDFC|\uDDFE)|\uDDED\uD83C(?:\uDDF0|\uDDF2|\uDDF3|\uDDF7|\uDDF9|\uDDFA)|\uDDEE\uD83C(?:\uDDE8|\uDDE9|\uDDEA|\uDDF1|\uDDF2|\uDDF3|\uDDF4|\uDDF6|\uDDF7|\uDDF8|\uDDF9)|\uDDEF\uD83C(?:\uDDEA|\uDDF2|\uDDF4|\uDDF5)|\uDDF0\uD83C(?:\uDDEA|\uDDEC|\uDDED|\uDDEE|\uDDF2|\uDDF3|\uDDF5|\uDDF7|\uDDFC|\uDDFE|\uDDFF)|\uDDF1\uD83C(?:\uDDE6|\uDDE7|\uDDE8|\uDDEE|\uDDF0|\uDDF7|\uDDF8|\uDDF9|\uDDFA|\uDDFB|\uDDFE)|\uDDF2\uD83C(?:\uDDE6|\uDDE8|\uDDE9|\uDDEA|\uDDEB|\uDDEC|\uDDED|\uDDF0|\uDDF1|\uDDF2|\uDDF3|\uDDF4|\uDDF5|\uDDF6|\uDDF7|\uDDF8|\uDDF9|\uDDFA|\uDDFB|\uDDFC|\uDDFD|\uDDFE|\uDDFF)|\uDDF3\uD83C(?:\uDDE6|\uDDE8|\uDDEA|\uDDEB|\uDDEC|\uDDEE|\uDDF1|\uDDF4|\uDDF5|\uDDF7|\uDDFA|\uDDFF)|\uDDF4\uD83C\uDDF2|\uDDF5\uD83C(?:\uDDE6|\uDDEA|\uDDEB|\uDDEC|\uDDED|\uDDF0|\uDDF1|\uDDF2|\uDDF3|\uDDF7|\uDDF8|\uDDF9|\uDDFC|\uDDFE)|\uDDF6\uD83C\uDDE6|\uDDF7\uD83C(?:\uDDEA|\uDDF4|\uDDF8|\uDDFA|\uDDFC)|\uDDF8\uD83C(?:\uDDE6|\uDDE7|\uDDE8|\uDDE9|\uDDEA|\uDDEC|\uDDED|\uDDEE|\uDDEF|\uDDF0|\uDDF1|\uDDF2|\uDDF3|\uDDF4|\uDDF7|\uDDF8|\uDDF9|\uDDFB|\uDDFD|\uDDFE|\uDDFF)|\uDDF9\uD83C(?:\uDDE6|\uDDE8|\uDDE9|\uDDEB|\uDDEC|\uDDED|\uDDEF|\uDDF0|\uDDF1|\uDDF2|\uDDF3|\uDDF4|\uDDF7|\uDDF9|\uDDFB|\uDDFC|\uDDFF)|\uDDFA\uD83C(?:\uDDE6|\uDDEC|\uDDF2|\uDDF8|\uDDFE|\uDDFF)|\uDDFB\uD83C(?:\uDDE6|\uDDE8|\uDDEA|\uDDEC|\uDDEE|\uDDF3|\uDDFA)|\uDDFC\uD83C(?:\uDDEB|\uDDF8)|\uDDFD\uD83C\uDDF0|\uDDFE\uD83C(?:\uDDEA|\uDDF9)|\uDDFF\uD83C(?:\uDDE6|\uDDF2|\uDDFC)))|[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2648-\u2653\u2660\u2663\u2665\u2666\u2668\u267B\u267F\u2692-\u2694\u2696\u2697\u2699\u269B\u269C\u26A0\u26A1\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD79\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED0\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3]|\uD83E[\uDD10-\uDD18\uDD80-\uDD84\uDDC0]/g, '');
					enmojiLength = inputs.val().length - strRemoveEnmoji.length;
				}else{
					strRemoveEnmoji = inputs.val();
				}
				strLength = strRemoveEnmoji.length;
				for (var i = 0; i < strLength; i++) {
					var ls_one_char = strRemoveEnmoji.charAt(i);
					var encodedCharacter = encodeURIComponent(ls_one_char);
					var encodedLength = encodedCharacter.length;
					if (encodedLength > 4) {
						cbyte += 3; //chinese language
					} else {
						cbyte++; //english language
					}
					if (cbyte <= maximumByte) {
						limitStr = i + 1;
					}
				}
				var realLength = limitStr + enmojiLength;

				if(strLength > realLength){
					return false;
				}

				return true;
			};

		$(document).on('keydown.customcount keyup.customcount', '.custom-count-length', function(e){
			if (!customCountValidate(this)) {
				this.value = oldState;
			} else {
				oldState = this.value;
			}
		});
	}
	/**
	 * @private
	 * @function
	 * @description Adds class ('js') to html for css targeting and loads js specific styles.
	 */
	function initializeDom() {
		// add class to html for css targeting
		$('html').addClass('js');
		if (app.clientcache.LISTING_INFINITE_SCROLL && !app.clientcache.LISTING_LOAD_MORE){
			$('html').addClass('infinite-scroll');
		}
		// load js specific styles
		app.util.limitCharacters();
		app.util.constrainGiftMessage();
		app.util.disableChromeAutocomp();
	}


	/**
	 * @property {Object} _app "inherits" app object via $.extend() at the end of this seaf (Self-Executing Anonymous Function)
	 */
	var _app = {
		containerId		: "content",
		ProductCache	: null,  // app.Product object ref to the current/main product
		ProductDetail	: null,
		clearDivHtml	: '<div class="clear"></div>',
		currencyCodes	: app.currencyCodes || {}, // holds currency code/symbol for the site

		/**
		 * @name init
		 * @function
		 * @description Master page initialization routine
		 */
		init: function () {

			if (document.cookie.length===0) {
				$("<div/>").addClass("browser-compatibility-alert").append($("<p/>").addClass("browser-error").html(app.resources.COOKIES_DISABLED)).appendTo("#browser-check");
			}


			// init global cache
			initUiCache();

			// init global dom elements
			initializeDom();

			// init global events
			initializeEvents();

			// phone prefix for sandro maje
			app.prefixformat = {
				'prefix': [ '+852', '+853'],
				'pattern': '^[0-9]+$'
			};
			app.prefixformat.init = function () {
				$.fn.smcpPhonePrefix && $('.row-phone-prefix input, input.phonefield, input.phone').smcpPhonePrefix(
					app.prefixformat
				);
			};

			// init specific global components
			app.tooltips.init();
			app.minicart.init();
			app.validator.init();
			app.components.init();
			app.searchplaceholder.init();
			app.prefixformat.init();
			// execute page specific initializations
			var ns = app.page.ns;
			if (ns && app[ns] && app[ns].init) {
				app[ns].init();
			}
		}
	};

	return $.extend(app, _app);
}(window.app = window.app || {}, jQuery));

/**
@class app.storefront
*/
(function (app, $) {
	var $cache = {};
	app.storefront = {
		init : function () {
			$cache = {
				slide : $('.slide'),
				slider : $('#homepage-slider'),
				wrapper : $('#wrapper')
			};

			/**
			 * @function
			 * @description Triggers the scroll event on a carousel element
			 * @param {Object} carousel
			 */
			function slideCarousel_initCallback(carousel) {

				// create navigation for slideshow
				var numSlides = $('#homepage-slider li').size();
				var slideShowNav = '<div class="jcarousel-control">';
				for( i=1; i <= numSlides; i++) {
					slideShowNav = slideShowNav + '<a href="#" class="link-'+i+'">' + i + '</a>';
				}
				slideShowNav = slideShowNav + '</div>';
				$('#homepage-slider .jcarousel-clip').append(slideShowNav);

			   $('.jcarousel-control a').bind('click', function() {
			        carousel.scroll(jQuery.jcarousel.intval($(this).text()));
			        return false;
			    });

			   $cache.slide.width($cache.wrapper.width());

			}
			/**
			 * @function
			 * @description Activates the visibility of the next element in the carousel
			 * @param {Object} carousel -- necessity needs TBD!
			 * @param {Object} item --  necessity needs TBD!
			 * @param {Number} idx Index of the item which should be activated
			 * @param {Object} state --  necessity needs TBD!
			 */
			function slideCarousel_itemVisible(carousel, item, idx, state) {
			    //alert('Item #' + idx + ' is visible');
				$('.jcarousel-control a').removeClass('active');
				$('.jcarousel-control').find('.link-'+idx).addClass('active');
			}

			$cache.slider.jcarousel({
				scroll: 1,
				auto: 4,
				buttonNextHTML: null,
				buttonPrevHTML: null,
				itemFallbackDimension: '100%',
				initCallback: slideCarousel_initCallback,
				itemFirstInCallback: slideCarousel_itemVisible
			});

			$('.activeAnimate').waypoint({
		        handler: function(direction) {
		            if (direction === 'down' && $(this.element).data('anim')) {
						$(this.element).addClass('animate')
		            }
		        },
		        offset: '90%'
		    });

		    $('.lp_3products .blocslider').each(function(index){
		    	$(this).css('transition-delay', 0.5 * index + 's');
		    })
		}
	};

}(window.app = window.app || {}, jQuery));


/**
@class app.tooltip
*/
(function (app, $) {
	var $cache = {};
	app.tooltips = {
		/**
		 * @function
		 * @description Initializes the tooltip-content and layout
		 */
		init : function () {

			$('.tooltip').tooltip({
				track: true,
				showURL: false,
			    bodyHandler: function() {
					// add a data attribute of data-layout="some-class" to your tooltip-content container if you want a custom class
					var tooltipClass = "";
					if( tooltipClass = $(this).find('.tooltip-content').data("layout") ) {
						tooltipClass = " class='" + tooltipClass + "' ";
					}
		        	return "<div " + tooltipClass + ">" + $(this).find('.tooltip-content').html() + "</div>";
				},
				showURL: false
			});

		}
	};

}(window.app = window.app || {}, jQuery));


/**
 @class app.product
 */
(function (app, $) {
	var $cache;

	/*************** app.product private vars and functions ***************/

	/**
	 * @private
	 * @function
	 * @description Loads product's navigation on the product detail page
	 */
	function loadProductNavigation() {
		var pidInput = $cache.pdpForm.find("input[name='pid']").last();
		var navContainer = $("#product-nav-container");
		// if no hash exists, or no pid exists, or nav container does not exist, return
		if (window.location.hash.length <= 1 || pidInput.length===0 || navContainer.length===0) {
			return;
		}

		var pid = pidInput.val();
		var hashParams = window.location.hash.substr(1);
		if (hashParams.indexOf("pid="+pid) < 0) {
			hashParams+="&pid="+pid;
		}

		var url = app.urls.productNav+(app.urls.productNav.indexOf("?") < 0 ? "?" : "&")+hashParams;
		app.ajax.load({url:url, target: navContainer});
	}

	/**
	 * @private
	 * @function
	 * @description Creates product recommendation carousel using jQuery jcarousel plugin
	 */
	function loadRecommendations() {
		var carousel = $(".carousel-recomendations");
		if(!carousel || carousel.length === 0 || carousel.children().length === 0) {
			return;
		}

		carousel.jcarousel(app.components.carouselSettings);
	}

	/**
	 * @function
	 * @description Sets the main image attributes and the href for the surrounding <a> tag
	 * @param {Object} atts Simple object with url, alt, title and hires properties
	 */
	function setMainImage(atts) {
		var imgZoom = $cache.pdpMain.find("a.main-image");
		if (imgZoom.length>0 && atts.hires && atts.hires!='' && atts.hires!='null') {
			// Do not reactivate the link in quick view
			if (imgZoom.parents('#QuickViewDialog').length == 0) {
				imgZoom.attr("href", atts.hires);
			}
		}

		imgZoom.find("img.primary-image").attr({
			"src" : atts.url,
			"alt" : atts.alt,
			"title" : atts.title
		});
	}

	/**
	 * @function
	 * @description helper function for swapping main image on swatch hover
	 * @param {Element} element DOM element with custom data-lgimg attribute
	 */
	function swapImage(element) {
		var lgImg = $(element).data("lgimg");

		var newImg = $.extend({}, lgImg);
		var imgZoom = $cache.pdpMain.find("a.main-image");
		var mainImage = imgZoom.find("img.primary-image");
		// store current image info
		lgImg.hires = imgZoom.attr("href");
		lgImg.url = mainImage.attr("src");
		lgImg.alt = mainImage.attr("alt");
		lgImg.title = mainImage.attr("title");
		// reset element's lgimg data attribute
		$(element).data(lgImg);
		// set the main image
		setMainImage(newImg);
	}


	/**
	 * @function
	 * @description Enables the zoom viewer on the product detail page
	 */
	function loadZoom() {
		if(app.quickView.isActive() || $('.touch').length > 0) { return; }

		//zoom properties
		var options = {
			zoomType: 'standard',
			alwaysOn : 0, // setting to 1 will load load high res images on page load
			zoomWidth : 559,
			zoomHeight : 522,
			position:'left',
			preloadImages: 0, // setting to 1 will load load high res images on page load
			xOffset: 20,
			yOffset:0,
			title: false
		};

		// Added to prevent empty hires zoom feature (if images don't exist)
		var mainImage = $cache.pdpMain.find("a.main-image");
		var hiresImageSrc = mainImage.attr("href");
		if( hiresImageSrc && hiresImageSrc != '' && hiresImageSrc.indexOf('noimagelarge')<0 && !$('.touch').length) {

			mainImage.removeData("jqzoom").jqzoom(options);
		}
	}
	/**
	 * @function
	 * @description replaces the images in the image container. for example when a different color was clicked.
	 */
	function replaceImages(ctnr) {
		var newImages = ctnr.find("#update-images");
		var imageContainer = ctnr.find("div.product-image-container");
		imageContainer.html(newImages.html());
		newImages.remove();
		setMainImageLink(ctnr);
		//loadZoom();
	}
	/**
	 * @function
	 * @description Adds css class (image-zoom) to the main product image in order to activate the zoom viewer on the product detail page.
	 */
	function setMainImageLink(ctnr) {
		if (app.quickView.isActive() || $('.touch').length > 0) {
			ctnr.find("a.main-image").removeAttr("href");
		}
		else {
			ctnr.find("a.main-image").addClass("image-zoom");
		}
	}
	/**
	 * @function
	 * @description Removes css class (image-zoom) from the main product image in order to deactivate the zoom viewer on the product detail page.
	 */
	function removeImageZoom() {
		$cache.pdpMain.find("a.main-image").removeClass("image-zoom");
	}

	/**
	 * @private
	 * @function
	 * @description Initializes the DOM of the product detail page (images, reviews, recommendation and product-navigation).
	 */
	function initializeDom() {
		$cache.pdpMain.find('div.product-detail .product-tabs').tabs();
		if($('#pwrwritediv').length > 0) {
			var options = $.extend(true, {}, app.dialog.settings, {
				autoOpen : true,
				height : 750,
				width : 650,
				dialogClass : 'writereview',
				title : 'Product Review',
				resizable : false
			});

			app.dialog.create({
				target : app.ui.reviewsContainer,
				options : options
			});
		}

		loadRecommendations($cache.container);
		loadProductNavigation();
		setMainImageLink($cache.pdpMain);

		if ($cache.productSetList.length>0) {
			var unavailable = $cache.productSetList.find("form").find("button.add-to-cart[disabled]");
			if (unavailable.length > 0) {
				//$cache.addAllToCart.attr("disabled", "disabled");
				//$cache.addToCart.attr("disabled", "disabled"); // this may be a bundle

			}
		}

		app.tooltips.init();
	}
	/**
	 * @private
	 * @function
	 * @description Initializes the cache on the product detail page.
	 */
	function initializeCache() {
		$cache = {
			productId : $("#pid"),
			pdpMain : $("#pdpMain"),
			productContent : $("#product-content"),
			thumbnails : $("#thumbnails"),
			bonusProductGrid : $(".bonusproductgrid"),
			imageContainer : $(".product-primary-image"),
			productSetList : $("#product-set-list"),
			addToCart : $("#add-to-cart"),
			addAllToCart : $("#add-all-to-cart")
		};
		$cache.detailContent = $cache.pdpMain.find("div.detail-content");
		$cache.pdpForm = $cache.pdpMain.find("form.pdpForm");
		$cache.swatches = $cache.pdpMain.find("ul.swatches");
		$cache.mainImageAnchor = $cache.imageZoom = $cache.imageContainer.find("a.main-image");
		$cache.mainImage = $cache.mainImageAnchor.find("img.primary-image");
	}

	/**
	 * @private
	 * @function
	 * @description Initializes events on the product detail page for the following elements:<br/>
	 * <p>availability message</p>
	 * <p>add to cart functionality</p>
	 * <p>images and swatches</p>
	 * <p>variation selection</p>
	 * <p>option selection</p>
	 * <p>send to friend functionality</p>
	 */
	function initializeEvents() {


		// add or update shopping cart line item
		app.product.initAddToCart();
		$cache.pdpMain.on("change keyup", "form.pdpForm input[name='Quantity']", function (e) {
			var availabilityContainer = $cache.pdpMain.find("div.availability");
			app.product.getAvailability(
				$("#pid").val(),
				$(this).val(),
				function (data) {
					if (!data) {
						$cache.addToCart.removeAttr("disabled");
						availabilityContainer.find(".availability-qty-available").html();
						availabilityContainer.find(".availability-msg").show();
						return;
					}else{
						var avMsg = null;
						var avRoot = availabilityContainer.find(".availability-msg").html('');

						// Look through levels ... if msg is not empty, then create span el
						if( data.levels.IN_STOCK> 0 ) {
							avMsg = avRoot.find(".in-stock-msg");
							if (avMsg.length===0) {
								avMsg = $("<p/>").addClass("in-stock-msg").appendTo(avRoot);
							}
							if( data.levels.PREORDER==0 && data.levels.BACKORDER==0 && data.levels.NOT_AVAILABLE==0 ) {
								// Just in stock
								avMsg.text(app.resources.IN_STOCK);
							} else {
								// In stock with conditions ...
								avMsg.text(data.inStockMsg);
							}
						}
						if( data.levels.PREORDER> 0 ) {
							avMsg = avRoot.find(".preorder-msg");
							if (avMsg.length===0) {
								avMsg = $("<p/>").addClass("preorder-msg").appendTo(avRoot);
							}
							if( data.levels.IN_STOCK==0 && data.levels.BACKORDER==0 && data.levels.NOT_AVAILABLE==0 ) {
								// Just in stock
								avMsg.text(app.resources.PREORDER);
							} else {
								avMsg.text(data.preOrderMsg);
							}
						}
						if( data.levels.BACKORDER> 0 ) {
							avMsg = avRoot.find(".backorder-msg");
							if (avMsg.length===0) {
								avMsg = $("<p/>").addClass("backorder-msg").appendTo(avRoot);
							}
							if( data.levels.IN_STOCK==0 && data.levels.PREORDER==0 && data.levels.NOT_AVAILABLE==0 ) {
								// Just in stock
								avMsg.text(app.resources.BACKORDER);
							} else {
								avMsg.text(data.backOrderMsg);
							}
						}
						if( data.inStockDate != '' ) {
							avMsg = avRoot.find(".in-stock-date-msg");
							if (avMsg.length===0) {
								avMsg = $("<p/>").addClass("in-stock-date-msg").appendTo(avRoot);
							}
							avMsg.text(String.format(app.resources.IN_STOCK_DATE,data.inStockDate));
						}
						if( data.levels.NOT_AVAILABLE> 0 ) {
							avMsg = avRoot.find(".not-available-msg");
							if (avMsg.length===0) {
								avMsg = $("<p/>").addClass("not-available-msg").appendTo(avRoot);
							}
							if( data.levels.PREORDER==0 && data.levels.BACKORDER==0 && data.levels.IN_STOCK==0 ) {
								avMsg.text(app.resources.NOT_AVAILABLE);
							} else {
								avMsg.text(app.resources.REMAIN_NOT_AVAILABLE);
							}
						}
						return;
					}
					$cache.addToCart.attr("disabled", "disabled");
					availabilityContainer.find(".availability-msg").hide();
					var avQtyMsg = availabilityContainer.find(".availability-qty-available");
					if (avQtyMsg.length===0) {
						avQtyMsg = $("<span/>").addClass("availability-qty-available").appendTo(availabilityContainer);
					}
					avQtyMsg.text(data.inStockMsg).show();

					var avQtyMsg = availabilityContainer.find(".availability-qty-available");
					if (avQtyMsg.length===0) {
						avQtyMsg = $("<span/>").addClass("availability-qty-available").appendTo(availabilityContainer);
					}
					avQtyMsg.text(data.backorderMsg).show();
				});

		});

		// Add to Wishlist and Add to Gift Registry links behaviors
		$cache.pdpMain.on("click", "a.wl-action", function (e) {
			e.preventDefault();

			var data = app.util.getQueryStringParams($("form.pdpForm").serialize());
			if (data.cartAction) {
				delete data.cartAction;
			}
			var url = app.util.appendParamsToUrl(this.href, data);
			url = this.protocol + "//" + this.hostname + ((url.charAt(0)==="/") ? url : ("/"+url));
			window.location.href = url;
		});

		$(".lastProductsSeenPush .swatchAll a.linkColor").on("hover", function() {
			var newImg = $(this).data("vignetteimage");
			$(".lastProductsSeenPush a.imgSeen img").attr("src", newImg);
		});

		$(".lastProductsSeenPush .swatchAll a.linkColor").on("mouseleave", function() {
			var oldImage = $(".lastProductsSeenPush a.imgSeen img").data("imgbase");
			$(".lastProductsSeenPush a.imgSeen img").attr("src", oldImage);
		});

		$cache.pdpMain.on("hover", "ul.Color a.swatchanchor", function () {
			swapImage(this);
		});
		// productthumbnail.onclick()
		$cache.pdpMain.on("click", "img.productthumbnail", function () {
			var lgImg = $(this).data("lgimg");

			// switch indicator
			$cache.pdpMain.find("div.product-thumbnails li.selected").removeClass("selected");
			$(this).closest("li").addClass("selected");

			setMainImage(lgImg);
			// load zoom if not quick view
			if( lgImg.hires != '' && lgImg.hires.indexOf('noimagelarge')<0 ){
				setMainImageLink($cache.pdpMain);
				//loadZoom();
			} else {
				removeImageZoom();
			}
		});

		// dropdown variations
		$cache.pdpMain.on("change", ".product-options select", function (e) {
			var salesPrice = $cache.pdpMain.find("div.product-add-to-cart .price-sales");

			var selectedItem = $(this).children().filter(":selected").first();
			var combinedPrice = selectedItem.data("combined");
			salesPrice.text(combinedPrice);
		});

		// prevent default behavior of thumbnail link and add this Button
		$cache.pdpMain.on("click", ".thumbnail-link, .addthis_toolbox a", false);
		$cache.pdpMain.on("click", "li.unselectable a", false);

		// handle drop down variation attribute value selection event
		$cache.pdpMain.on("change", ".variation-select", function(e){
			if ($(this).val().length===0) {return;}
			var qty = $cache.pdpForm.find("input[name='Quantity']").first().val(),
				listid = $cache.pdpForm.find("input[name='productlistid']").first().val(),
				productSet = $(this).closest('.subProduct'),
				params = {
					Quantity : isNaN(qty) ? "1" : qty,
					format : "ajax"
				};
			if( listid ) params.productlistid = listid;
			var target = (productSet.length > 0 && productSet.children.length > 0) ? productSet : $cache.productContent;
			var url = app.util.appendParamsToUrl($(this).val(), params);
			app.progress.show($cache.pdpMain);
			app.ajax.load({
				url: url,
				callback : function (data) {
					target.html(data);
					app.product.initAddToCart();
					$("update-images").remove();
					app.tooltips.init();
				}
			});
		});

		// swatch anchor onclick()
		$(".pdp-main").on("click", " .swatches a[href].swatchanchor, .swatches a[href].swatchanchor_text", function (e) {
			e.preventDefault();

			var mobileBox = $('.dropup-size.active').length;

			var el = $(this);
			if( el.parents('li').hasClass('unselectable') ) return;

			var isColor = el.closest("ul.swatches").hasClass("Color");

			var anchor = el,
				qty = $cache.pdpForm.find("input[name='Quantity']").first().val(),
				listid = $cache.pdpForm.find("input[name='productlistid']").first().val(),
				productSet = $(anchor).closest('.subProduct'),
				params = {
					Quantity : isNaN(qty) ? "1" : qty
				};

			// Make sure the selected color is included in the url
			if (!isColor) {
	        	$(this).closest('.pdp-main').last().find('.Color .selected a.swatchanchor').each(function() {
	        		if ($(this).data('variationparameter')) {
		        		var paramSplit = $(this).data('variationparameter').split('=');
		        		if (paramSplit.length > 1)
		        		params[paramSplit[0]] = paramSplit[1];
	        		}
	        	});
			}

			if( listid ) params.productlistid = listid;

			var target = (productSet.length > 0 && productSet.children.length > 0) ? productSet : el.closest(".pdp-main").find("#product-content");
			var url = app.util.appendParamsToUrl(this.href, params);
			app.progress.show(el.closest(".pdp-main"));
			app.ajax.load({
				url: url,
				callback : function (data) {
					if (data.trim().length == 0) {
						target.attr('data-loading-error', 'PRODUCT DATA WAS EMPTY, CHECK IF PRODUCT IS REALLY ONLINE OR ASSIGNED TO A CATEGORY');
						return;
					}

					var contentResponse = $(data).closest('#product-content').get(0);
					if($('#product-content') && $('#product-content').length > 0 && contentResponse) {
						$('#product-content').replaceWith(contentResponse);
					}

					if (mobileBox)
						$('.dropup-size').addClass('active');
					app.product.initAddToCart();
					Sandro.product.bindAddToWishlist();
					if (isColor) {
						$('.product-image-tiles').empty();
						replaceImages(target.closest(".pdp-main"));
						$('html, body').animate({ scrollTop: 0 }, 500);
						target.closest(".pdp-main").find(".productlargeimgdata").empty();
						Sandro.product.initSlide();
					}

					quickviewMobileCart();

					if($('#wrapper').hasClass('pt_product-details')) {
						productDetail.event.slideInit();
						productDetail.event.expand();
						productDetail.event.zoom();
						productDetail.event.resize();
						productDetail.event.getColor();
						$(document).trigger('product.switch.variation');
					}
					app.tooltips.init();

					// Product Detail Page Subtitle Update
					if($("span.productSubnameHiddenData") && $(".pdp-main .product-detail h1.product-name"))
					{
						$(".pdp-main .product-detail h1.product-name span#title").empty();
						var dat = $("span.productSubnameHiddenData").data("subtitle");
						if(typeof dat != "undefined")
							$(".pdp-main .product-detail h1.product-name span#title").append(dat);
					}

					//If swatch is selected from quick view then stop loading recommendation products
					if(target.find('.recourl').data('recourl').indexOf('quickview') == -1){
						var urlreco = target.find('.recourl').data('recourl');

						app.ajax.load({
							url: urlreco,
							callback : function (response) {
								$('.recommendations.cross-sell').remove();
								$('#complete-look').remove();
								var target = $('#pdpMain .product-rows');
								if ( $('#pdpMain .product-rows ~ #breadcrumb-wrapper').length )
									target = $('#pdpMain #breadcrumb-wrapper');
								target.after(response);
								//To initialize shop link on complet look after swatch selection
								initSliderLook();
								Sandro.content.activeLinkQuickView();
							}
						});
					}

					// fixed variants
					$(document).trigger('fixedDetails');

					$(window).trigger('resize.pdp');
				}
			});
		});

		$cache.productSetList.on("click", "div.product-set-item li a[href].swatchanchor,div.product-set-item li a[href].swatchanchor_text", function (e) {
			e.preventDefault();
			// get the querystring from the anchor element
			var params = app.util.getQueryStringParams(this.search);
			var psItem = $(this).closest(".product-set-item");

			// set quantity to value from form
			var qty = psItem.find("form").find("input[name='Quantity']").first().val();
			params.Quantity = isNaN(qty) ? "1" : qty;

			var url = app.urls.getSetItem + "?" + $.param(params);

			// get container
			var ic = $(this).closest(".product-set-item");
			ic.load(url, function () {
				app.progress.hide();

				app.product.initAddToCart(ic);
				app.tooltips.init();
			});
		});

		$cache.addAllToCart.on("click", function (e) {
			e.preventDefault();
			var psForms = $cache.productSetList.find("form").toArray(),
				miniCartHtml = "",
				addProductUrl = app.util.ajaxUrl(app.urls.addProduct);

			// add items to cart
			function addItems() {
				var form = $(psForms.shift());
				var itemid = form.find("input[name='pid']").val();

				$.ajax({
					dataType : "html",
					url: addProductUrl,
					data: form.serialize()
				})
				.done(function (response) {
					// success
					miniCartHtml = response;
				})
				.fail(function (xhr, textStatus) {
					// failed
					var msg = app.resources.ADD_TO_CART_FAIL;
					$.validator.format(msg, itemid);
					if(textStatus === "parsererror") {
						msg+="\n"+app.resources.BAD_RESPONSE;
					} else {
						msg+="\n"+app.resources.SERVER_CONNECTION_ERROR;
					}
					window.alert(msg);
				})
				.always(function () {
					if (psForms.length > 0) {
						addItems();
					}
					else {
						app.quickView.close();
						app.minicart.show(miniCartHtml);
					}
				});
			}
			addItems();
			return false;
		});
		app.sendToFriend.initializeDialog($cache.pdpMain, "a.send-to-friend");

		$cache.pdpMain.find("button.add-to-cart[disabled]").attr('title', $cache.pdpMain.find(".availability-msg").html() );
	}

	/**
	 * @private
	 * @function
	 * @description Event handler to handle the add to cart event
	 */
	function setAddToCartHandler(e) {
		e.preventDefault();
		var form = $(this).closest("form");
		var qty = form.find("input[name='Quantity']");
		var isSubItem = $(this).hasClass("sub-product-item");
		var isQuickview = $(this).parents("#QuickViewDialog").length;
		if(qty.length === 0 || isNaN(qty.val()) || parseInt(qty.val(), 10) === 0) {
			qty.val("1");
		}
		var product = $(this).data("product");
		var data = form.serialize();
		app.cart.update(data, function (response) {
			var uuid = form.find("input[name='uuid']");
			if (uuid.length > 0 && uuid.val().length > 0) {
				app.cart.refresh();
			}
			else {
				if (!isSubItem) {
					app.quickView.checkoutContinue();
				}
				if(isQuickview){
					app.minicart.updateMiniCart(response);
				} else{
					app.minicart.show(response);
				}
			}
			Sandro.minicart.bindEvents();

			$(document).trigger("pdp.addtocart", [product]);

			$('#mobileBasket span').html($('#mini-cart .mini-cart-nb').html());
			$('.footerMobile .mini-cart-total span.mini-cart-nb').html($('#mini-cart .mini-cart-nb').html());
		});
	}



	/*************** app.product public object ***************/
	app.product = {
		deviceLoaded : "",

		gridHelper : {
			1 : "grid-one",
			2 : "grid-two",
			4 : "grid-four"
		},

		init : function () {
			initializeCache();
			initializeDom();
			initializeEvents();
			//loadZoom();
		},
		readReviews : function(){
			$('.product-tabs').tabs('select','#tab4');
			$('body').scrollTop($('#tab4').offset().top);
		},
		updateUI : function() {
			var grid = $(".search-result-items").hasClass('item-grid-two')?$("button.btn-change-grid.grid-two").data('gridsize'):($(".search-result-items").hasClass('item-grid-one')?$("button.btn-change-grid.grid-one").data('gridsize'):$("button.btn-change-grid.grid-four").data('gridsize'));

			$("button.btn-change-grid").removeClass("active");
			$("button." + app.product.gridHelper[grid]).addClass("active");
		},
		/**
		 * @function
		 * @description Loads a product into a given container div
		 * @param {Object} options An object with the following properties:</br>
		 * <p>containerId - id of the container div, if empty then global app.containerId is used</p>
		 * <p>source - source string e.g. search, cart etc.</p>
		 * <p>label - label for the add to cart button, default is Add to Cart</p>
		 * <p>url - url to get the product</p>
		 * <p>id - id of the product to get, is optional only used when url is empty</p>
		 */
		get : function (options) {
			var target = options.target || app.quickView.init();
			var source = options.source || "";
			var productListID = options.productlistid || "";

			var productUrl = options.url || app.util.appendParamToURL(app.urls.getProductUrl, "pid", options.id);
			if(source.length > 0) {
				productUrl = app.util.appendParamToURL(productUrl, "source", source);
			}
			if(productListID.length > 0) {
				productUrl = app.util.appendParamToURL(productUrl, "productlistid", productListID);
			}

			// show small loading image
			app.ajax.load({
				target : target,
				url : productUrl,
				data : options.data || "",
				// replace with callback passed in by options
				callback : options.callback || app.product.init
			});
		},
		/**
		 * @function
		 * @description Gets the availability to given product and quantity
		 */
		getAvailability : function (pid, quantity, callback) {
			app.ajax.getJson({
				url: app.util.appendParamsToUrl(app.urls.getAvailability, {pid:pid, Quantity:quantity}),
				callback: callback
			});
		},
		/**
		 * @function
		 * @description Binds the click event to a given target for the add-to-cart handling
		 * @param {Element} target The target on which an add to cart event-handler will be set
		 */
		initAddToCart: function (target) {
			$(window).trigger('resize.pdp');

			$(".add-to-cart").each(function(){
				if(!$(this).hasClass('add-function')){
					$(this).on("click", setAddToCartHandler);
					$(this).addClass('add-function');
				}
			});
		},
		/**
		 * Breakpoint values for desktop and mobile
		 */
		breakPointMobile : 768,
		breakPointDesktop : 1024,
		/**
		 * Function that retrieves the Device the user is on
		 * used on the ChangeGrid function
		 */
		deviceLoad : function () {
			var device = "";
			var sizeWindow = window.innerWidth;

			if (sizeWindow < app.product.breakPointMobile) {
				device = "mobile";
			}
			else if (sizeWindow < app.product.breakPointDesktop && sizeWindow >= app.product.breakPointMobile) {
				device = "tablet";
			}
			else if (sizeWindow >= app.product.breakPointDesktop) {
				device = "desktop";
			}
			return device;
		},


		/**
		 * @function
		 * @description Binds and handle gridchanges on product search and listing pages
		 */
		changeGrid : function(grid, gridUrl) {

			// Update cookie data
			if ($.cookie('gridSelected')) {
				$.removeCookie('gridSelected', { path: '/' });
			}
			$.cookie('gridSelected', grid, { expires: 1, path: '/' });

			// Ajax call
			app.progress.show($("#main").find(".search-result-content"));
			app.ajax.load({
				url: app.util.ajaxUrl(gridUrl)+"&ajax=1",
				callback : function (data) {
					$('#main').html(data);
					app.filterCatalog.init();
					app.product.tile.init();

					picturefill();
					app.progress.hide();
				}
			});

		}
	};

}(window.app = window.app || {}, jQuery));

/**
 * @class app.product.tile
 */
(function (app, $) {
	var $cache = {};

	/**
	 * @function
	 * @description Initializes the DOM of the Product Detail Page
	 */
	function initializeDom() {
		var tiles = $cache.container.find(".product-tile");
		if (tiles.length===0) { return; }
	}
	/**
	 * @private
	 * @function
	 * @description Initializes events on the product-tile for the following elements:<br/>
	 * <p>swatches</p>
	 * <p>thumbnails</p>
	 */
	function initializeEvents() {

		// Event for handling UI feedback when a grid is selected + launching the ajax update of the grid
		$('body').on("click", "button.btn-change-grid", function() {
			$('button.btn-change-grid').removeClass('active');
			$(this).addClass('active');
			app.product.changeGrid($(this).data('gridsize'),$(this).data('href'));
		});

		// Event for handling the "Back to top" button
		$('body').on("touchend click", ".srollToTop", function (e) {
			e.preventDefault();
			$('html, body').animate({scrollTop : 0},800);
		});

		// Event for changing the grid number on resize.
		// Put inside a document ready to avoid an automatic triggering of this event at page loading
		$(document).ready(function(){
			// Initializing type of device used in this event
			app.product.deviceLoaded = app.product.deviceLoad();

			$(window).on("resize", function() {
				var currentDevice = app.product.deviceLoad();
				if (app.product.deviceLoaded !== currentDevice || !$.cookie('checkDevice')) {
					app.product.deviceLoaded = currentDevice;
					$.cookie('checkDevice', 1, { expires: 1, path: '/' });

					var grid = $(".wrapper-btn-change-grid").data("grid"+currentDevice);

					$(".search-result-items").removeClass("item-grid-one item-grid-two item-grid-four");
					$(".search-result-items").addClass("item-" + app.product.gridHelper[grid]);

					app.productlistpage.ruptureMerch();
					app.product.updateUI();
				}
			}).trigger('resize');

			// Event show terms and conditions for the first time log to private sale
			if ($('.terms-conditions-popup').length) {
				$('.terms-conditions-popup').dialog({
					modal: true,
					dialogClass: 'custom-dialog'
				});
			}
		});


		//app.quickView.initializeButton($cache.container, ".product-image");
		$cache.container.on("mouseleave", ".swatch-list", function(e){
			// Restore current thumb image
			var tile = $(this).closest(".grid-tile");
			var thumb = tile.find(".product-image a.thumb-link img").filter(":first");
			var data = thumb.data("current");
			if(thumb && data){
				thumb.attr({
					src : data.src,
					alt : data.alt,
					title : data.title
				});
			}
			tile.find(".product-pricing .priceContainer").html(tile.find(".hiddenPriceDefault").html());
		});
		$cache.container.on("mouseenter", ".swatch-list a.swatch", function (e) {
			//if ($(this).hasClass("selected")) { return; }

			// get current thumb details
			var tile = $(this).closest(".grid-tile");
			var thumb = tile.find(".product-image a.thumb-link img").filter(":first");
			var swatchImg = $(this).children("img").filter(":first");
			var data = swatchImg.data("thumb");
			var current = thumb.data('current');

			var pricingData = eval(tile.find(".product-pricing-data").data('pricings'));
			var colorID = swatchImg.attr("data-colorid");
			var oldPriceSpan = tile.find(".product-pricing .reducePrice");
			//var percentSpan = tile.find(".percentAvantage");
			var salesPriceSpan = tile.find(".product-pricing .product-sales-price");

			// If this is the first time, then record the current img
			if(!current) {
			    thumb.data('current',{src:thumb[0].src, alt:thumb[0].alt, title:thumb[0].title});
			    thumb.data('currentPricing',{old:oldPriceSpan.html(), percent:percentSpan.html(), sale:salesPriceSpan.html()});
			}

			if(pricingData) {
				if(pricingData[colorID].reductionPercentage) {
					if (oldPriceSpan.length == 0) {
						salesPriceSpan.closest('a').wrap('<div class="reducePercent"></div>');
						salesPriceSpan.closest('a').before('<a class="reducePrice"></a>');
						oldPriceSpan = tile.find(".reducePrice");

						percentSpan = tile.find(".percentAvantage");
					}
					tile.find(".product-pricing a.reducePrice").parent().addClass("reducePercent");
					oldPriceSpan.show();
				} else {
					tile.find(".product-pricing .reducePercent").removeClass("reducePercent");
					oldPriceSpan.hide();
					tile.find(".quick-actions").css('bottom', '');
				}

				oldPriceSpan.html(pricingData[colorID].formattedOldPrice);
				salesPriceSpan.html(pricingData[colorID].formattedSalePrice);
			}

			// Set the tile image to the values provided on the swatch data attributes
			thumb.attr({
				src : data.src,
				alt : data.alt,
				title : data.title
			});

			//swatchImg.data("thumb", currentAtts);
		});

		//Open and Close Mobile Filter
		$('.show-filter-mobile, .btn-close-block').on('click', function(){
			$(".show-filter-mobile").toggleClass("filter-mobile-active");
			$(".main-customSelect").stop(false,true).slideToggle();
		});

		//Fixe filter bar at the top on scroll
		$(window).on('resize', function() {
			var windowW = window.innerWidth;
			var deviceMobile = false;

			if(window.innerWidth < 768 && deviceMobile == false){
				deviceMobile == true;

				$('.filterListProduct .refinement').each(function() {
					var filter = $(this);

					filter.unbind();
					filter.find(".filterContent").removeAttr('style');
				});
			} else {
				deviceMobile == false
				$(".customSelect").removeAttr('style');

				$('.filterListProduct .refinement').each(function() {
					var filter = $(this);
					filter.unbind();

					filter.on('mouseenter', function() {
						if(!filter.find(".filterContent").is(":visible")){
							filter.addClass('expanded');
							filter.find(".filterContent").stop(false,true).show('slide', {direction:'up'}, 500);
						}
					}).on('mouseleave', function() {
						if(filter.find(".filterContent").is(":visible")){
							filter.removeClass('expanded');
							filter.find(".filterContent").stop(false,true).hide('slide', {direction:'up'}, 500);
						}


					});
				});
			}

			var device = app.product.deviceLoad();

			if(typeof($.cookie) === "function"){
				if ($.cookie('currentDevice')) {
					if ($.cookie('currentDevice') !== device) {
						$.removeCookie('currentDevice', { path: '/' });
						$.cookie('currentDevice', device, { expires: 1, path: '/' });
					}
				}
				else {
					$.cookie('currentDevice', device, { expires: 1, path: '/' });
				}
			}

		}).resize();

		var is_touch_device = function() {
			  return 'ontouchstart' in window || navigator.maxTouchPoints;
		};

		if($('.customSelect').length){
			$(document).on('click', '.customSelect a', function(e){
				e.preventDefault();

				$(this).closest('ul').addClass('active');
				var optionID        = $(this).parent().data('value') ,
					selectReference = $(this).closest('.has-custom-select').find('select');

				if(!$(this).parent().hasClass('active')){
					selectReference.val(optionID);
					selectReference.trigger('change');
					$(this).closest('ul').addClass('active');
				}
			});

			$('.has-custom-select').each(function() {
				var filter = $(this);

				if(is_touch_device()){
					filter.on('click', function() {
						filter.toggleClass('open');
						filter.find(".filterContent").slideToggle();
					});
				}else{
					filter.on('mouseenter', function() {
						if(!filter.find(".filterContent").is(":visible")){
							filter.addClass('open');
							filter.find(".filterContent").stop(false,true).show('slide', {direction:'up'}, 500);
						}
					}).on('mouseleave', function() {
						if(filter.find(".filterContent").is(":visible")){
							filter.removeClass('open');
							filter.find(".filterContent").stop(false,true).hide('slide', {direction:'up'}, 500);
						}
					});
				}


			});
		}

	    //Fixe filter bar at the top on scroll
		function fixeFilterOnScroll() {
	    	var wrapFilter = $('.filterNew');
	    	var FilterFixed = false;

			$(window).on('scroll',function(){
				if($(window).scrollTop() >= 163 && FilterFixed == false) {
					FilterFixed = true;
					wrapFilter.addClass('fixed');
				}else if ($(window).scrollTop() < 163 && FilterFixed == true){
					FilterFixed = false;
					wrapFilter.removeClass('fixed');
				}
			}).scroll();
	    }
		fixeFilterOnScroll();

		$('.linkQuickView, .linkWishList').on('click', function(e) {
			e.preventDefault();
			var myWidth = $(this).attr('data-width');
			if($(window).width() > 767) {
				myWidth = 880;
			}else{
				myWidth = 310;
			}

			app.quickView.show({
				url : $(this).attr("href"),
				width: myWidth
			});
			Sandro.product.bindAddToWishlist();
			$(document).on('click', '.add-to-cart-disabled', function(){
				Sandro.product.cannotaddtocart(this);
			});

			return false;
		});
	}

	/*************** app.product.tile public object ***************/
	app.product.tile = {
		/**
		 * @function
		 * @description Cache, events and initialization
		 */
		init : function () {
			$cache = {
				container : $(".tiles-container")
			};
			initializeEvents();
		}
	};

}(window.app = window.app || {}, jQuery));

/**
 * @class app.product.compare
 */
(function (app, $) {
	var $cache = {},
		_currentCategory = "",
		_isClearing = false,
		MAX_ACTIVE = 6,
		CI_PREFIX = "ci-";

	/**
	 * @private
	 * @function
	 * @description Verifies the number of elements in the compare container and updates it with sequential classes for ui targeting
	 */
	function refreshContainer() {
		if (_isClearing) { return; }

		var ac = $cache.compareContainer.find(".active").length;

		if (ac < 2) {
			$cache.compareButton.attr("disabled", "disabled");
		}
		else {
			$cache.compareButton.removeAttr("disabled");
		}

		// update list with sequential classes for ui targeting
		var compareItems = $cache.compareContainer.find('.compare-item');
		for( i=0; i < compareItems.length; i++ ){
			compareItems.removeClass('compare-item-' + i);
			$(compareItems[i]).addClass('compare-item-' + i);
		}

		$cache.compareContainer.toggle(ac > 0);

	}
	/**
	 * @private
	 * @function
	 * @description Adds an item to the compare container and refreshes it
	 */
	function addToList(data) {
		// get the first compare-item not currently active
		var item = $cache.compareContainer.find(".compare-item").not(".active").first();
		if (item.length===0) { return; } // safety only

		// if already added somehow, return
		if ($("#"+CI_PREFIX+data.uuid).length > 0) {
			return;
		}
		// set as active item
		item.addClass("active")
			.attr("id", CI_PREFIX+data.uuid)
			.data("itemid", data.itemid);

		// replace the item image
		var itemImg = item.children("img.compareproduct").first();
		itemImg.attr({src : $(data.img).attr("src"), alt : $(data.img).attr("alt")});

		// refresh container state
		refreshContainer();

		var tile = $("#"+data.uuid);
		if (tile.length===0) { return; }

		// ensure that the associated checkbox is checked
		tile.find(".compare-check")[0].checked = true;
	}
	/**
	 * @private
	 * @function
	 * description Removes an item from the compare container and refreshes it
	 */
	function removeFromList(uuid) {
		var item = $("#"+CI_PREFIX+uuid);
		if (item.length===0) { return; }

		// replace the item image
		var itemImg = item.children("img.compareproduct").first();
		itemImg.attr({src : app.urls.compareEmptyImage, alt : app.resources.EMPTY_IMG_ALT});

		// remove class, data and id from item
		item.removeClass("active")
			.removeAttr("id")
			.removeAttr("data-itemid")
			.data("itemid", "");

		// use clone to prevent image flash when removing item from list
		var cloneItem = item.clone();
		item.remove();
		cloneItem.appendTo($cache.comparePanel);
		refreshContainer();
		// ensure that the associated checkbox is not checked
		var tile = $("#"+uuid);
		if (tile.length === 0 ) { return; }

		tile.find(".compare-check")[0].checked = false;
	}
	/**
	 * @private
	 * @function
	 * description Initializes the cache of compare container
	 */
	function initializeCache() {
		$cache = {
			primaryContent : $("#primary"),
			compareContainer : $("#compare-items"),
			compareButton : $("#compare-items-button"),
			clearButton : $("#clear-compared-items"),
			comparePanel : $("#compare-items-panel")
		};
	}
	/**
	 * @private
	 * @function
	 * @description Initializes the DOM-Object of the compare container
	 */
	function initializeDom() {
		_currentCategory = $cache.compareContainer.data("category") || "";
		var active = $cache.compareContainer.find(".compare-item").filter(".active");
		active.each(function () {
			var uuid = this.id.substr(CI_PREFIX.length);
			var tile = $("#"+uuid);
			if (tile.length === 0 ) { return; }

			tile.find(".compare-check")[0].checked = true;
		});
		// set container state
		refreshContainer();
	}
	/**
	 * @private
	 * @function
	 * @description Initializes the events on the compare container
	 */
	function initializeEvents() {
		// add event to buttons to remove products
		$cache.primaryContent.on("click", ".compare-item-remove", function (e, async) {
			var item = $(this).closest(".compare-item");
			var uuid = item[0].id.substr(CI_PREFIX.length);
			var tile = $("#"+uuid);
			var args = {
				itemid : item.data("itemid"),
				uuid : uuid,
				cb :  tile.length===0 ? null : tile.find(".compare-check"),
				async : async
			};
			app.product.compare.removeProduct(args);
			refreshContainer();
		});

		// Button to go to compare page
		$cache.primaryContent.on("click", "#compare-items-button", function () {
			window.location.href = app.util.appendParamToURL(app.urls.compareShow, "category", _currentCategory);
		});

		// Button to clear all compared items
		$cache.primaryContent.on("click", "#clear-compared-items", function () {
			_isClearing = true;
			$cache.compareContainer.hide()
								   .find(".active .compare-item-remove")
								   .trigger("click", [false]);
			_isClearing = false;

		});
	}

	/*************** app.product.compare public object ***************/
	app.product.compare = {
		/**
		 * @function
		 * @description Cache, events and initialization
		 */
		init : function () {
			initializeCache();
			initializeDom();
			initializeEvents();
		},
		initCache : initializeCache,
		/**
		 * @function
		 * @description Adds product to the compare table
		 */
		addProduct : function (args) {
			var items = $cache.compareContainer.find(".compare-item");
			var cb = $(args.cb);
			var ac = items.filter(".active").length;
			if(ac===MAX_ACTIVE) {
				if(!window.confirm(app.resources.COMPARE_CONFIRMATION)) {
					cb[0].checked = false;
					return;
				}

				// remove product using id
				var item = items.first();

				// safety check only. should never occur.
				if (item[0].id.indexOf(CI_PREFIX)!==0) {
					cb[0].checked = false;
					window.alert(app.resources.COMPARE_ADD_FAIL);
					return;
				}
				var uuid = item[0].id.substr(CI_PREFIX.length);
				app.product.compare.removeProduct({
					itemid: item.data("itemid"),
					uuid: uuid,
					cb: $("#"+uuid).find(".compare-check")
				});
			}

			app.ajax.getJson({
				url : app.urls.compareAdd,
				data : { 'pid' : args.itemid, 'category' : _currentCategory },
				callback : function (response) {
					if (!response || !response.success) {
						// response failed. uncheck the checkbox return
						cb.checked = false;
						window.alert(app.resources.COMPARE_ADD_FAIL);
						return;
					}

					// item successfully stored in session, now add to list...
					addToList(args);
				}
			});
		},
		/**
		 * @function
		 * @description Removes product from the compare table
		 */
		removeProduct : function (args) {
			if (!args.itemid) { return; }
			var cb = args.cb ? $(args.cb) : null;
			app.ajax.getJson({
				url : app.urls.compareRemove,
				data : { 'pid' : args.itemid, 'category' : _currentCategory },
				async: args.async,
				callback : function (response) {
					if (!response || !response.success) {
						// response failed. uncheck the checkbox return
						if (cb && cb.length > 0) { cb[0].checked = true; }
						window.alert(app.resources.COMPARE_REMOVE_FAIL);
						return;
					}

					// item successfully removed session, now remove from to list...
					removeFromList(args.uuid);
				}
			});
		}
	};

}(window.app = window.app || {}, jQuery));

/**
 * @class app.compare
 */
(function (app, $) {
	var $cache = {};
	/**
	 * @private
	 * @function
	 * @description Initializes the cache on the compare table
	 */
	function initializeCache() {
		$cache = {
			compareTable : $("#compare-table"),
			categoryList : $("#compare-category-list")
		};
	}
	/**
	 * @private
	 * @function
	 * @description Initializes the DOM on the product tile
	 */
	function initializeDom() {
		app.product.tile.init();
	}
	/**
	 * @private
	 * @function
	 * @description Binds the click events to the remove-link and quick-view button
	 */
	function initializeEvents() {
		$cache.compareTable.on("click", ".remove-link", function (e) {
			e.preventDefault();
			app.ajax.getJson({
				url : this.href,
				callback : function (response) {
					app.page.refresh();
				}
			});
		})
		.on("click", ".open-quick-view", function (e) {
			e.preventDefault();
			var form = $(this).closest("form");
			app.quickView.show({
				url:form.attr("action"),
				source:"quickview",
				data:form.serialize()
			});
		});

		$cache.categoryList.on("change", function () {
			$(this).closest("form").submit();
		});
	}

	/*************** app.compare public object ***************/
	app.compare = {
		/**
		 * @function
		 * @description Initializing of Cache, DOM and events
		 */
		init : function () {
			initializeCache();
			initializeDom();
			initializeEvents();
			app.product.initAddToCart();
		}
	};


}(window.app = window.app || {}, jQuery));

/**
 * @class app.sendToFriend
 */
(function (app, $) {
	var $cache = {},
		initialized=false;
	/**
	 * @private
	 * @function
	 * @description Initializes the events (preview, send, edit, cancel and close) on the send to friend form
	 */
	function initializeEvents() {
		app.util.limitCharacters();
		app.util.constrainGiftMessage();
		if (initialized) {return; }
		$cache.dialog.on("click", ".preview-button, .send-button, .edit-button", function (e) {
			e.preventDefault();
			$cache.form.validate();
			if (!$cache.form.valid()) {
				return false;
			}
			var requestType = $cache.form.find("#request-type");
			if (requestType.length>0) {
				requestType.remove();
			}
			$("<input/>").attr({id:"request-type", type:"hidden", name:$(this).attr("name"), value:$(this).attr("value")}).appendTo($cache.form);
			var data = $cache.form.serialize();
			app.ajax.load({url:$cache.form.attr("action"),
				   data: data,
				   target: $cache.dialog,
				   callback: function() {
						app.validator.init();
						app.util.limitCharacters();
						app.util.constrainGiftMessage();
						$cache.form = $("#send-to-friend-form");
						$(".ui-dialog-content").dialog("option", "position", "center");
				   }
			});
		})
		.on("click", ".cancel-button, .close-button", function (e) {
			e.preventDefault();
			$cache.dialog.dialog("close");
		});
		initialized=true;
	}

	/*************** app.sendToFriend public object ***************/
	app.sendToFriend = {
		init : function () {
			$cache = {
				form: $("#send-to-friend-form"),
				dialog: $("#send-to-friend-dialog"),
				pdpForm: $("form.pdpForm")
			};
			initializeEvents();
		},

		/**
		 * @function
		 * @description
		 */
		initializeDialog : function (eventDelegate, eventTarget) {
			$(eventDelegate).on("click", eventTarget, function (e) {
				e.preventDefault();
				var dlg = app.dialog.create({target:$("#send-to-friend-dialog"), options:{
					width:800,
					height:'auto',
					title:this.title,
					open:function() {
						app.sendToFriend.init();
						app.validator.init();
					}
				}});

				var data = app.util.getQueryStringParams($("form.pdpForm").serialize());
				if (data.cartAction) {
					delete data.cartAction;
				}
				var url = app.util.appendParamsToUrl(this.href, data);
				url = this.protocol + "//" + this.hostname + ((url.charAt(0)==="/") ? url : ("/"+url));
				app.ajax.load({
					url:app.util.ajaxUrl(url),
					target:dlg,
					callback: function () {
						dlg.dialog("open");	 // open after load to ensure dialog is centered
					}
				});
			});
		}
	};

}(window.app = window.app || {}, jQuery));

function ruptureMerch(grid){
	var nbCol;
	var productListContainer;

	$(document).on("click",".wrapper-btn-changegrid .btn-changegrid",function() {
		nbCol = parseInt($(this).val());
		var newGridClass = $(this).attr('data-grid-class');
		$(".grid-tile-rupture").length;

		//get ul container that correpsond to page in infinite scroll
		productListContainer = $(".search-result-items");
		//calculate the rupture position for each pages
		productListContainer.each(function() {
			positionRupMerch(this);
		});

		$("#main").removeClass("result-grid-four result-grid-six result-grid-two result-grid-one").addClass(newGridClass);
		$(this).addClass('selected').siblings().removeClass('selected');

		// Save the selected grid in a cookie for use later
		var currentGrid = $.cookie('gridSelected');
		if (currentGrid != nbCol) {
			$.cookie('gridSelected', nbCol, { expires: 1, path: '/' });
		}
	});

	if(!$(".grid-tile-rupture").length > 0){
		return;
	}

	//get ul containers that corepsond to pages in infinite scroll
	var productListContainer = $(".search-result-items");

	if($('#main').hasClass('result-grid-one') && nbCol != 1){
		nbCol = 1;
		//calculate the rupture position for each pages
		productListContainer.each(function() {
			positionRupMerch(this);
		});
		return
	} else if($('#main').hasClass('result-grid-two') && nbCol != 2){
		nbCol = 2;
		//calculate the rupture position for each pages
		productListContainer.each(function() {
			positionRupMerch(this);
		});
		return;
	} else if($('#main').hasClass('result-grid-four') && nbCol != 4){
		nbCol = 4;
		//calculate the rupture position for each pages
		productListContainer.each(function() {
			positionRupMerch(this);
		});
		return;
	} else if($('#main').hasClass('result-grid-six') && nbCol != 6){
		nbCol = 6;
		//calculate the rupture position for each pages
		productListContainer.each(function() {
			positionRupMerch(this);
		});
		return;
	} else {
		var currentActivatedGrid = parseInt($('.wrapper-btn-changegrid .btn-changegrid.selected:visible').val());
		if (currentActivatedGrid > 0) {
			nbCol = currentActivatedGrid;
		} else {
			// default layout
			nbCol = 4;
		}

		//calculate the rupture position for each pages
		productListContainer.each(function() {
			positionRupMerch(this);
		});
		return;
	}

	function positionRupMerch(productListContainer) {
		var tableProd = [];
		listProd = $(productListContainer).find('.grid-tile');

		//on recupere dans un tableau la size de chaques produits
		listProd.each(function() {
			var size = $(this).data("sizerupture");

			if(typeof size === "undefined"){
				tableProd.push(1);
			} else {
				tableProd.push(size);
			}
		});

		//Function load video vimeo, youtube, JWplayer
		function loadvideo(i, newSize, src, imageVid){
			var youtube = listProd.eq(i).find(".rupture-iframe-youtube").length;
			var vimeo = listProd.eq(i).find(".rupture-iframe-vimeo").length;
			var jwp = listProd.eq(i).find(".rupture-jw-player").length;

			if(jwp > 0){
				var containerJW = listProd.eq(i).find(".video-jw-player");
				containerJW.attr("id","video" + i);
				var playerInstance = jwplayer("video" + i);
				var newName = "video" + i;
				var calculRatio;

				//On calcul le ratio de la video pour le responsive
				(function() {
					if(newSize == 1){
						calculRatio = "16:21.31";
					}else if(newSize == 2){
						calculRatio = "16:10.15";
					}else if(newSize == 3){
						calculRatio = "16:6.67";
					}else if(newSize == 4){
						calculRatio = "16:4.97";
					}
				})();

				if (windowW >= 768){
					playerInstance.setup({
						file: src,
						mute: true,
						width: "100%",
						aspectratio: calculRatio,
						repeat:true,
						autostart:true,
						controls: false,
						image: imageVid
					});
				} else {
					playerInstance.setup({
						file: src,
						mute: true,
						width: "100%",
						aspectratio: calculRatio,
						repeat:true,
						autostart:true,
						controls: true,
						image: imageVid
					});
				}

				playerInstance.play();
			}else if(vimeo > 0){
				listProd.eq(i).find("iframe").attr("src", "//player.vimeo.com/video/"+ src);
			}else if(youtube > 0){
				listProd.eq(i).find("iframe").attr("src", "https://www.youtube.com/embed/"+ src +"?enablejsapi=1&autoplay=1&loop=1&playlist="+ tableAllVid[newSize-1]);
			}
		}

		//Suppression des class rupture-merch et les réattribuer, utile pour le responsive
		listProd.removeClass("rupture-merch-hide rupture-merch-1 rupture-merch-2 rupture-merch-3 rupture-merch-4");

		var createLine = 0; //Nombre de size
		var limitLine = nbCol; //La limit qui détermine si on créer une autre ligne
		var dispoCol = nbCol; //Le nombre de place disponible sur la ligne qui est au depart egale a la limite d'une ligne

		//Analyse de chaque produit dans une boucle for
		for(var i = 0; i < listProd.length; i++){
			//Calcul de la place disponible sur la ligne
			var sizeLastProd = tableProd[i];
			createLine = createLine + tableProd[i];

			if (listProd.eq(i).hasClass("grid-tile-rupture")){
				//Si c'est une rupture de Merch on recupere les data image, video et href
				var newSize;
				var allImg = listProd.eq(i).find(".product-tile").data("image");
				var allVid = listProd.eq(i).find(".product-tile").data("video");
				var isFreeHtml = listProd.eq(i).find(".html-slot-container").length > 0;

				var tableAllImg = allImg != null ? [allImg.img1, allImg.img2, allImg.img3, allImg.img4] : '';
				var tableAllVid = allVid != null ? [allVid.vid1, allVid.vid2, allVid.vid3, allVid.vid4] : '';

				if(allImg === undefined && allVid === undefined && !isFreeHtml){
					listProd.eq(i).addClass("rupture-merch-hide");
					createLine = createLine - tableProd[i];
					sizeLastProd = 0;
				}

				var typeRupture; //image, photo, null
				var theSrc;

				// Regarde si il y a assez d'espace sur la ligne pour placer la rupture de merch
				// Si ce n'est pas le cas on lui donne la taille maximal disponible
				if(createLine > limitLine){
					newSize = dispoCol;
				} else {
					newSize = sizeLastProd;
				}
				// Check si la source de la taille attendu est disponible,
				// Sinon on prend la meilleur source possible adaptée a la place disponible (video priorisée sur la photo)
				var calculSrc = function(tableAllImg, tableAllVid, size) {
					if (!isFreeHtml) {
						for(var r = size; r >= 1; r--){
							var n = r-1;
							if(tableAllVid[n] !== "" && tableAllVid[n] !== undefined && window.innerWidth > 1024){
								newSize = r;
								theSrc = tableAllVid[n];
								typeRupture = "video";
								break;
							} else if (tableAllImg[n] !== "" && tableAllImg[n] !== undefined){
								newSize = r;
								theSrc = tableAllImg[n];
								typeRupture = "image";
								break;
							} else if (r < 1){
								theSrc = null;
								typeRupture = null;
								newSize = 0;
								break;
							}
						}
					} else {
						typeRupture = "freehtml";
						newSize = 1;
					}
				}

				//Recupere la source, le type video ou image et sa nouvelle taille si modification
				calculSrc(tableAllImg, tableAllVid, newSize);

				if(typeRupture === "video"){ //Si c'est une video
					//On cache le block image et affiche le block video
					if(listProd.eq(i).find(".rupture-video").length > 0){
						listProd.eq(i).find(".rupture-video").show();
						listProd.eq(i).find(".product-image img").hide();
						listProd.eq(i).find(".product-image a").addClass("video-link");
					}
					//On lui attribut la taille calculée
					listProd.eq(i).addClass("rupture-merch-" + newSize);
					//On change la source de la video via la function loadvideo()
					loadvideo(i, newSize, theSrc, tableAllImg[newSize-1]);
				}else if(typeRupture === "image"){ //Si c'est une image
					//On cache le block video et affiche le block photo
					if(listProd.eq(i).find(".rupture-video").length > 0){
						listProd.eq(i).find(".rupture-video").hide();
						listProd.eq(i).find(".product-image img").show();
						listProd.eq(i).find(".product-image a").removeClass("video-link");
					}
					//On change la source de l'image
					if(listProd.eq(i).find(".product-image img").length > 0){
						listProd.eq(i).find(".product-image img").attr("src", theSrc);
					} else {
						if (listProd.eq(i).find(".product-image > a").length > 0){
							listProd.eq(i).find(".product-image > a").html("<img src='" + theSrc + "'/>");
						} else {
							listProd.eq(i).find(".product-image").prepend("<img src='" + theSrc + "'/>");
						}
					}
					//On lui attribut la taille calculée
					listProd.eq(i).addClass("rupture-merch-" + newSize);
				}else if(typeRupture === "freehtml") {
					listProd.eq(i).addClass("rupture-merch-" + newSize);
				}else if(typeRupture === null){
					//Si ce n'est ni une image ni une video c'est que il n'y a pas d'image ou de video de la taille attendu
					//On le cache
					listProd.eq(i).addClass("rupture-merch-hide");
				}

				//On recalcul le nombre d'élément sur la ligne
				//On créer une ligne si besoin
				createLine = createLine - sizeLastProd + newSize;
				if(createLine == limitLine){
					limitLine = limitLine + nbCol;
				}

				//On calcul la place disponible sur la ligne pour le prochain produit
				dispoCol = limitLine-createLine;
			} else if(createLine == limitLine){ //Si il n'y a plus de place sur la ligne on en créer une nouvelle
				limitLine = limitLine + nbCol;
				//On calcul la place disponible sur la ligne pour le prochain produit
				dispoCol = limitLine-createLine;
			} else if(createLine < limitLine){ //Si il reste de la place sur la ligne on calcul la place disponible
				//On calcul la place disponible sur la ligne pour le prochain produit
				dispoCol = limitLine-createLine;
			}
		}
	}
}


/**
 * @class app.search
 */
(function (app, $) {
	var $cache = {};

	/**
	 * @private
	 * @function
	 * @description replaces breadcrumbs, lefthand nav and product listing with ajax and puts a loading indicator over the product listing
	 */
	function updateProductListing(isHashChange, parameterFilter) {
		var hash = window.location.hash;
		if(hash==='#results-content' || hash==='#results-products' || hash.indexOf('#productPosition=') > -1 || hash.indexOf('#rupturePosition=') > -1 ) { return; }

		var refineUrl = null;
		if (hash.length > 0) {
			refineUrl = window.location.pathname+"?"+ hash.substr(1);
		}
		else if (isHashChange) {
			refineUrl = window.location.href;
		}

		if (!refineUrl) { return; }

		var activateFilter = $('.btnFilterNew').hasClass('active');
		app.progress.show($cache.main.find(".search-result-content"));
		$cache.main.load(app.util.appendParamToURL(refineUrl, "format", "ajax"), function () {

			app.product.updateUI();

			app.product.compare.init();
			app.product.tile.init();
			app.progress.hide();
			app.productlistpage.ruptureMerch();
			// Here, we ask the init not to refresh the grid, because when we arrive here, we already requested an up to date grid,
			// and refreshing here makes an unnecessary call
			app.filterCatalog.init(false);

			Sandro.search.bindEvents();

			if (app.clientcache.LISTING_INFINITE_SCROLL){
				jQuery(document).trigger('grid-update');
			}

			if(activateFilter) {
				$('.contentFilter').removeAttr('style').show();
				$('.btnFilterNew').addClass('active');
			}

			var getSelectableValues = function(){
			    var selectableValues = [];

			    $(".refinement .filterContent ul li:not(.unselectable) a[title]").each(function(){
			        selectableValues.push( $(this).attr("title") );
			    });

			    return selectableValues;
			};

			var keepOnlySelectableValues = function(selectableValues, parameters){
			    //this will return a new array, each value being the value returned by the function given as parameter
			    return parameters.map(function(parameter){
			        var splittedParam = parameter.split('=');
			        var paramName = splittedParam[0];
			        var paramValue = splittedParam[1];

			        //leave the parameter untouched if it is not a a prefv or if its value is empty already
			        if(!(paramName.indexOf('prefv') >= 0) || paramValue === ''){
			            return parameter;
			        }

			        //returns a new array from selectableValues, containing the selectableValues that are present in the parameter value
			        var selectableValuesInParamValue = selectableValues.reduce(function(acc, currentValue){
			            if(paramValue.indexOf(encodeURI(currentValue)) >= 0){
			                acc.push(encodeURI(currentValue));
			            }
			            else if(paramValue.indexOf(encodeURIComponent(currentValue)) >= 0){
			                acc.push(encodeURIComponent(currentValue));
			            }
			            return acc;
			        }, []);

			        //if the parameter value contained one or more selectable values, the new parameter value concat them with an urlencoded pipe as separator. Otherwise, the new value is empty.
			        var newParamValue = selectableValuesInParamValue.length > 0 ? selectableValuesInParamValue.join('%7C') : '';

			        //will replace the previous parameter with the cleaned one
			        return [paramName, newParamValue].join('=');

			    });
			};

			var allParameters = window.location.hash.substring(1).split("&");
			var filteredParameters = keepOnlySelectableValues(getSelectableValues(), allParameters);
			var newHash = '#'+ filteredParameters.join('&');

			if(newHash !== window.location.hash){ window.location.hash = newHash;}

			if(parameterFilter === true){
				$(".parameterInStock").val(true);
				$(".linkAvailable.all").removeClass("selected");
				$(this).addClass("selected");
			}else if(parameterFilter === false){
				$(".parameterInStock").val(false);
			}
			if(($(".product-image .vignette.soldout").length == $(".product-swatches .swatch-list li").length) && $(".pagination ul").length == 0){
				$(".refinement .linkAvailable.InStock").css({
					"color": "#dbdbdb",
					"cursor": "default",
					"text-decoration": "none"
				});
			}
		});
	}
	/**
	 * @private
	 * @function
	 * @description
	 */
	function initInfiniteScroll() {
		jQuery(window).bind('scroll',function(e) {
			infiniteScrollEventHandler(e);

			//Update URL in Browser for SEO
			initBrowserUrlUpdater();
		});
		jQuery(document).bind('ready grid-update',function(e) {
			infiniteScrollEventHandler(e);

			//Update URL in Browser for SEO
			initBrowserUrlUpdater();
		});
	}
	
	function initLoadMorePreviousPageLoading() {
		jQuery(window).bind('scroll',function(e) {
			infiniteScrollEventHandler(e, true);
		});
	}

	/**
	 *@private
	 *@function
	 *@description Function to be triggered to handle infinite scroll
	 */
	function infiniteScrollEventHandler(e) {
		// getting the hidden div, which is the placeholder for the next page
		var loadingPlaceHolder = jQuery('.infinite-scroll-placeholder[data-loading-state="unloaded"]');
		if (loadingPlaceHolder.length == 1 && app.util.elementInViewport(loadingPlaceHolder.get(0), 250)) {
			// switch state to 'loading'
			// - switches state, so the above selector is only matching once
			// - shows loading indicator
			loadingPlaceHolder.attr('data-loading-state','loading');
			loadingPlaceHolder.addClass('infinite-scroll-loading');

			// get url hidden in DOM
			var gridUrl = loadingPlaceHolder.attr('data-grid-url');

			// do query via ajax
			jQuery.ajax({
				type: "GET",
				dataType: 'html',
				url: gridUrl,
				success: function(response) {
					// update UI
					loadingPlaceHolder.removeClass('infinite-scroll-loading');
					loadingPlaceHolder.attr('data-loading-state','loaded');
					jQuery('div.search-result-content').append(response);
					app.productlistpage.ruptureMerch();
					jQuery(document).trigger('grid-update');
				}
			});
		}
	}

	//Value needed for initBrowserUrlUpdater()
	var last_scroll = 0;
	/**
	*	initBrowserUrlUpdater()
	*	The purpose of this function is to update the URL bar
	*	in the browser with current url (when using infinite scroll)
	*/
	function initBrowserUrlUpdater() {
		var scrollWrapper = $('body');
		scrollWrapper.scroll(function() {
			// handle scroll events to update content
			var scroll_pos = scrollWrapper.scrollTop();

			// Adjust the URL based on the top item shown
			// for reasonable amounts of items
			if ( Math.abs(scroll_pos - last_scroll) > $(window).height() * 0.1) {
				last_scroll = scroll_pos;
				$(".search-result-items").each(function(index) {
					if ( mostlyVisible(this) ) {
						var urltoupdate = $(this).attr("data-urltoupdate") ? $(this).attr("data-urltoupdate") : null;
						if ( !!urltoupdate ) {
							history.replaceState(null, null, urltoupdate );
						}
						return(false);
					}
				});
			}
		});
	}

	/**
	*mostlyVisible()
	*The purpose of this function is to determine
	*if an element occupies more than 25% of the screen
	*This will allow us to update URL in browser URL bar
	*depending on the search result page element present
	*@params {Object} element
	*/
	function mostlyVisible(element) {
		// if  25% of element is visible
		var scroll_pos = $('body').scrollTop();
		var window_height = $(window).height();
		var el_top = $(element).offset().top;
		var el_height = $(element).height();
		var el_bottom = el_top + el_height;
		return ( ( el_bottom - el_height * 0.25 > scroll_pos) && ( el_top < (scroll_pos + 0.5 * window_height) ) );
	}
	
	/*
	 * This function is called to add the page loaded in a loadmore paging context
	 */
	function fillLoadedPage(response, isPreviousPageLoading) {
		var currentPageFirstTile = $('li.grid-tile')[0];
		var resultElementToUpdate = $('#search-result-items');
		var tileToAppend = $(response).find('#search-result-items li.grid-tile');
		var paginationToAppend = $(response).find('.search-result-content .pagination');
		var scriptToAppend = $(response).filter('script.datalayer');
		var pageUrlToAppend = $(response).find('.page-url');

		if (tileToAppend.length > 0) {
			//reverse the list gotten by the call to display the tiles in the right order
			if (isPreviousPageLoading) {
				tileToAppend = tileToAppend.get().reverse();
			}

			$(tileToAppend).each(function (idx, elm) {
				//add new tiles above old tiles
				if (isPreviousPageLoading) {
					resultElementToUpdate.prepend(elm);
				//add new tiles under old tiles
				} else {
					resultElementToUpdate.append(elm);
				}
			});

			if (isPreviousPageLoading) {
				$(document).scrollTop($(currentPageFirstTile).offset().top - 222);

				//if a previous page is available for the current page loaded, add it to the current page
				var placeHolderToAppend = $(response).find('.infinite-scroll-placeholder.previous-page');
				if (placeHolderToAppend.length > 0) {
					$('.search-result-content').prepend(placeHolderToAppend);
				}
			} else {
				//update the pagination with the call ajax answer
				if (paginationToAppend.length > 0) {
					$('.search-result-content .pagination').replaceWith(paginationToAppend);
				}
			}

			//Add the script calls
			if(scriptToAppend.length > 0) {
				resultElementToUpdate.append(scriptToAppend);
			}

			if (pageUrlToAppend.length > 0) {
				$('.search-result-content').append(pageUrlToAppend);
			}

			app.searchsuggest.changeGrid();
		} else {
			alert("A problem has occured, please try again");
		}
	}


	/**
	 * @private
	 * @function
	 * @description Initializes events for the following elements:<br/>
	 * <p>refinement blocks</p>
	 * <p>updating grid: refinements, pagination, breadcrumb</p>
	 * <p>item click</p>
	 * <p>sorting changes</p>
	 */
	function initializeEvents() {
		var parameterInStock = false;
		// compare checked
		$cache.main.on("click", "input[type='checkbox'].compare-check", function (e) {
			var cb = $(this);
			var tile = cb.closest(".product-tile");

			var func = this.checked ? app.product.compare.addProduct : app.product.compare.removeProduct;
			var itemImg = tile.find("div.product-image a img").first();
			func({
				itemid : tile.data("itemid"),
				uuid : tile[0].id,
				img : itemImg
			});

		});

		// handle toggle refinement blocks
		$cache.main.on("click", ".refinement h3", function (e) {
			$(this)
		 	.toggleClass('expanded')
		 	.siblings('ul').toggle();
		});
		$(document).ready(function(){
			if(($(".product-image .vignette.soldout").length == $(".product-swatches .swatch-list li").length) && $(".pagination ul").length == 0){
				$(".refinement .linkAvailable.InStock").css({
					"color": "#dbdbdb",
					"cursor": "default",
					"text-decoration": "none"
				});
			}
		});
		// handle events for updating grid
		$cache.main.on("click", ".breadcrumb-refinement-value a", function (e) {
			if($(this).parent().hasClass("unselectable")) { return; }
			var catparent = $(this).parents('.category-refinement');
			var folderparent = $(this).parents('.folder-refinement');

			//if the anchor tag is uunderneath a div with the class names & , prevent the double encoding of the url
			//else handle the encoding for the url
			if(catparent.length > 0 || folderparent.length > 0 ){

				return true;
			}else{
				e.preventDefault();
				var link = "";
				if($(this).hasClass("linkAvailable")){
					link = $(this).attr('href');
					link = link.replace("&format=ajax", "");
					if($(this).hasClass("all")){
						if(link.indexOf("&opOnly=false") >= 0){
							link = link.replace("&opOnly=false", "");
						}else{
							link = link.replace("&opOnly=true", "");
							link += "&opOnly=false";
							parameterInStock = false;
						}
					}else{
						if(($(".product-image .vignette.soldout").length == $(".product-swatches .swatch-list li").length) && $(".pagination ul").length == 0){
							return false;
						}
						if(link.indexOf("&opOnly=true") >= 0){
							link = link.replace("&opOnly=true", "");
							parameterInStock = false;
						}else{
							link = link.replace("&opOnly=false", "");
							link = link.replace(/start=([^&]$|[^&]*)/i, "start=0");
							link += "&opOnly=true";
							parameterInStock = true;
						}
					}
				}else{
					link = $(this).attr('href');
					var parameter = "";
					if($(".parameterInStock").val() == "true" && !$(this).hasClass("textDeleteFilter")){
						parameterInStock = true;
						link += "&opOnly=true";
					}
				}
				if(typeof link != 'undefined' && link.length > 0){
					var uri = app.util.getUri(link);
				}else{
					var uri = app.util.getUri(this);
				}

				if( uri != null && uri.query.length > 1 ) {
					window.location.hash = uri.query.substring(1);
				} else if (uri != null) {
					window.location.href = this.href;
				}

				// Scroll to top only if we clicked on a page link
				if ($(this).closest('.pagination').length > 0 && !$(this).hasClass('viewAll')) {
					$('body').animate({scrollTop : 0});
				}
				return false;
			}
		});

		// handle events item click. append params.
		$cache.main.on("click", ".grid-tile .product-tile a:not('#quickviewbutton')", function (e) {
			var a = $(this);
			var hashPosition = '';
			var gridTileElement = a.closest('.grid-tile');

			if (gridTileElement.hasClass('grid-tile-rupture')) {
				var rupturePosition = gridTileElement.data('positionrupture');
				hashPosition = '#rupturePosition=' + rupturePosition;
			} else {
				var productPosition = gridTileElement.find('.product-position').data('product-position');
				hashPosition = '#productPosition=' + productPosition;
			}

			var productPageUrl = location.href + hashPosition;

			history.replaceState(null, null, productPageUrl);
		});

		// handle sorting change
		$cache.main.on("change", ".sort-by select", function (e) {
			var refineUrl = $(this).find('option:selected').val();
			var uri = app.util.getUri(refineUrl);
			var stringParams = uri.query.substr(1);
			var params = app.util.getQueryStringParams(stringParams);
			// If we have a srule parameter in our refinement url (retrieved from the select next to the sort dropdown),
			// which we should here, since this event is explicitly called when an option is selected,
			// add it to the generateUrl of the filters, so that it will generate an url with this sorting rule everytime the filter is changed
			if("srule" in params){
				app.filterCatalog.generateURL.attributes.srule = params.srule;
			}

			app.filterCatalog.generateURL.create();
			window.location.hash = stringParams;
			return false;
		});

		//fetch new element when the number of elements by page is changed
		//from the items-per-page select element or from viewAll <a> element
		function fetchItems(refineUrl){

			if (refineUrl == "INFINITE_SCROLL") {
				jQuery('html').addClass('infinite-scroll');
				jQuery('html').removeClass('disable-infinite-scroll');
			} else {
				jQuery('html').addClass('disable-infinite-scroll');
				jQuery('html').removeClass('infinite-scroll');
				var uri = app.util.getUri(refineUrl);
				window.location.hash = uri.query.substr(1);
			}

		};

		//handle the change event of number of items per page
		$cache.main.on("change", ".items-per-page select", function (e) {

			//get the url and fetch new elements
			var refineUrl = $(this).find('option:selected').val();
			fetchItems(refineUrl);

			return false;
		});

		// handle events "viewall" link in pagination bar
		$cache.main.on("click", ".search-result-options a.viewAll", function(e) {

			//prevent the default behavior of the <a> element
			//this will block the reload of the page from the top
			//then we change the url and load elements by calling the window.location.hash
			e.preventDefault();

			//get the url and fetch new elements
			var refineUrl = $(this).attr('href');
			fetchItems(refineUrl);
			return false;
		});

	
		$cache.main.on("click", ".js-loadmore", function (e) {
			e.preventDefault();
			var url = $(this).attr('href');
			$(this).addClass('loaded');
			app.progress.show();

			// remove expired pagecache
			var cachedList = Object.keys(sessionStorage).filter(function(key){
				return key.indexOf('expired_') > -1;
			}).forEach(function(item){
				var expiredTime = new Date(sessionStorage[item]);
				if (new Date().getTime() > expiredTime.getTime()) { // if date now is superior than the expiration date
					sessionStorage.removeItem(item);
					sessionStorage.removeItem('page-cache_' + url);
				}
			});
			// end remove expired pagecache

			if (sessionStorage["page-cache_" + url]) {
				fillLoadedPage(sessionStorage["page-cache_" + url], false);
				app.progress.hide();
			} else {
				$.ajax({
					url : url,
					type : 'GET',
					success : function(response) {
						fillLoadedPage(response, false);
						app.progress.hide();
						try {
							var expiredTime = new Date();
							expiredTime.setTime(expiredTime.getTime() + (30 * 60 * 1000)); // 30 minutes

							sessionStorage["page-cache_" + url] = response;
							sessionStorage["expired_" + url] = expiredTime;
						}  catch(err) {}
					}
				});
			}
		});
		
		// handle hash change
		$(window).hashchange(function () {
			updateProductListing(true, parameterInStock);
		});

		$('body').on('click tap', '.topPage a', function(e) {
			e.preventDefault();
			$('body, html').animate({scrollTop : 0});
			return false;
		});
	}
	//Manage filters on category with button apply
	app.filterCatalog = {
        generateURL: {
            url: window.location.href.replace(/#.*$/, ""), // current URL removing hash content
            attributes: {filters: {}}, // querystring vars on the current URL
            paginated: false, // if this URL is of a pagination

            // Store (or remove if already present) attributes in object
            toggleAttribute: function(id, value) {
            	// Create the array for this filter type, if it doesn't exist
            	this.attributes.filters[id] = this.attributes.filters[id] || [];

            	// Remove the selected attribute from the filter if it's already there,
            	// for the toggle effect
            	if (this.attributes.filters[id].indexOf(value) != -1) {
            		this.attributes.filters[id].splice(this.attributes.filters[id].indexOf(value), 1);
            		return;
            	}

            	// Add the selected attribute to the filter array
            	this.attributes.filters[id].push(value);
            },

            // Form an URL for the AJAX call using the stocked filter attributes
            create: function() {
            	this.url = this.url.substring(0, this.url.indexOf('?')) + "?" + this.attributesToQueryString();
                if($.cookie('gridSelected')){
                    this.url += "&gridselected=" + $.cookie('gridSelected');
                }

            	// Store filter attributes in the session if it isn't a search
            	if (!("q" in this.attributes)) {
            		sessionStorage.setItem(window.location.pathname, JSON.stringify(this.attributes));
            	}
            },
            // update attributes model from session. If mandatory is true
            // return false if the attributes model is empty
            updateFilters: function(forceUpdate) {
                var filters = app.filterCatalog.getFilters();
                if (!filters || !filters.filters) {
                    return false;
                }

                if (!forceUpdate && !this.checkFilters(filters)) {
                    return false;
                }

                this.fillModel(filters);

                return true;
            },

            checkFilters: function(filters) {
            	filters = filters || this.attributes.filters;
            	for (var key in filters) {
            		if (filters.hasOwnProperty(key) && key != 'opOnly') {
            			if (filters[key].length > 0) {
            				return true;
                        }
                    }
                }

                return false;
            },

            fillModel: function(filters) {
            	for (var key in filters) {
            		if (filters.hasOwnProperty(key)) {
            			this.attributes.filters[key] = filters[key];
                    }
                }
            },

            queryStringToAttributes: function() {
            	var filters = {};
            	if (this.url.indexOf('?') > -1) {
	                var hashes = this.url.slice(this.url.indexOf('?') + 1).split('&');
	                for (var i = 0; i < hashes.length; i++) {
	                	var hash = hashes[i].split('=');
	                    var identifier, index;

	                    // check for filters attributes, adds to attributes if that's not the case
	                    if (hash[0].indexOf('prefn') > -1 ) {
	                    	identifier = 'name';
	                      	index = hash[0].split('prefn').pop();
	                    } else if (hash[0].indexOf('prefv') > -1) {
	                      	identifier = 'values';
	                      	index = hash[0].split('prefv').pop();
	                    } else if (hash[0].indexOf('gridselected') == -1){
	                        this.attributes[hash[0]] = hash[1];
	                    }

	                    // if it's a filter value, add it properly to filters variable
	                    if (index && identifier) {
		                	filters[index] = filters[index] || {name: '', values: []};
		                	filters[index][identifier] = (hash[1].indexOf('|') > -1) ? hash[1].split('|') : hash[1];
	                    }
	                }

	                // populate attributes with the filters, if their information are complete
	                for (var i = 0; i < filters.length; i++) {
	                	if (filters[i].name && filters[i].values.length > 0) {
	                    	this.attributes.filters[filters[i].name] = filters[i].values;
						}
	                }
            	}
            },

            attributesToQueryString: function() {
              	var queryString = [];
              	var i = 0;

              	for (var p in this.attributes) {
               		if (this.attributes.hasOwnProperty(p)) {
               			if (p == 'filters') {
               				for (var f in this.attributes[p]) {
               					var filterValues = this.attributes[p][f].join('|');
               	    			queryString.push(encodeURIComponent('prefn') + i + "=" + encodeURIComponent(f));
               	    			queryString.push(encodeURIComponent('prefv') + i + "=" + encodeURIComponent(filterValues));
               	    			i++;
               	    		}
               	    	} else if (p == 'srule'){
               	    		// Adding a case where we want to regenerate the sorting rule selected when changing the filter
               	    		queryString.push( encodeURIComponent(decodeURIComponent('srule')) + "=" + encodeURIComponent(decodeURIComponent(this.attributes[p])) );
               	    	} else {
               	    		var attrValue = this.attributes[p] ? this.attributes[p].replace('+', ' ') : this.attributes[p];
               	    		queryString.push(encodeURIComponent(decodeURIComponent(p)) + "=" + encodeURIComponent(decodeURIComponent(attrValue)));
               	    	}
               	    }
               	}

               	return queryString.join("&");
            },

            init: function(forceUpdate) {
            	this.queryStringToAttributes();
            	this.updateFilters(forceUpdate);
            	this.paginated = 'sz' in this.attributes;
            }
        },

        filters: {
            getResults: function(link) {
                app.progress.show($("#main").find(".search-result-content"));
                $.ajax({
                    url : app.util.ajaxUrl(link)+"&ajax=1",
                    success : function(response) {
                        // Traitement du retour de la requete ajax
                        $('#main').html(response);

                        app.product.updateUI();

                        app.product.compare.init();
                        app.product.tile.init();
                        app.productlistpage.ruptureMerch();

                        app.filterCatalog.init(false);
                        if ($(".tag-filter ul li").length > 0) {
	                        $(".tag-filter").addClass("active-tag-filter");
	                        $(".outFiltering").click(function(){
	                        	sessionStorage.setItem(window.location.pathname, '{}');
	                            location.reload();
	                        });
                        }
                        picturefill();
                    },
                    error : function() {
                        // TO DO : Traitement d'un eventuel cas d'erreur
                    }
                }).done(function() {
                    app.progress.hide();
                });
            }
        },

        getFilters: function() {
            var filters = {};
            var filters_json = sessionStorage.getItem(window.location.pathname) ? JSON.parse(sessionStorage.getItem(window.location.pathname)) : {};
			var currentCid = this.generateURL.attributes.cgid;
			if (filters_json && filters_json.cgid === currentCid) {
				filters = filters_json.filters;
			} else {
				sessionStorage.setItem(window.location.pathname, '{}');
			}
            return filters;
        },

		init: function(update) {
			this.generateURL.init(update);
			this.initializeDom();
			this.initializeEvents();

			// update only if:
			// variable update == true and current page isn't paginated or
			// variable update is null but there are filters present
			if (update || (!this.generateURL.paginated && update == null && this.generateURL.checkFilters())) {
				this.update();
			}
			app.productlistpage.ruptureMerch();
		},

		update: function() {
	        this.generateURL.create();
	        this.filters.getResults(this.generateURL.url);
		},

        initializeEvents: function() {
        	$(".filterContent li").each(function() {
                $(this).on("click", function() {
                    $(this).toggleClass("selected");
                });
            });

            $(".filterListProduct .stockAttributes, .color").each(function() {
                $(this).on("click", function() {
                    var id = $(this).data("id");
                    var value = $(this).data("value");
                    app.filterCatalog.generateURL.toggleAttribute(id, value);
                    app.filterCatalog.generateURL.attributes.start = 0;
                    app.filterCatalog.generateURL.create();
                    $(document).trigger("plp.filter", [id, value, app.filterCatalog.generateURL.url]);
                    app.filterCatalog.filters.getResults(app.filterCatalog.generateURL.url);
                });
            });

            $(".tag-filter ul li").each(function() {
                $(this).on("click", function() {
                	var target = $(this).text();
                	var filters = app.filterCatalog.generateURL.attributes.filters;
                	var filter = $(this).data('filter');
                	filters[filter] = $.grep(filters[filter], function(elem){
                		return elem != target;
                	});
                	app.filterCatalog.generateURL.attributes.filters = filters;
                	sessionStorage.setItem(window.location.pathname, JSON.stringify(app.filterCatalog.generateURL.attributes));
                	app.filterCatalog.init(true);
                });
            });
        },

        initializeDom: function() {
        	// first empty the list
        	$('.tag-filter ul').empty();

        	// get current filters from session
        	var filters = this.generateURL.attributes.filters;

            // populate with <li> elements filled with the filter values
            var items = [];

            if (filters) {
	            $.each(filters, function(i, item) {
	            	if (i != 'opOnly' && item != '') {
	            		if (item.length > 0) {
	            			$.each(item, function(s, subItem) {
	            				items.push('<li data-filter="' + i + '">' + decodeURIComponent(subItem) + '</li>');
	            			});
	            		} else {
	            			items.push('<li data-filter="' + i + '">' + decodeURIComponent(item) + '</li>');
	            		}
	            	}
	            });
            }

            // if there are tags, show filter tags label and append them to HTML
            if (items.length > 0) {
            	$('.tag-filter').addClass('active-tag-filter');
                $('.tag-filter ul').append(items.join(''));
            }
        }
	}

	function positionRupMerch (productListContainer, nbCol) {
		var tableProd = [];
		var listProd = $(productListContainer).find('.grid-tile');

		//on recupere dans un tableau la size de chaques produits
		listProd.each(function() {
			var size = $(this).data("sizerupture");
			if(typeof size === "undefined"){
				tableProd.push(1);
			} else {
				tableProd.push(size);
			}
		});

		//Function load video vimeo, youtube, JWplayer
		function loadvideo(i, newSize, src, imageVid){
			var youtube = listProd.eq(i).find(".rupture-iframe-youtube").length;
			var vimeo = listProd.eq(i).find(".rupture-iframe-vimeo").length;
			var jwp = listProd.eq(i).find(".rupture-jw-player").length;

			var videocontrol = listProd.eq(i).find('.rupture-video').data('videocontrol');
			var videoautoplay = listProd.eq(i).find('.rupture-video').data('videoautoplay');

			if(videocontrol){
				videocontrol = parseInt(videocontrol, 10);
			}

			if(videoautoplay){
				videoautoplay = parseInt(videoautoplay, 10);
			}

			if(jwp > 0){
				var containerJW = listProd.eq(i).find(".video-jw-player");
				containerJW.attr("id","video" + i);
				var playerInstance = jwplayer("video" + i);
				var newName = "video" + i;
				var calculRatio;

				//On calcul le ratio de la video pour le responsive
				(function() {
					if(newSize == 1){
						calculRatio = "16:20.64";
					}else if(newSize == 2){
						calculRatio = "16:10.12";
					}else if(newSize == 3){
						calculRatio = "16:6.75";
					}else if(newSize == 4){
						calculRatio = "16:5.05";
					}
				})();

				if (windowW >= 768){
					playerInstance.setup({
						file: src,
						mute: true,
						width: "100%",
						aspectratio: calculRatio,
						repeat:true,
						controls: false,
						image: imageVid
					});
				} else {
					playerInstance.setup({
						file: src,
						mute: true,
						width: "100%",
						aspectratio: calculRatio,
						repeat:true,
						controls: true,
						image: imageVid
					});
				}

				listProd.eq(i).find("a").on("mouseenter", function() {
					if(jwplayer(newName).getState()!== "PLAYING"){
						jwplayer(newName).play();
					}
				});
			}else if(vimeo > 0){
				listProd.eq(i).find("iframe").attr("src", "//player.vimeo.com/video/"+ src+"?autoplay="+videoautoplay);

				listProd.eq(i).find("a").on("mouseenter", function() {
					listProd.eq(i).find(".rupture-iframe-vimeo iframe").each(function() {
						var player = $f(this);
						player.api('setVolume', 0);
						player.api("play");
					});
				});
			}else if(youtube > 0){
				listProd.eq(i).find("iframe").attr("src", "https://www.youtube.com/embed/"+ src +"?enablejsapi=1&autoplay="+videoautoplay+"&loop=1&controls="+videocontrol+"&playlist="+ tableAllVid[newSize-1]);

				listProd.eq(i).find("a").on("mouseenter", function(){
					listProd.eq(i).find("iframe").each(function() {
						var player;
						player = new YT.Player(this, {
							events: {
								'onReady': onPlayerReady
							}
						});

						function onPlayerReady(event) {
							event.target.mute();
							player.playVideo();
						}
					});
				});
			}
		}

		//Suppression des class rupture-merch et les réattribuer, utile pour le responsive
		listProd.removeClass("rupture-merch-hide rupture-merch-1 rupture-merch-2 rupture-merch-3 rupture-merch-4");

		var createLine = 0;
		var limitLine = nbCol;
		var dispoCol = nbCol; //Le nombre de place disponible sur la ligne qui est au depart egale a la limite d'une ligne

		//Analyse de chaque produit dans une boucle for
		for(var i = 0; i < listProd.length; i++){
			//Calcul de la place disponible sur la ligne
			var sizeLastProd = tableProd[i];
			createLine = createLine + tableProd[i];

			if (listProd.eq(i).hasClass("grid-tile-rupture")){
				//Si c'est une rupture de Merch on recupere les data image, video et href
				var newSize;
				var allImg = listProd.eq(i).find(".product-tile").data("image");
				var allVid = listProd.eq(i).find(".product-tile").data("video");
				var isFreeHtml = listProd.eq(i).find(".html-slot-container").length > 0;

				var tableAllImg = [];
				var tableAllVid = [];

				if(allImg != null){
					tableAllImg = [allImg.img1, allImg.img2, allImg.img3, allImg.img4];
				}
				if(allVid != null){
					tableAllVid = [allVid.vid1, allVid.vid2, allVid.vid3, allVid.vid4];
				}

				if(allImg === undefined && allVid === undefined && !isFreeHtml){
					listProd.eq(i).addClass("rupture-merch-hide");
					createLine = createLine - tableProd[i];
					sizeLastProd = 0;
				}

				var typeRupture; //image, photo, null
				var theSrc;

				// Regarde si il y a assez d'espace sur la ligne pour placer la rupture de merch
				// Si ce n'est pas le cas on lui donne la taille maximal disponible
				if(createLine > limitLine){
					newSize = dispoCol;
				} else {
					newSize = sizeLastProd;
				}

				// Check si la source de la taille attendu est disponible,
				// Sinon on prend la meilleur source possible adaptée a la place disponible (video priorisée sur la photo)
				var calculSrc = function(tableAllImg, tableAllVid, size) {
					if (!isFreeHtml) {
						for(var r = size; r >= 1; r--){
							var n = r-1;
							if(tableAllVid[n] !== "" && tableAllVid[n] !== undefined && window.innerWidth > 1024){
								newSize = r;
								theSrc = tableAllVid[n];
								typeRupture = "video";
								break;
							} else if (tableAllImg[n] !== "" && tableAllImg[n] !== undefined){
								newSize = r;
								theSrc = tableAllImg[n];
								typeRupture = "image";
								break;
							} else if (r < 1){
								theSrc = null;
								typeRupture = null;
								newSize = 0;
								break;
							}
						}
					} else {
						typeRupture = "freehtml";
						newSize = 1;
					}
				}

				//Recupere la source, le type video ou image et sa nouvelle taille si modification
				calculSrc(tableAllImg, tableAllVid, newSize);

				if(typeRupture === "video"){ //Si c'est une video
					//On cache le block image et affiche le block video
					if(listProd.eq(i).find(".rupture-video").length > 0){
						listProd.eq(i).find(".rupture-video").show();
						listProd.eq(i).find(".product-image img").hide();
						listProd.eq(i).find(".product-image a").addClass("video-link");
					}
					//On lui attribut la taille calculée
					listProd.eq(i).addClass("rupture-merch-" + newSize);
					//On change la source de la video via la function loadvideo()
					loadvideo(i, newSize, theSrc, tableAllImg[newSize-1]);
				}else if(typeRupture === "image"){ //Si c'est une image
					//On cache le block video et affiche le block photo
					if(listProd.eq(i).find(".rupture-video").length > 0){
						listProd.eq(i).find(".rupture-video").hide();
						listProd.eq(i).find(".product-image img").show();
						listProd.eq(i).find(".product-image a").removeClass("video-link");
					}
					//On change la source de l'image
					if(listProd.eq(i).find(".product-image img").length > 0){
						listProd.eq(i).find(".product-image img").attr("src", theSrc);
					} else {
						if (listProd.eq(i).find(".product-image > a").length > 0){
							listProd.eq(i).find(".product-image > a").html("<img src='" + theSrc + "'/>");
						} else {
							listProd.eq(i).find(".product-image").prepend("<img src='" + theSrc + "'/>");
						}
					}
					//On lui attribut la taille calculée
					listProd.eq(i).addClass("rupture-merch-" + newSize);
				}else if(typeRupture === "freehtml") {
					listProd.eq(i).addClass("rupture-merch-" + newSize);
				}else if(typeRupture === null){
					//Si ce n'est ni une image ni une video c'est que il n'y a pas d'image ou de video de la taille attendu
					//On le cache
					listProd.eq(i).addClass("rupture-merch-hide");
				}

				//On recalcul le nombre d'élément sur la ligne
				//On créer une ligne si besoin
				createLine = createLine - sizeLastProd + newSize;

				if(createLine == limitLine){
					limitLine = limitLine + nbCol;
				}

				//On calcul la place disponible sur la ligne pour le prochain produit
				dispoCol = limitLine-createLine;
			} else if(createLine == limitLine){ //Si il n'y a plus de place sur la ligne on en créer une nouvelle
				limitLine = limitLine + nbCol;
				//On calcul la place disponible sur la ligne pour le prochain produit
				dispoCol = limitLine-createLine;
			} else if(createLine < limitLine){ //Si il reste de la place sur la ligne on calcul la place disponible
				//On calcul la place disponible sur la ligne pour le prochain produit
				dispoCol = limitLine-createLine;
			}
		}
	}

	/***** app.productlistpage public object *****/
	app.productlistpage = {
		ruptureMerch : function() {
			if(!$(".grid-tile-rupture").length > 0){
				return;
			}

			var nbCol;

			//get ul container that corespond to page in infinite scroll
			var productListContainer = $(".search-result-items");

			//calcul du nombre de colonne en fonction de la largeur de l'écran
			if ($('.search-result-items').hasClass('item-grid-one') && nbCol != 1) {
				nbCol = 1;

				//calculate the rupture position for each pages
				productListContainer.each(function() {
					positionRupMerch(this, nbCol);
				});
				return;
			} else if ($('.search-result-items').hasClass('item-grid-two') && nbCol != 2) {
				nbCol = 2;

				//calculate the rupture position for each pages
				productListContainer.each(function() {
					positionRupMerch(this, nbCol);
				});
				return;
			} else if ($('.search-result-items').hasClass('item-grid-four') && nbCol != 4) {
				nbCol = 4;

				//calculate the rupture position for each pages
				productListContainer.each(function() {
					positionRupMerch(this, nbCol);
				});
				return;
			}
		}
	}

	/******* app.search public object ********/
	app.search = {
		init : function () {
			$cache = {
				main : $("#main"),
				items : $(".search-result-content #search-result-items li")
			};
			$cache.content = $cache.main.find(".search-result-content");
			//if (app.product.compare) {
				app.product.compare.init();
			//}
				
			updateProductListing(false, false);
			
			var isInfiniteScrollContext = app.clientcache.LISTING_INFINITE_SCROLL;

			if (isInfiniteScrollContext) {
				initInfiniteScroll();
			} else {
				initLoadMorePreviousPageLoading();
			}
			
			
			/*if (app.clientcache.LISTING_LOAD_MORE){
				initBrowserUrlUpdater();
			} else if (app.clientcache.LISTING_INFINITE_SCROLL){
				initInfiniteScroll();
			}*/
			
			app.product.tile.init();
			initializeEvents();
			
			var hash = encodeURI(decodeURIComponent(window.location.hash));
			var isFocusProduct = hash.indexOf('productPosition') > -1;
			var isFocusRupture = hash.indexOf('rupturePosition') > -1;

			if (isFocusProduct || isFocusRupture) {
				var hashKeyToTreat = isFocusProduct ? 'productPosition' : 'rupturePosition';
				var tilePosition = hash.substr(hash.indexOf(hashKeyToTreat) + 16);

				history.scrollRestoration = 'manual';
				app.progress.show();

				var t = setInterval(function() {
					var targetTile = $('[data-product-position='+tilePosition+']').parent();
					if (targetTile.length) {
						$('html, body').animate({
							scrollTop: targetTile.offset().top - 180
						}, 50);
						clearInterval(t);
					} else {
						$('.js-loadmore:not(.loaded)').trigger('click');
					}
				}, 300);

				app.progress.hide();
				history.replaceState('', document.title, window.location.pathname + window.location.search);
			}

			if($cache.items.length > 0){
				app.productlistpage.ruptureMerch();
				app.filterCatalog.init();
			}
		}
	};

}(window.app = window.app || {}, jQuery));
/**
 * @class app.bonusProductsView
 */
(function (app, $) {
	var $cache = {};
	var selectedList = [];
	var maxItems = 1;
	var bliUUID = "";
	/**
	 * @private
	 * @function
	 * description Gets a list of bonus products related to a promoted product
	 */
	function getBonusProducts() {
		var o = {};
		o.bonusproducts = [];

		var i, len;
		for (i=0, len=selectedList.length;i<len;i++) {
			var p = { pid : selectedList[i].pid,	qty : selectedList[i].qty, options : {} };
			var a, alen, bp=selectedList[i];
			for (a=0,alen=bp.options.length;a<alen;a++) {
				var opt = bp.options[a];
				p.options = {optionName:opt.name,optionValue:opt.value};
			}
			o.bonusproducts.push({product:p});
		}
		return o;
	}
	/**
	 * @private
	 * @function
	 * @description Updates the summary page with the selected bonus product
	 */
	function updateSummary() {
		if (selectedList.length===0) {
			$cache.bonusProductList.find("li.selected-bonus-item").remove();
		}
		else {
			var ulList = $cache.bonusProductList.find("ul.selected-bonus-items").first();
			var itemTemplate = ulList.children(".selected-item-template").first();
			var i, len;
			for (i=0, len=selectedList.length;i<len;i++) {
				var item = selectedList[i];
				var li = itemTemplate.clone().removeClass("selected-item-template").addClass("selected-bonus-item");
				li.data("uuid", item.uuid).data("pid", item.pid);
				li.find(".item-name").html(item.name);
				li.find(".item-qty").html(item.qty);
				var ulAtts = li.find(".item-attributes");
				var attTemplate = ulAtts.children().first().clone();
				ulAtts.empty();
				var att;
				for (att in item.attributes) {
					var attLi = attTemplate.clone();
					attLi.addClass(att);
					attLi.children(".display-name").html(item.attributes[att].displayName);
					attLi.children(".display-value").html(item.attributes[att].displayValue);
					attLi.appendTo(ulAtts);
				}
				li.appendTo(ulList);
			}
			ulList.children(".selected-bonus-item").show();
		}

		// get remaining item count
		var remain = maxItems - selectedList.length;
		$cache.bonusProductList.find(".bonus-items-available").text(remain);
		if (remain <= 0) {
			$cache.bonusProductList.find("button.button-select-bonus").attr("disabled", "disabled");
		}
		else {
			$cache.bonusProductList.find("button.button-select-bonus").removeAttr("disabled");
		}
	}
	/********* public app.bonusProductsView object *********/
	app.bonusProductsView = {
		/**
		 * @function
		 * @description Initializes the bonus product dialog
		 */
		init : function () {
			$cache = {
				bonusProduct : $("#bonus-product-dialog"),
				resultArea : $("#product-result-area")
			};
		},
		/**
		 * @function
		 * @description Opens the bonus product quick view dialog
		 */
		show : function (url) {
			// add element to cache if it does not already exist
			if(!$cache.bonusProduct) {
				app.bonusProductsView.init();
			}

			// create the dialog
			$cache.bonusProduct = app.dialog.create({
				target : $cache.bonusProduct,
				options : {
					width: 795,
					dialogClass : 'quickview',
					title : app.resources.BONUS_PRODUCTS
				}
			});

			// load the products then show
			app.ajax.load({
				target : $cache.bonusProduct,
				url : url,
				callback : function () {
					$cache.bonusProduct.dialog('open');
					app.bonusProductsView.initializeGrid();
				}
			});

		},
		/**
		 * @function
		 * @description Closes the bonus product quick view dialog
		 */
		close : function () {
			$cache.bonusProduct.dialog('close');
		},
		/**
		 * @function
		 * @description Loads the list of bonus products into quick view dialog
		 */
		loadBonusOption : function () {
			$cache.bonusDiscountContainer = $(".bonus-discount-container");
			if ($cache.bonusDiscountContainer.length===0) { return; }

			app.dialog.create({
				target : $cache.bonusDiscountContainer,
				options : {
					height : 'auto',
					width : 350,
					dialogClass : 'quickview',
					title : app.resources.BONUS_PRODUCT
				}
			});
			$cache.bonusDiscountContainer.dialog('open');

			// add event handlers
			$cache.bonusDiscountContainer.on("click", ".select-bonus-btn", function (e) {
				e.preventDefault();
				var uuid = $cache.bonusDiscountContainer.data("lineitemid");
				var url = app.util.appendParamsToUrl(app.urls.getBonusProducts,
													 {
														bonusDiscountLineItemUUID : uuid,
														source : "bonus"
													 });

				$cache.bonusDiscountContainer.dialog('close');
				app.bonusProductsView.show(url);
			}).on("click", ".no-bonus-btn", function (e) {
				$cache.bonusDiscountContainer.dialog('close');
			});
		},

		/**
		 * @function
		 * @description
		 */
		initializeGrid : function () {
			$cache.bonusProductList = $("#bonus-product-list"),
				bliData = $cache.bonusProductList.data("line-item-detail");

			maxItems = bliData.maxItems;
			bliUUID = bliData.uuid;

			if (bliData.itemCount>=maxItems) {
				$cache.bonusProductList.find("button.button-select-bonus").attr("disabled", "disabled");
			}

			var cartItems = $cache.bonusProductList.find(".selected-bonus-item");

			cartItems.each(function() {
				var ci = $(this);

				var product = {
					uuid : ci.data("uuid"),
					pid : ci.data("pid"),
					qty : ci.find(".item-qty").text(),
					name : ci.find(".item-name").html(),
					attributes: {}
				};
				var attributes = ci.find("ul.item-attributes li");
				attributes.each(function(){
					var li = $(this);
					product.attributes[li.data("attributeId")] = {
						displayName:li.children(".display-name").html(),
						displayValue:li.children(".display-value").html()
					};
				});
				selectedList.push(product);
			});


			$cache.bonusProductList.on("click", "div.bonus-product-item a[href].swatchanchor,div.bonus-product-item a[href].swatchanchor_text", function (e) {
				e.preventDefault();

				var anchor = $(this),
					bpItem = anchor.closest(".bonus-product-item"),
					bpForm = bpItem.find("form.bonus-product-form"),
					qty = bpForm.find("input[name='Quantity']").first().val(),
					params = {
						Quantity : isNaN(qty) ? "1" : qty,
						format : "ajax",
						source : "bonus",
						bonusDiscountLineItemUUID : bliUUID
					};

				var url = app.util.appendParamsToUrl(this.href, params);

				app.progress.show(bpItem);
				app.ajax.load({
					url: url,
					callback : function (data) {
						bpItem.html(data);
					}
				});
			})
			.on("click", "button.button-select-bonus", function (e) {
				e.preventDefault();
				if (selectedList.length>=maxItems) {
					$cache.bonusProductList.find("button.button-select-bonus").attr("disabled", "disabled");
					$cache.bonusProductList.find("bonus-items-available").text("0");
					return;
				}

				var form = $(this).closest("form.bonus-product-form"),
					detail = $(this).closest(".product-detail");
					uuid = form.find("input[name='productUUID']").val(),
					qtyVal = form.find("input[name='Quantity']").val(),
					qty = isNaN(qtyVal) ? 1 : (+qtyVal);

				var product = {
					uuid : uuid,
					pid : form.find("input[name='pid']").val(),
					qty : qty,
					name : detail.find(".product-name").text(),
					attributes : detail.find(".product-variations").data("current"),
					options : []
				};

				var optionSelects = form.find("select.product-option");

				optionSelects.each(function (idx) {
					product.options.push({
						name : this.name,
						value : $(this).val(),
						display : $(this).children(":selected").first().html()
					});
				});
				selectedList.push(product);
				updateSummary();
			})
			.on("click", ".remove-link", function(e){
				e.preventDefault();
				var container = $(this).closest("li.selected-bonus-item");
				if (!container.data("uuid")) { return; }

				var uuid = container.data("uuid");
				var i, len = selectedList.length;
				for(i=0;i<len;i++) {
					if (selectedList[i].uuid===uuid) {
						selectedList.splice(i,1);
						break;
					}
				}
				updateSummary();
			})
			.on("click", ".add-to-cart-bonus", function (e) {
				e.preventDefault();
				var url = app.util.appendParamsToUrl(app.urls.addBonusProduct, {bonusDiscountLineItemUUID:bliUUID});
				var bonusProducts = getBonusProducts();
				// make the server call
				$.ajax({
					type : "POST",
					dataType : "json",
					cache	: false,
					contentType : "application/json",
					url : url,
					data : JSON.stringify(bonusProducts)
				})
				.done(function (response) {
					// success
					app.page.refresh();
				})
				.fail(function (xhr, textStatus) {
					// failed
					if(textStatus === "parsererror") {
						window.alert(app.resources.BAD_RESPONSE);
					} else {
						window.alert(app.resources.SERVER_CONNECTION_ERROR);
					}
				})
				.always(function () {
					$cache.bonusProduct.dialog("close");
				});
			});
		}
	};

}(window.app = window.app || {}, jQuery));

/**
 * @class app.giftcert
 * @description Loads gift certificate details
 */
(function (app, $) {
	var $cache;

	function setAddToCartHandler(e) {
		e.preventDefault();
		var form = $(this).closest("form");

		var options = {
			url : app.util.ajaxUrl(form.attr('action')),
			method : 'POST',
			cache: false,
			contentType : 'application/json',
			data : form.serialize()
		};
		var product = $(this).data("product");
		$(document).trigger("pdp.addtocart", [product]);
		$.ajax(options).done(function (response) {
			if( response.success ) {
				app.ajax.load({
					url : app.urls.minicartGC,
					data :{lineItemId : response.result.lineItemId},
					callback : function(response){
						app.minicart.show(response);
						form.find('input,textarea').val('');
					}
				});
			} else {
				form.find('span.error').hide();
				for( id in response.errors.FormErrors ) {
					var error_el = $('#'+id).addClass('error').removeClass('valid').next('.error');
					if( !error_el || error_el.length===0 ) {
						error_el = $('<span for="'+id+'" generated="true" class="error" style=""></span>');
						$('#'+id).after(error_el);
					}
					error_el.text(response.errors.FormErrors[id].replace(/\\'/g,"'")).show();
				}
			}
		}).fail(function (xhr, textStatus) {
			// failed
			if(textStatus === "parsererror") {
				window.alert(app.resources.BAD_RESPONSE);
			} else {
				window.alert(app.resources.SERVER_CONNECTION_ERROR);
			}
		});
	}

	function initializeCache() {
		$cache = {
			addToCart : $("#AddToBasketButton")
		};
	}

	function initializeEvents() {
		$cache.addToCart.on('click', setAddToCartHandler);
	}

	app.giftcert = {
		init : function(){
			initializeCache();
			initializeEvents();
		}
	};
}(window.app = window.app || {}, jQuery));

/**
 * @class app.giftcard
 * @description Loads gift certificate details
 */
(function (app, $) {

	app.giftcard = {
		/**
		 * @function
		 * @description Load details to a given gift certificate
		 * @param {String} id The ID of the gift certificate
		 * @param {Function} callback A function to called
		 */
		checkBalance : function (id, callback) {
			// load gift certificate details
			var url = app.util.appendParamToURL(app.urls.giftCardCheckBalance, "giftCertificateID", id);

			app.ajax.getJson({
				url: url,
				callback: callback
			});
		}
	};
}(window.app = window.app || {}, jQuery));

/**
 * @class app.checkout
 */
(function (app, $) {
	var $cache = {},
		isShipping = false,
		isMultiShipping = false,
		shippingMethods = null,
		previouslySelectedMethod = null,
		incompleteFormData = {}; // Object to save the form data

	/**
	 * @function
	 * @description Helper method which constructs a URL for an AJAX request using the
	 * entered address information as URL request parameters.
	 */
	function getShippingMethodURL(url) {
		var newUrl = app.util.appendParamsToUrl(url,
												{
													countryCode:$cache.countryCode.val(),
												 	stateCode:$cache.stateCode.val(),
												 	postalCode:$cache.postalCode.val(),
												 	city:$cache.city.val()
												 },
												 true);
		return newUrl;
	}

	/**
	 * @function
	 * @description updates the order summary based on a possibly recalculated basket after a shipping promotion has been applied
	 */
	function updateSummary() {
		var url = app.urls.summaryRefreshURL;
		var summary = $("#secondary.summary");
		// indicate progress
		app.progress.show(summary);

		var data = Sandro.cart.refreshCartAmountsData($('div#shipping-form input.input-text.zip').val());

		// load the updated summary area
		summary.load( url, data, function () {
			// hide edit shipping method link
			summary.fadeIn("fast");
			summary.find('.checkout-mini-cart .minishipment .header a').hide();
			summary.find('.order-totals-table .order-shipping .label a').hide();
		});
	}
	/**
	 * @function
	 * @description selects a shipping method for the default shipment and updates the summary section on the right hand side
	 * @param
	 */
	function selectShippingMethod(shippingMethodID) {
		var pickUpShippingMethods = ["777","pointrelais"];
		// nothing entered
		if(!shippingMethodID) {
			return;
		}

		// Every time a user clicks on a new delivery method, save the current values of the form
		// that can be refilled in the callback of the app.ajax.load call further down
		// Only save values for non-hidden fields and only if there is at least one field displayed
		var addressFields = $("[id*='_addressFields_']:not(:hidden)");
		if(addressFields.length > 0) {
			incompleteFormData[previouslySelectedMethod] = {};
			addressFields.each(function(idx, elem){
				incompleteFormData[previouslySelectedMethod][$(elem).attr("id")] = $(elem).val();
			});
		}

		// attempt to set shipping method
		var url = app.util.appendParamsToUrl(app.urls.selectShippingMethodsList,
											 { countryCode:$cache.countryCode.val(),
											   stateCode:$cache.stateCode.val(),
											   postalCode:$cache.postalCode.val(),
											   city:$cache.city.val(),
											   shippingMethodID:shippingMethodID
											 },
											 true);

		 app.ajax.getJson({
			url: url,
			callback: function (data) {
				updateSummary();
				if(!data || !data.shippingMethodID) {
					window.alert("Couldn't select shipping method.");
					return false;
				}
				// display promotion in UI and update the summary section,
				// if some promotions were applied
				$(".shippingpromotions").empty();
				if(data.shippingPriceAdjustments && data.shippingPriceAdjustments.length > 0) {
					var i,len=data.shippingPriceAdjustments.length;
					for(i=0; i<len; i++) {
						var spa = data.shippingPriceAdjustments[i];
					}
				}

				if (previouslySelectedMethod == null || pickUpShippingMethods.indexOf(previouslySelectedMethod ) > -1 || pickUpShippingMethods.indexOf(shippingMethodID) > -1 ) {

					previouslySelectedMethod = shippingMethodID;

					// In-store pickup : load the store selection form or the address form
					app.ajax.load({ url: app.urls.shippingForm
							, target: '.gmap-relay-container'
							, callback: function(data) {

								// re-bind events
								app.checkout.init();
								Sandro.cart.taxesCalculation();

								if (app.constants.CAPADRESSE_ENABLED) {
									csInit();
								}

								if(shippingMethodID ==  "777") {
									setTimeout(function() {
										var settings = {};
										settings.storeUrl = app.urls.getPickupStores;
										settings.featureFilter = false;
										settings.locationSearchLabel = app.resources.FIND_A_STORE_NEAR;
										settings.locationSearchPlaceholder = app.resources.INDICATEPLACE;
										settings.storePickupMode = true;
										settings.geolocateButton = true;
										storeLocator.Store.infoPanelCache_ = {};
										Sandro.storelocator.initCore(settings);
										Sandro.checkout.selectPickupStore();
									}, 0)
									Sandro.checkout.updateMapSize();
									$('div#primary h1.hideindesktop-block').text('1/3 ' + app.resources.CHOOSE_A_STORE);
								} else if( shippingMethodID == "pointrelais" ) {
									$("h1.authenticaded-customer-select-address-title").fadeOut(0);
									Sandro.checkout.contribCrosslog();
								} else {
									$('div#primary h1.hideindesktop-block').text('1/3 ' + app.resources.SHIPPING_ADDRESS);
								}

								// If we have some saved incomplete form data, put it back inside the shipping method form
								if(incompleteFormData[shippingMethodID]) {
									// If there is form data and we find the "new address" link, it means we need to display the form before filling data in
									var newAddressLink = $("a.shipping-address-add");
									if(newAddressLink.length > 0) {
										newAddressLink.click();
									}
									$.each(incompleteFormData[shippingMethodID], function(idx, elem){
										$("[id='"+idx+"']").val(elem);
										// If we set a country, trigger change in order to make the postalcode enabled
										// A disabled field would be ignored by the validation and allow a submit with an empty postal code
										if(/_country/.test(idx)) {
											$("[id='"+idx+"']").change();
										}
									});
									// Once data is restored, delete the saved entry
									delete incompleteFormData[shippingMethodID];
								}
							}
					});
				}
			}
		});
	}

	/**
	 * @function
	 * @description Make an AJAX request to the server to retrieve the list of applicable shipping methods
	 * based on the merchandise in the cart and the currently entered shipping address
	 * (the address may be only partially entered).  If the list of applicable shipping methods
	 * has changed because new address information has been entered, then issue another AJAX
	 * request which updates the currently selected shipping method (if needed) and also updates
	 * the UI.
	 */
	function updateShippingMethodList() {
		if (!$cache.shippingMethodList || $cache.shippingMethodList.length === 0) { return; }
		var url = getShippingMethodURL(app.urls.shippingMethodsJSON);

		 app.ajax.getJson({
			url: url,
			callback: function (data) {
				if(!data) {
					window.alert("Couldn't get list of applicable shipping methods.");
					return false;
				}

				if (previouslySelectedMethod == null) {
					previouslySelectedMethod = $cache.shippingMethodList.find("[name$='_shippingMethodID']:checked").val();
				}

				// We need to update the UI.  The list has changed.
				// Cache the array of returned shipping methods.
				shippingMethods = data;

				var smlUrl = getShippingMethodURL(app.urls.shippingMethodsList);

				// indicate progress
				app.progress.show($cache.shippingMethodList);

				// load the shipping method form
				$cache.shippingMethodList.load( smlUrl, function () {
					$cache.shippingMethodList.fadeIn("fast");
					// rebind the radio buttons onclick function to a handler.
					$cache.shippingMethodList.find("[name$='_shippingMethodID']").click(function () {
						selectShippingMethod($(this).val());
					});

					// update the summary
					updateSummary();
					app.progress.hide();
					app.tooltips.init();
				});
			}
		});
	}

	//shipping page logic
	//checkout gift message counter
	/**
	 * @function
	 * @description Initializes gift message box, if shipment is gift
	 */
	function initGiftMessageBox() {
		// show gift message box, if shipment is gift
		$cache.checkoutForm.find(".gift-option-panel").toggle($cache.checkoutForm.find("[id$='_isGift_true']:checked").length > 0);

	}
	/**
	 * @function
	 * @description Initializes gift message box for multiship shipping, the message box starts off as hidden and this will display it if the radio button is checked to yes, also added event handler to listen for when a radio button is pressed to display the message box
	 */
	function initMultiGiftMessageBox() {
		$.each( $("table.item-list"), function(){

			//handle initial load
			if($(this).find(".js-isgiftyes").is(':checked')){
				$(this).find(".gift-message-text").css('display','block')
			}

			//set event listeners
			$(this).bind('change', function(){
				if($(this).find(".js-isgiftyes").is(':checked')){
					$(this).find(".gift-message-text").css('display','block');
				}else if($(this).find(".js-isgiftno").is(':checked')){
					$(this).find(".gift-message-text").css('display','none');
				}
			});

		});
	}
	/**
	* @function
	* @description this function inits the form so that uses client side validation before submitting to the server
	*/
	function initmultishipshipaddress() {
	//init the continue button as disabled
		var selectvalue = new Array();
	    $(this).removeClass('error');

	    $("select option:selected").each(function () {
	    	selectvalue.push(this.value)

     	});

	    //if we found a empty value disable the button
	    if(selectvalue.indexOf('') == -1){
	    	$('.formactions button').removeAttr('disabled');
	    }else{
	    	$('.formactions button').attr('disabled','disabled');

	    }

	    //add error classes to selects that don't have an address associated with them  when the button is clicked
	    $('.formactions').bind('click',function(){
	    	$.each( $(".cart-row .shippingaddress select.selectbox"), function(){
	        	if(this.value == ''){
	          		$(this).addClass('error');
	        	}else{
	          		$(this).removeClass('error');
	        	};
	      	});
	    });

	    //add listeners to the selects to enable the continue button
	    $.each( $(".cart-row .shippingaddress select.selectbox"), function(){
	    	$(this).bind('change', function(){
	        	if(this.value == ''){
	          		$('.formactions button').attr('disabled','disabled');
	          		$(this).addClass('error');
	        	}else{
	          		//check to see if any select box has a empty vlaue
	          		var selectvalues = new Array();
	          		$(this).removeClass('error');

	            	$("select option:selected").each(function () {
	              		selectvalues.push(this.value)

	           	 	});

	            	//if we found a empty value disable the button
	            	if(selectvalues.indexOf('') == -1){
	              		$('.formactions button').removeAttr('disabled');
	            	}else{
	              		$('.formactions button').attr('disabled','disabled');

	            	}
	        	}
	      	});

	    });
	}
	/**
	 * @function
	 * @description shows gift message box, if shipment is gift
	 */
	function shippingLoad() {
		$cache.checkoutForm.on("click", "[name$='_isGift']", function (e) {
			$cache.checkoutForm.find(".gift-option-panel").toggle($cache.checkoutForm.find("[id$='_isGift_true']:checked").length > 0);
		})
		.on("change",
			"input[name$='_addressFields_state'], input[name$='_addressFields_city'], input[name$='_addressFields_zip']",
			updateShippingMethodList
		);

		// gift message character limitation
		initGiftMessageBox();
		updateShippingMethodList();
		return null;
	}
	/**
	 * @function
	 * @description Selects the first address from the list of addresses
	 */
	function addressLoad() {
		// select address from list
		$(document).on("change", ".select-address select[id$='_addressList']",function () {
			var inputFilter = $(this).data('inputfilter');
			var selected = $(this).children(":selected").first();
			var data = $(selected).data("address");
			var $form = $(this).closest('form');

			if (!data) { return; }
			var p;
			for (p in data) {

				if($cache[p])
					$cache[p].val('');

				if(p == "salutation"){
					var currentid="";
					switch(data[p]){
						case "2":
							currentid = inputFilter == "shipping" ? "customerms" : "customerms-bill";
						break;
						case "3":
							currentid = inputFilter == "shipping" ? "customermiss" : "customermiss-bill";
						break;
						default:
							currentid = inputFilter == "shipping" ? "customermr" : "customermr-bill";
						break;
					}
					var salutationvalue;
					if (!$cache[p]){
						salutationvalue = 1;
					}else{
						salutationvalue = $cache[p].val();
					}
					var label = $('label[for="'+currentid+'"]');
					$("#"+currentid).attr('checked','checked');
					if ( inputFilter == "shipping" ) {
						$('label[for="customerms"]').removeClass('selected');
						$('label[for="customermiss"]').removeClass('selected');
						$('label[for="customermr"]').removeClass('selected');
					} else {
						$('label[for="customerms-bill"]').removeClass('selected');
						$('label[for="customermiss-bill"]').removeClass('selected');
						$('label[for="customermr-bill"]').removeClass('selected');
					}
					$(label).addClass('selected');

					$('option[value="'+data[p]+'"]').attr('selected','selected');

					if($("#dwfrm_profile_customer_salutation").length > 0){
						$("#dwfrm_profile_customer_salutation").attr('value',salutationvalue);
					}
					if($("#dwfrm_profile_address_salutation").length > 0){
						$("#dwfrm_profile_address_salutation").attr('value',salutationvalue);
					}
					if($("#dwfrm_singleshipping_shippingAddress_addressFields_salutation").length > 0){
						$("#dwfrm_singleshipping_shippingAddress_addressFields_salutation").attr('value',salutationvalue);
					}
					if($("#dwfrm_billing_billingAddress_addressFields_salutation").length > 0){
						$("#dwfrm_billing_billingAddress_addressFields_salutation").attr('value',salutationvalue);
					}
				}

				if ($cache[p] && data[p]) {
					// Prevent billing fields from being filled
					$cache[p].filter('[name*='+inputFilter+']').val(data[p].replace("^","'"));

					//Automatically enable postalCode input when countryCode is not empty and capAddress is enable
					//To be able to submit the address selected in the form with a zip code filled
					if (app.constants.CAPADRESSE_ENABLED && p == "countryCode") {
						$cache['postalCode'].filter('[name*='+inputFilter+']').prop("disabled", false);
					}

					if (p == "countryCode") {
						// refesh city field based on country and set its value
						var cityList = app.countries[data[p]].regions,
							arrHtml = [];
						for (city in cityList) {
							arrHtml.push('<option value="'+city+'">'+cityList[city]+'</option>');
						}
						$form.find("[name$='_city']").html(arrHtml.join('')).val(data.city);
						$form.find("[name$='_country']").data('cityvalue', data.city);
					} else if (p == "city") {
						continue;
					} else if (p == "address2") {
						$form.find("[name$='_address2']").val(data.address2);
					}
				} else {
					if ($cache[p] && !data[p]) {
						$cache[p].val('');
					}
				}
			}


			// hack : we have to show the form in order to make the validation work
			$('#' + inputFilter + 'form').show();
			// re-validate the form
			$('#single-page-' + inputFilter + '-form').validate();
			updateShippingMethodList();
		});

		// update state options in case the country changes
		$cache.countryCode.on("change", function () {
			//app.util.updateStateOptions(this);
			$(window).trigger('checkout.load.provinces',{country: this});
		});
	}

	/**
	 * @function
	 * @description shows gift message box in multiship, and if the page is the multi shipping address page it will call initmultishipshipaddress() to initialize the form
	 */
	function multishippingLoad() {
		initMultiGiftMessageBox();
		if($(".cart-row .shippingaddress select.selectbox").length>0){
			initmultishipshipaddress();
		}
		return null;
	}

	/**
	 * @function
	 * @description Changes the payment method form depending on the passed paymentMethodID
	 * @param {String} paymentMethodID the ID of the payment method, to which the payment method form should be changed to
	 */
	function changePaymentMethod(paymentMethodID) {
		$cache.paymentMethods.removeClass("payment-method-expanded");
		var pmc = $cache.paymentMethods.filter("#PaymentMethod_"+paymentMethodID);
		if (pmc.length===0) {
			pmc = $("#PaymentMethod_Custom");
		}
		pmc.addClass("payment-method-expanded");

		var bmlForm = $cache.checkoutForm.find("#PaymentMethod_BML");
		bmlForm.find("select[name$='_year']").removeClass("required");
		bmlForm.find("select[name$='_month']").removeClass("required");
		bmlForm.find("select[name$='_day']").removeClass("required");
		bmlForm.find("input[name$='_ssn']").removeClass("required");

		if (paymentMethodID==="BML") {
			var yr = bmlForm.find("select[name$='_year']");
			bmlForm.find("select[name$='_year']").addClass("required");
			bmlForm.find("select[name$='_month']").addClass("required");
			bmlForm.find("select[name$='_day']").addClass("required");
			bmlForm.find("input[name$='_ssn']").addClass("required");
		}
		app.validator.init();
	}
	/**
	 * @function
	 * @description Fills the Credit Card form with the passed data-parameter and clears the former cvn input
	 * @param {Object} data The Credit Card data (holder, type, masked number, expiration month/year)
	 */
	function setCCFields(data) {
		$cache.ccOwner.val(data.holder);
		$cache.ccType.val(data.type);
		$cache.ccNum.val(data.maskedNumber);
		$cache.ccMonth.val(data.expirationMonth);
		$cache.ccYear.val(data.expirationYear);
		$cache.ccCcv.val("");

		// remove error messages
		$cache.ccContainer.find(".errormessage")
						  .toggleClass("errormessage")
						  .filter("span").remove();

		$cache.ccContainer.find(".errorlabel").toggleClass("errorlabel");
	}

	/**
	 * @function
	 * @description Updates the credit card form with the attributes of a given card
	 * @param {String} cardID the credit card ID of a given card
	 */
	function populateCreditCardForm(cardID) {
		// load card details
		var url = app.util.appendParamToURL(app.urls.billingSelectCC, "creditCardUUID", cardID);
		 app.ajax.getJson({
			url: url,
			callback: function (data) {
				if(!data) {
					window.alert(app.resources.CC_LOAD_ERROR);
					return false;
				}
				$cache.ccList.data(cardID, data);
				setCCFields(data);
			}
		});
	}

	/**
	 * @function
	 * @description loads billing address, Gift Certificates, Coupon and Payment methods
	 */
	function billingLoad() {
		if( !$cache.paymentMethodId ) return;

		$cache.paymentMethodId.on("click", function () {
			changePaymentMethod($(this).val());
		});

		// get selected payment method from payment method form
		var paymentMethodId = $cache.paymentMethodId.filter(":checked");
		changePaymentMethod(paymentMethodId.length===0 ? "CREDIT_CARD" : paymentMethodId.val());

		// select credit card from list
		$cache.ccList.on("change", function () {
			var cardUUID = $(this).val();
			if(!cardUUID) { return; }
			var ccdata = $cache.ccList.data(cardUUID);
			if (ccdata && ccdata.holder) {
				setCCFields(ccdata);
				return;
			}
			populateCreditCardForm(cardUUID);
		});

		// handle whole form submit (bind click to continue checkout button)
		// append form fields of current payment form to this submit
		// in order to validate the payment method form inputs too

		$cache.save.on('click', function (e) {
			// determine if the order total was paid using gift cert or a promotion
			if ($("#noPaymentNeeded").length > 0 && $(".giftcertpi").length > 0) {
				// as a safety precaution, uncheck any existing payment methods
				$cache.paymentMethodId.filter(":checked").removeAttr("checked");
				// add selected radio button with gift card payment method
				$("<input/>").attr({
									name:$cache.paymentMethodId.first().attr("name"),
									type:"radio",
									checked:"checked",
									value:app.constants.PI_METHOD_GIFT_CERTIFICATE})
							 .appendTo($cache.checkoutForm);
			}

			var tc = $cache.checkoutForm.find("input[name$='bml_termsandconditions']");
			if ($cache.paymentMethodId.filter(":checked").val()==="BML" && !$cache.checkoutForm.find("input[name$='bml_termsandconditions']")[0].checked) {
				alert(app.resources.BML_AGREE_TO_TERMS);
				return false;
			}

		});

		$cache.gcCheckBalance.on("click", function (e) {
			e.preventDefault();
			$cache.gcCode = $cache.gcCode || $cache.checkoutForm.find("input[name$='_giftCertCode']");
			$cache.balance = $cache.balance || $cache.checkoutForm.find("div.balance");
			if ($cache.gcCode.length===0 || $cache.gcCode.val().length===0) {
				var error = $cache.balance.find("span.error");
				if (error.length===0) {
					error = $("<span>").addClass("error").appendTo($cache.balance);
				}
				error.html(app.resources.GIFT_CERT_MISSING);
				return;
			}

			app.giftcard.checkBalance($cache.gcCode.val(), function (data) {
				if(!data || !data.giftCertificate) {
					// error
					var error = $cache.balance.find("span.error");
					if (error.length===0) {
						error = $("<span>").addClass("error").appendTo($cache.balance);
					}
					error.html(app.resources.GIFT_CERT_INVALID);
					return;
				}
				// display details in UI
				$cache.balance.find("span.error").remove();
				var balance = data.giftCertificate.balance;
				$cache.balance.html(app.resources.GIFT_CERT_BALANCE+" "+balance);
			});
		});

		$cache.addCoupon.on("click", function(e){
			e.preventDefault();
			$cache.couponCode = $cache.couponCode || $cache.checkoutForm.find("input[name$='_couponCode']");
			$cache.redemption = $cache.redemption || $cache.checkoutForm.find("div.redemption.coupon");
			var val = $cache.couponCode.val();
			if (val.length===0) {
				var error = $cache.redemption.find("span.error");
				if (error.length===0) {
					error = $("<span>").addClass("error").appendTo($cache.redemption);
				}
				error.html(app.resources.COUPON_CODE_MISSING);
				return;
			}

			var url = app.util.appendParamsToUrl(app.urls.addCoupon, {couponCode:val,format:"ajax"});
			$.getJSON(url, function(data) {
				var fail = false;
				var msg = "";
				if (!data) {
					msg = app.resources.BAD_RESPONSE;
					fail = true;
				}
				else if (!data.success) {
					msg = data.message;
					fail = true;
				}

				dataLayer.push({
					'event':'addPromoCode',
					'promoCode':val,
					'validity':fail ? 'KO' : 'OK',
					'discount':null
				});

				if (fail) {
					var error = $cache.redemption.find("span.error");
					if (error.length===0) {
						$("<span>").addClass("error").appendTo($cache.redemption);
					}
					error.html(msg);
					return;
				}

				$cache.redemption.html(data.message);
			});
		});
	}

	/**
	 * @function
	 * @description Sets a boolean variable (isShipping) to determine the checkout stage
	 */
	function initializeDom() {
		isShipping = $(".checkout-shipping").length > 0;
		isMultiShipping = $(".checkout-multi-shipping").length > 0;
	}

	/**
	 * @function
	 * @description Initializes the cache of the checkout UI
	 */
	function initializeCache() {
		$cache.checkoutForm = $("form.address");
		$cache.addressList = $cache.checkoutForm.find(".select-address select[id$='_addressList']");
		$cache.firstName = $cache.checkoutForm.find("input[name$='_firstName']");
		$cache.lastName = $cache.checkoutForm.find("input[name$='_lastName']");
		$cache.streetNb = $cache.checkoutForm.find("input[name$='_streetNb']");
		$cache.address1 = $cache.checkoutForm.find("input[name$='_address1']");
		$cache.address2 = $cache.checkoutForm.find("textarea[name$='_address2']");
		$cache.city = $cache.checkoutForm.find("input[name$='_city']");
		$cache.postalCode = $cache.checkoutForm.find("input[name$='_zip']");
		$cache.phone = $cache.checkoutForm.find("input[name$='_phone']");
		$cache.countryCode = $cache.checkoutForm.find("select[id$='_country']");
		$cache.stateCode = $cache.checkoutForm.find("select[id$='_state']");
		$cache.qualityCode = $cache.checkoutForm.find("input[id$='_qualityCode']");
		$cache.addToAddressBook = $cache.checkoutForm.find("input[name$='_addToAddressBook']");
		if ($cache.checkoutForm.hasClass("checkout-shipping")) {
			// shipping only
			$cache.useForBilling = $cache.checkoutForm.find("input[name$='_useAsBillingAddress']");
			$cache.giftMessage = $cache.checkoutForm.find(".gift-message-text");
			$cache.shippingMethodList = $("#shipping-method-list");
		}

		if ($cache.checkoutForm.hasClass("checkout-billing")) {
			// billing only
			$cache.email = $cache.checkoutForm.find("input[name$='_emailAddress']");
			$cache.save = $cache.checkoutForm.find("button[name$='_billing_save']");
			$cache.paymentMethods = $cache.checkoutForm.find("div.payment-method");
			$cache.paymentMethodId = $cache.checkoutForm.find("input[name$='_selectedPaymentMethodID']");
			$cache.ccContainer = $("#PaymentMethod_CREDIT_CARD");
			$cache.ccList = $("#creditCardList");
			$cache.ccOwner = $cache.ccContainer.find("input[name$='creditCard_owner']");
			$cache.ccType = $cache.ccContainer.find("select[name$='_type']");
			$cache.ccNum = $cache.ccContainer.find("input[name$='_number']");
			$cache.ccMonth = $cache.ccContainer.find("[name$='_month']");
			$cache.ccYear = $cache.ccContainer.find("[name$='_year']");
			$cache.ccCcv = $cache.ccContainer.find("input[name$='_cvn']");
			$cache.BMLContainer = $("#PaymentMethod_BML");
			$cache.gcCheckBalance = $("#gc-checkbalance");
			$cache.addCoupon = $("#add-coupon");

		}

		$(document).on("click", "#accept-sales-conditions a.modify", function (e) {
			var myWidth,
				inWidth = $(this).data('width');
			if($(window).width() > 767 && inWidth !== undefined) {
				myWidth = inWidth;
			}else{
				myWidth = 310;
			}
			e.preventDefault();
			app.quickView.show({
				url : e.target.href,
				width: myWidth,
				classes: { 'ui-dialog-titlebar-close' : "cgv-close" } // Use a mechanism similar to jqUI 1.12 option "classes"
			});
		})

	}
	/**
	 * @function Initializes the page events depending on the checkout stage (shipping/billing)
	 */
	function initializeEvents() {
		addressLoad();
	}

	/******* app.checkout public object ********/
	app.checkout = {
		init : function () {
			initializeCache();
			initializeDom();
			initializeEvents();
		},
		refreshCache : initializeCache
	};
}(window.app = window.app || {}, jQuery));


/**
 * @class app.quickview
 */
(function (app, $) {
	var $cache = {};
	/**
	 * @function
	 * @description Binds a 'click'-event to the quick view button
	 */
	function bindQvButton() {
		$cache.qvButton.one("click", function (e) {
			e.preventDefault();
			app.quickView.show({
				url : $(this).attr("href"),
				source : "quickview"
			});
		});
	}

	/******* app.quickView public object ********/
	app.quickView = {
		/**
		 * @function
		 * @description
		 */
		initializeButton : function (container, target) {
			// quick view button
			$(container).on("mouseenter", target, function (e) {
				if(!$cache.qvButton) {
					$cache.qvButton = $("<a id='quickviewbutton'/>");
				}
				bindQvButton();
				var link = $(this).children("a:first");
				$cache.qvButton.attr({
					"href" : link.attr("href"),
					"title" : link.attr("title")
				}).appendTo($(this));
			});
		},
		init : function () {
			if(app.quickView.exists()) {
				return $cache.quickView;
			}

			$cache.quickView = $("<div/>").attr("id", "QuickViewDialog").appendTo(document.body);
			return $cache.quickView;
		},
		// show quick view dialog and send request to the server to get the product
		// options.source - source of the dialog i.e. search/cart
		// options.url - product url
		/**
		 * @function
		 * @description
		 */
		show : function (options) {
			var persoWidth = 370;
			if(options.width !== undefined){
				persoWidth = options.width;
			}

			options.target = app.quickView.init();
			options.callback = function () {
				app.product.init();
				app.dialog.create({
					target : $cache.quickView,
					options : {
						height : 'auto',
						width : persoWidth,
						dialogClass : 'quickview primary-content ' + (options.classadd ? options.classadd : ''),
						title : options.title ? options.title : 'Product Quickview' ,
						resizable : false,
						position : { my: "center", at: "top", of: window, offset: "0 10%" },
						open : function () {
							var $quickView = $('#QuickViewDialog');
							app.progress.hide();

							if($quickView.length) {
								var getWidthDialog = $quickView.width(),
									getHeightDialog = $quickView.height();

									$quickView.closest('.quickview').css({
										'width' : getWidthDialog,
										'height' : getHeightDialog,
										'margin-left' : -(getWidthDialog / 2),
										'margin-top' : -(getHeightDialog / 2),
										'top' : '50%',
										'left' : '50%'
									});

									if($quickView.find('.addToFavorite').length && $(window).width() > 980){
										var btFavorite = $quickView.find('.addToFavorite');
										var formAddToCart = $quickView.find('.product-add-to-cart').find('fieldset');
										var bookInStoreCta = $quickView.find('.socloz.btnProductAction');

										if (bookInStoreCta.length) {
											bookInStoreCta.appendTo(formAddToCart);
										}
									}
							}

							if($('.pt_cart').length){
								$quickView.closest('.quickview').css({
									'height' : 'auto'
								});
							}
						}
					}
				});
				$cache.quickView.dialog('open');

				// Add classes to specific jqUI elements, as defined in classes
				if(options.classes !== undefined) {
					for(c in options.classes) {
						$('.'+c).addClass(options.classes[c]);
					}
				}

				$cache.quickView.find('.productlargeimgdata').empty();
				Sandro.product.initSlide();
				Sandro.product.zoomMobile();

				//quickImage
				quickviewMobileCart();
				if ($('.pt_cart').length > 0) {
					$('#QuickViewDialog.ui-dialog-content .addToFavorite').css('display', 'none');
				}
			};
			app.product.get(options);

			return $cache.quickView;
		},
		// close the quick view dialog
		close : function () {
			if($cache.quickView) {
				$cache.quickView.dialog('close').empty();
				return $cache.quickView;
			}
		},
		//insert a confirm page after checkout
		checkoutContinue : function() {
			if ($cache.quickView) {
				var url = app.urls.quickViewConfirm;
				var $quickviewParent = $cache.quickView.parent("[aria-labelledby='ui-dialog-title-QuickViewDialog']");
				var quickBuyConfirmStyle = {
				    "height":"425px",
				    "width":"440px",
				    "top":"50%",
				    "left":"50%",
				    "margin-left":"0",
				    "margin-top":"0",
				    "transform":"translate(-50%,-50%)"
				};

				// finally load the dialog
				app.ajax.load({
					target : $cache.quickView,
					url : url,
					callback : function(){
						if($quickviewParent){
							$quickviewParent.css(quickBuyConfirmStyle);
						}
						$cache.quickView.css("height", "100%");
					}
				});
			}
		},
		goToCart : function(){
			var cartUrl = app.urls.cartShow || "#";
			window.location = cartUrl;
		},
		exists : function () {
			return $cache.quickView && ($cache.quickView.length > 0);
		},
		isActive : function () {
			return $cache.quickView && ($cache.quickView.length > 0) && ($cache.quickView.children.length > 0);
		},
		container : $cache.quickView
	};

}(window.app = window.app || {}, jQuery));

/**
 * @class app.util
 */
(function (app, $) {

	// sub namespace app.util.* contains utility functions
	app.util = {

		/**
		* @function disableChromeAutocomp
		* @description Creates event handlers on field focus and autocomplete creation to set the autocomplete attribute to a value preventing Chrome autocomplete
		*/
		disableChromeAutocomp : function() {
			// Chrome autocomplete workaround
			$(document).on('focus autocompletecreate', "[autocomplete='off'], [autocomplete='disabled'], [autocomplete='false']", function(){
				if(/chrom(e|ium)/.test(navigator.userAgent.toLowerCase())) {
					$(this).attr("autocomplete", "disableOnChrome");
				}
			});
		},

		/**
		 * @function
		 * @description trims a prefix from a given string, this can be used to trim
		 * a certain prefix from DOM element IDs for further processing on the ID
		 */
		trimPrefix : function (str, prefix) {
			return str.substring(prefix.length);
		},

		/**
		 * @var
		 * @description Array of special keys to prevent default behaviour
		 */
		controlKeys : ["8", "13", "46", "45", "36", "35", "38", "37", "40", "39"],

		/**
		 * @function
		 * @description
		 */
		setDialogify : function (e) {
			e.preventDefault();
			var actionSource = $(this),
				dlgAction = $(actionSource).data("dlg-action") || {}, // url, target, isForm
				dlgOptions = $.extend({}, app.dialog.settings, $(actionSource).data("dlg-options") || {});

			dlgOptions.title = dlgOptions.title || $(actionSource).attr("title") || "";

			var url = dlgAction.url // url from data
					  || (dlgAction.isForm ? $(actionSource).closest("form").attr("action") : null) // or url from form action if isForm=true
					  || $(actionSource).attr("href"); // or url from href

			if (!url) { return; }

			var form = jQuery(this).parents('form');
			var method = form.attr("method")||"POST";

			// if this is a content link, update url from Page-Show to Page-Include
			if ($(this).hasClass("attributecontentlink")) {
				var uri = app.util.getUri(url);
				url = app.urls.pageInclude+uri.query;
			}
			if (method && method.toUpperCase() == "POST")
			{
		         var postData = form.serialize() + "&"+ jQuery(this).attr("name") + "=submit";
		    }
			else
			{
		         if (url.indexOf('?') == -1 )
		         {
		          url+='?';
		         }
		         else
		         {
		          url += '&'
		         }
		         url += form.serialize();
		         url = app.util.appendParamToURL(url, jQuery(this).attr('name'), "submit");
			}


			/**
			 * Keeps the value on the password reset input
			 * after the validation
			 */
			var requestPasswordValue;

			if($('#PasswordResetForm').length){

				/*
				 * Backups the value before the content update
				 */
				$(document).ajaxStart(function(){
					requestPasswordValue = $('#PasswordResetForm #email_artefact').val();
				});

				/*
				 * Gets the backup value once the content is updated
				 */
				$(document).ajaxComplete(function(){
					if(typeof requestPasswordValue !== 'undefined'){

						$('#PasswordResetForm #email_artefact').val(requestPasswordValue);

					}
				});
			}

			/**
			 * Password reset had a bug which when the e-mail is invalid
			 * the error message "blinks" and doesn't stay in the page.
			 * This solution will call the AJAX function only when the user
			 * puts a valid e-mail
			 */
			if($('#PasswordResetForm').length && $('#PasswordResetForm').is(':visible')){
				$(document).off('click', '#requestpasswordbtn').on('click', '#requestpasswordbtn', function(){
					var emailField = $('#PasswordResetForm #email_artefact').val();
					if(/^[\w.%+\-]+@[\w.\-]+\.[\w]{2,6}$/.test(emailField)){
						//initAjaxLoad();
						var url = $(actionSource).attr("href") || $(actionSource).closest("form").attr("action");
						var postArrayData = JSON.parse(JSON.stringify($("#PasswordResetForm").serializeArray()));
						
						var postData = {};
						postData[$(this).attr('name')] = $(this).val();
						for(var i =0; i < postArrayData.length;i ++) {
						    var attrObj = {};
						    attrObj[postArrayData[i].name] = postArrayData[i].value;
						    postData = $.extend(postData, attrObj);
						}
						
						postData = $.extend(postData, {'url':url,'form-type': pageContext.type, 'reload' : 0});
						
						$(window).trigger('forgotpassword.triggercaptcha',[postData, function(htmlData) {
							$(".resetPassword").html(htmlData);
						}]);
					} else if (emailField.length === 0) {
						$("span.email-error-message").empty();
						$("span.email-error-message").append($("#PasswordResetForm").data('emailemptyerror'));
					} else {
						$("span.email-error-message").empty();
						$("span.email-error-message").append($("#PasswordResetForm").data('emailerror'));
					}
				});
			} else{
				initAjaxLoad();
			}

			function initAjaxLoad(){
				var dlg = app.dialog.create({target:dlgAction.target, options : dlgOptions});

				app.ajax.load({
					url:$(actionSource).attr("href") || $(actionSource).closest("form").attr("action"),
					target:dlg, callback: function () {
						dlg.dialog("open");	// open after load to ensure dialog is centered
						app.validator.init(); // re-init validator

						// Pre-enter the email into the forgotten password input interface
						if($(actionSource).attr("resetpassword")=='1'){

							var resetemail = $("#dwfrm_login .login-email input.email-input").val();
							$('#dwfrm_requestpassword_email').val(resetemail);
							$('#email_artefact').val(resetemail);

							// Do the same above if the user closes the pop-in and open it again
							$(document).ajaxComplete(function(){
								$('#dwfrm_requestpassword_email').val(resetemail);
								$('#email_artefact').val(resetemail);
							});
						}

					},
					data : !$(actionSource).attr("href") ? postData : null

				});
			}

		},
		/**
		 * @function
		 * @description Appends a character to the left side of a numeric string (normally ' ')
		 * @param {String} str the original string
		 * @param {String} padChar the character which will be appended to the original string
		 * @param {Number} len the length of the end string
		 */
		padLeft : function (str, padChar, len) {
			var digs = len || 10;
			var s = str.toString();
			var dif = digs - s.length;
			while(dif > 0) {
				s = padChar + s;
				dif--;
			}
			return s;
		},

		/**
		 * @function
		 * @description appends the parameter with the given name and value to the given url and returns the changed url
		 * @param {String} url the url to which the parameter will be added
		 * @param {String} name the name of the parameter
		 * @param {String} value the value of the parameter
		 */
		appendParamToURL : function (url, name, value) {
			var c = "?";
			if(url.indexOf(c) !== -1) {
				c = "&";
			}
			return url + c + name + "=" + encodeURIComponent(value);
		},
		/**
		 * @function
		 * @description
		 * @param {String}
		 * @param {String}
		 */
		elementInViewport: function (el, offsetToTop) {
			var top = el.offsetTop,
				left = el.offsetLeft,
				width = el.offsetWidth,
				height = el.offsetHeight;

			while (el.offsetParent) {
				el = el.offsetParent;
				top += el.offsetTop;
				left += el.offsetLeft;
			}

			if (typeof(offsetToTop) != 'undefined') {
				top -= offsetToTop;
			}
			//internet explorer < 9 compatible calculations
			var xOffset = (window.pageXOffset !== undefined) ? window.pageXOffset : (document.documentElement || document.body.parentNode || document.body).scrollLeft;
			var yOffset = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
			var innerWidth = (window.innerWidth !== undefined) ? window.innerWidth : (document.documentElement || document.body).clientWidth;
			var innerHeight = (window.innerHeight !== undefined) ? window.innerHeight : (document.documentElement || document.body).clientHeight;

			var result = (
					top < (yOffset + innerHeight) &&
					left < (xOffset + innerWidth) &&
					(top + height) > yOffset &&
					(left + width) > xOffset
			);
			return result;
		},
		/**
		 * @function
		 * @description appends the parameters to the given url and returns the changed url
		 * @param {String} url the url to which the parameters will be added
		 * @param {String} params a JSON string with the parameters
		 */
		appendParamsToUrl : function (url, params) {
			var uri = app.util.getUri(url),
				includeHash = arguments.length < 3 ? false : arguments[2];

			var qsParams = $.extend(uri.queryParams, params);
			var result = uri.path+"?"+$.param(qsParams);
			if (includeHash) {
				result+=uri.hash;
			}
			if (result.indexOf("http")<0 && result.charAt(0)!=="/") {
				result="/"+result;
			}

			return result;
		},
		/**
		 * @function
		 * @description removes the parameter with the given name from the given url and returns the changed url
		 * @param {String} url the url from which the parameter will be removed
		 * @param {String} name the name of the parameter
		 */
		removeParamFromURL : function (url, parameter) {
			var urlparts = url.split('?');

			if(urlparts.length >= 2) {
				var urlBase = urlparts.shift();
				var queryString = urlparts.join("?");

				var prefix = encodeURIComponent(parameter) + '=';
				var pars = queryString.split(/[&;]/g);
				var i=pars.length;
				while(0 > i--) {
					if(pars[i].lastIndexOf(prefix, 0) !== -1) {
						pars.splice(i, 1);
					}
				}
				url = urlBase + '?' + pars.join('&');
			}
			return url;
		},

		/**
		 * @function
		 * @description Returns the static url for a specific relative path
		 * @param {String} path the relative path
		 */
		staticUrl : function (path) {
			if(!path || $.trim(path).length === 0) {
				return app.urls.staticPath;
			}

			return app.urls.staticPath + (path.charAt(0) === "/" ? path.substr(1) : path );
		},
		/**
		 * @function
		 * @description Appends the parameter 'format=ajax' to a given path
		 * @param {String} path the relative path
		 */
		ajaxUrl : function (path) {
			return app.util.appendParamToURL(path, "format", "ajax");
		},

		/**
		 * @function
		 * @description
		 * @param {String} url
		 */
		toAbsoluteUrl : function (url) {
			if (url.indexOf("http")!==0 && url.charAt(0)!=="/") {
				url = "/"+url;
			}
			return url;
		},
		/**
		 * @function
		 * @description Loads css dynamically from given urls
		 * @param {Array} urls Array of urls from which css will be dynamically loaded.
		 */
		loadDynamicCss : function (urls) {
			var i, len=urls.length;
			for(i=0; i < len; i++) {
				app.util.loadedCssFiles.push(app.util.loadCssFile(urls[i]));
			}
		},

		/**
		 * @function
		 * @description Loads css file dynamically from given url
		 * @param {String} url The url from which css file will be dynamically loaded.
		 */
		loadCssFile : function (url) {
			return $("<link/>").appendTo($("head")).attr({
				type : "text/css",
				rel : "stylesheet"
			}).attr("href", url); // for i.e. <9, href must be added after link has been appended to head
		},
		// array to keep track of the dynamically loaded CSS files
		loadedCssFiles : [],

		/**
		 * @function
		 * @description Removes all css files which were dynamically loaded
		 */
		clearDynamicCss : function () {
			var i = app.util.loadedCssFiles.length;
			while(0 > i--) {
				$(app.util.loadedCssFiles[i]).remove();
			}
			app.util.loadedCssFiles = [];
		},
		/**
		 * @function
		 * @description Extracts all parameters from a given query string into an object
		 * @param {String} qs The query string from which the parameters will be extracted
		 */
		getQueryStringParams : function (qs) {
			if(!qs || qs.length === 0) { return {}; }

			var params = {}, unescapedQS = unescape(qs);
			// Use the String::replace method to iterate over each
			// name-value pair in the string.
			unescapedQS.replace( new RegExp( "([^?=&]+)(=([^&]*))?", "g" ),
						function ( $0, $1, $2, $3 ) {	params[ $1 ] = $3; }
			);
			return params;
		},
		/**
		 * @function
		 * @description Returns an URI-Object from a given element with the following properties:<br/>
		 * <p>protocol</p>
		 * <p>host</p>
		 * <p>hostname</p>
		 * <p>port</p>
		 * <p>path</p>
		 * <p>query</p>
		 * <p>queryParams</p>
		 * <p>hash</p>
		 * <p>url</p>
		 * <p>urlWithQuery</p>
		 * @param {Object} o The HTML-Element
		 */
		getUri : function (o) {
			var a;
			if (o.tagName && $(o).attr("href")) {
				a = o;
			}
			else if (typeof o === "string") {
				a = document.createElement("a");
				a.href = o;
			}
			else {
				return null;
			}

			return {
				protocol : a.protocol, //http:
				host : a.host, //www.myexample.com
				hostname : a.hostname, //www.myexample.com'
				port : a.port, //:80
				path : a.pathname, // /sub1/sub2
				query : a.search, // ?param1=val1&param2=val2
				queryParams : a.search.length > 1 ? app.util.getQueryStringParams(a.search.substr(1)) : {},
				hash : a.hash, // #OU812,5150
				url : a.protocol+ "//" + a.host + a.pathname,
				urlWithQuery : a.protocol+ "//" + a.host + a.port + a.pathname + a.search
			};
		},
		/**
		 * @function
		 * @description Appends a form-element with given arguments to a body-element and submits it
		 * @param {Object} args The arguments which will be attached to the form-element:<br/>
		 * <p>url</p>
		 * <p>fields - an Object containing the query-string parameters</p>
		 */
		postForm : function (args) {
			var form = $("<form>").attr({action:args.url,method:"post"}).appendTo("body");
			var p;
			for (p in args.fields) {
				$("<input>").attr({name:p,value:args.fields[p]}).appendTo(form);
			}
			form.submit();
		},
		/**
		 * @function
		 * @description  Returns a JSON-Structure of a specific key-value pair from a given resource bundle
		 * @param {String} key The key in a given Resource bundle
		 * @param {String} bundleName The resource bundle name
		 * @param {Object} A callback function to be called
		 */
		getMessage : function (key, bundleName, callback) {
			if (!callback || !key || key.length===0) {
				return;
			}
			var params = {key:key};
			if (bundleName && bundleName.length===0) {
				params.bn = bundleName;
			}
			var url = app.util.appendParamsToUrl(app.urls.appResources, params);
			$.getJSON(url, callback);
		},
		/**
		 * @function
		 * @description Updates the states options to a given country
		 * @param {String} countrySelect The selected country
		 */
		updateStateOptions : function(countrySelect) {
			var country = $(countrySelect);
			if (country.length===0 || !app.countries[country.val()]) {
				 return;
			}
			var form = country.closest("form");
			var stateField = country.data("stateField") ? country.data("stateField") : form.find("select[name$='_state']");
			if (stateField.length===0) {
				return;
			}

			var form = country.closest("form");
			var 	c = app.countries[country.val()];
			var	arrHtml = [];
			var	labelSpan = form.find("label[for='"+stateField[0].id+"'] span").not(".required-indicator");

			// set the label text
			labelSpan.html(c.label);

			var s;
			for (s in c.regions) {
				arrHtml.push('<option value="'+s+'">'+c.regions[s]+'</option>');
			}
			// clone the empty option item and add to stateSelect
			var o1 = stateField.children().first().clone();
			stateField.html(arrHtml.join("")).removeAttr("disabled").children().first().before(o1);
			stateField[0].selectedIndex=0;
		},
		/**
		 * @function
		 * @description Updates the number of the remaining character
		 * based on the character limit in a text area
		 */
		limitCharacters : function () {
			$('form').find('textarea[data-character-limit]').each(function(){
				var controlKeys = ["8", "13", "46", "45", "36", "35", "38", "37", "40", "39"];

				var characterLimit = $(this).data("character-limit");
				var charCountHtml = String.format(app.resources.CHAR_LIMIT_MSG,
										'<span class="char-remain-count">'+characterLimit+'</span>',
										'<span class="char-allowed-count">'+characterLimit+'</span>');
				var charCountContainer = $(this).next('div.char-count');
				if (charCountContainer.length===0) {
					charCountContainer = $('<div class="char-count"/>').insertAfter($(this));
				}
				charCountContainer.html(charCountHtml);

				$(this).on("input", function(e) {

					if (e.which && app.util.controlKeys.indexOf(e.which.toString()) < 0) {
						e.preventDefault();
					}

					var txtarea = $(this);

					// Test total number of characters (without \n)
					if(txtarea.val().replace(/[\n\r]+/g, ' ').length >= characterLimit) {
						txtarea.val(txtarea.val().substring(0, characterLimit));
					}

					txtarea.parent().find('div.char-count .char-remain-count').html(characterLimit - txtarea.val().length);
				})

				// trigger the input event so that any existing character data is calculated
				$(this).trigger('input');
			});
		},
		constrainGiftMessage : function(){
			// This Unicode range defines the latin characters
			// var nonLatinChars = new RegExp(/[^\u0000-\u007F\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF]+/g);
			// This regexp to split the input string
			var split60 = new RegExp(/(.{1,60}(\b|$)|^$)/gm);

			// if language == CN -> remove space character in regexp
			if (app.constants.DEFAULTLLANGUAGECODE === 'ZH')
				split60 = new RegExp(/(.{1,60}|^$)/gm);

			// Hold current message, before treatment by the input event
			var giftMsgCache = "";

			// Add line count
			var lineCount = $('.gift-message-area .gift-message-text div.line-count');
			if(lineCount.length === 0) {
				lineCount = $('<div class="line-count">'+String.format(app.resources.LINE_LIMIT_MSG,
						'<span class=line-remain-count>6</span>',
						'<span class=line-allowed-count>6</span>')+'</div>');
				$('.gift-message-area .gift-message-text textarea').after(lineCount);
			}
			lineRemain = $('.line-count .line-remain-count');

			$(document).on("input", ".gift-message-area .gift-message-text textarea[data-line-limit]", function(e) {
				var txtarea = $(this);

				// Remove all non-latin characters
				// if(nonLatinChars.test(txtarea.val())) {
				// 	txtarea.val( txtarea.val().replace(nonLatinChars, '') );
				// }

				// This regexp splits the input string in chunks of, at most, 60 characters,
				// without splitting words (\b) and preserving line endings ($). Also matches empty lines.
				var matches = txtarea.val().match(split60);
				if(matches)
				{
					// If we have less than 6 chunks (1 chunk = 1 line), we join them and put them in the cache
					// Otherwise, we don't change the cache, because we don't want more than 6 lines.
					if(matches.length <= 6) {
						giftMsgCache = matches.slice(0,6).join('\n');
						// Update number of lines
						lineRemain.html(7 - matches.length);
					}

					txtarea.val(giftMsgCache);
				}
			});

			// trigger the input event so that any existing character data is calculated
			$(this).trigger('input');
		},
		/**
		 * @function
		 * @description Binds the onclick-event to a delete button on a given container,
		 * which opens a confirmation box with a given message
		 * @param {String} container The name of element to which the function will be bind
		 * @param {String} message The message the will be shown upon a click
		 */
		setDeleteConfirmation : function(container, message) {
			$(container).on("click", ".delete", function(e){
				return confirm(message);
			});
		},
		/**
		 * @function
		 * @description Scrolls a browser window to a given x point
		 * @param {String} The x coordinate
		 */
		scrollBrowser : function (xLocation) {
			$('html, body').animate({ scrollTop: xLocation }, 500);
		},
		hasContainSpecialCharacter : function(value) {
			var str = value;
			var patt = /(?:0\u20E3|1\u20E3|2\u20E3|3\u20E3|4\u20E3|5\u20E3|6\u20E3|7\u20E3|8\u20E3|9\u20E3|#\u20E3|\*\u20E3|\uD83C(?:\uDDE6\uD83C(?:\uDDE8|\uDDE9|\uDDEA|\uDDEB|\uDDEC|\uDDEE|\uDDF1|\uDDF2|\uDDF4|\uDDF6|\uDDF7|\uDDF8|\uDDF9|\uDDFA|\uDDFC|\uDDFD|\uDDFF)|\uDDE7\uD83C(?:\uDDE6|\uDDE7|\uDDE9|\uDDEA|\uDDEB|\uDDEC|\uDDED|\uDDEE|\uDDEF|\uDDF1|\uDDF2|\uDDF3|\uDDF4|\uDDF6|\uDDF7|\uDDF8|\uDDF9|\uDDFB|\uDDFC|\uDDFE|\uDDFF)|\uDDE8\uD83C(?:\uDDE6|\uDDE8|\uDDE9|\uDDEB|\uDDEC|\uDDED|\uDDEE|\uDDF0|\uDDF1|\uDDF2|\uDDF3|\uDDF4|\uDDF5|\uDDF7|\uDDFA|\uDDFB|\uDDFC|\uDDFD|\uDDFE|\uDDFF)|\uDDE9\uD83C(?:\uDDEA|\uDDEC|\uDDEF|\uDDF0|\uDDF2|\uDDF4|\uDDFF)|\uDDEA\uD83C(?:\uDDE6|\uDDE8|\uDDEA|\uDDEC|\uDDED|\uDDF7|\uDDF8|\uDDF9|\uDDFA)|\uDDEB\uD83C(?:\uDDEE|\uDDEF|\uDDF0|\uDDF2|\uDDF4|\uDDF7)|\uDDEC\uD83C(?:\uDDE6|\uDDE7|\uDDE9|\uDDEA|\uDDEB|\uDDEC|\uDDED|\uDDEE|\uDDF1|\uDDF2|\uDDF3|\uDDF5|\uDDF6|\uDDF7|\uDDF8|\uDDF9|\uDDFA|\uDDFC|\uDDFE)|\uDDED\uD83C(?:\uDDF0|\uDDF2|\uDDF3|\uDDF7|\uDDF9|\uDDFA)|\uDDEE\uD83C(?:\uDDE8|\uDDE9|\uDDEA|\uDDF1|\uDDF2|\uDDF3|\uDDF4|\uDDF6|\uDDF7|\uDDF8|\uDDF9)|\uDDEF\uD83C(?:\uDDEA|\uDDF2|\uDDF4|\uDDF5)|\uDDF0\uD83C(?:\uDDEA|\uDDEC|\uDDED|\uDDEE|\uDDF2|\uDDF3|\uDDF5|\uDDF7|\uDDFC|\uDDFE|\uDDFF)|\uDDF1\uD83C(?:\uDDE6|\uDDE7|\uDDE8|\uDDEE|\uDDF0|\uDDF7|\uDDF8|\uDDF9|\uDDFA|\uDDFB|\uDDFE)|\uDDF2\uD83C(?:\uDDE6|\uDDE8|\uDDE9|\uDDEA|\uDDEB|\uDDEC|\uDDED|\uDDF0|\uDDF1|\uDDF2|\uDDF3|\uDDF4|\uDDF5|\uDDF6|\uDDF7|\uDDF8|\uDDF9|\uDDFA|\uDDFB|\uDDFC|\uDDFD|\uDDFE|\uDDFF)|\uDDF3\uD83C(?:\uDDE6|\uDDE8|\uDDEA|\uDDEB|\uDDEC|\uDDEE|\uDDF1|\uDDF4|\uDDF5|\uDDF7|\uDDFA|\uDDFF)|\uDDF4\uD83C\uDDF2|\uDDF5\uD83C(?:\uDDE6|\uDDEA|\uDDEB|\uDDEC|\uDDED|\uDDF0|\uDDF1|\uDDF2|\uDDF3|\uDDF7|\uDDF8|\uDDF9|\uDDFC|\uDDFE)|\uDDF6\uD83C\uDDE6|\uDDF7\uD83C(?:\uDDEA|\uDDF4|\uDDF8|\uDDFA|\uDDFC)|\uDDF8\uD83C(?:\uDDE6|\uDDE7|\uDDE8|\uDDE9|\uDDEA|\uDDEC|\uDDED|\uDDEE|\uDDEF|\uDDF0|\uDDF1|\uDDF2|\uDDF3|\uDDF4|\uDDF7|\uDDF8|\uDDF9|\uDDFB|\uDDFD|\uDDFE|\uDDFF)|\uDDF9\uD83C(?:\uDDE6|\uDDE8|\uDDE9|\uDDEB|\uDDEC|\uDDED|\uDDEF|\uDDF0|\uDDF1|\uDDF2|\uDDF3|\uDDF4|\uDDF7|\uDDF9|\uDDFB|\uDDFC|\uDDFF)|\uDDFA\uD83C(?:\uDDE6|\uDDEC|\uDDF2|\uDDF8|\uDDFE|\uDDFF)|\uDDFB\uD83C(?:\uDDE6|\uDDE8|\uDDEA|\uDDEC|\uDDEE|\uDDF3|\uDDFA)|\uDDFC\uD83C(?:\uDDEB|\uDDF8)|\uDDFD\uD83C\uDDF0|\uDDFE\uD83C(?:\uDDEA|\uDDF9)|\uDDFF\uD83C(?:\uDDE6|\uDDF2|\uDDFC)))|[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2648-\u2653\u2660\u2663\u2665\u2666\u2668\u267B\u267F\u2692-\u2694\u2696\u2697\u2699\u269B\u269C\u26A0\u26A1\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD79\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED0\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3]|\uD83E[\uDD10-\uDD18\uDD80-\uDD84\uDDC0]/g ;
			if( patt.test( str ) == true ){
			   return true;
			}
			return false;
		}

	};
}(window.app = window.app || {}, jQuery));

/**
 * @class app.page
 */
(function (app, $) {

	app.page = {
		title : "",
		type : "",
		setContext : function (o) {
			$.extend(app.page, o);
		},
		params : app.util.getQueryStringParams(window.location.search.substr(1)),
		trackerData: {},
		redirect : function(newURL) {
			var t=setTimeout("window.location.href='"+newURL+"'",0);
		},
		refresh : function() {
			var t=setTimeout("window.location.assign(window.location.href);",500);

		}
	};
}(window.app = window.app || {}, jQuery));

/**
 * @class app.registry
 */
(function (app, $) {
	var $cache = {};
	/**
	 * @function
	 * @description Loads address details to a given address and fills the "Pre-Event-Shipping" address form
	 * @param {String} addressID The ID of the address to which data will be loaded
	 */
	function populateBeforeAddressForm(addressID) {
		// load address details
		var url = app.urls.giftRegAdd + addressID;
		 app.ajax.getJson({
			url: url,
			callback: function (data) {
				if(!data || !data.address) {
					window.alert(app.resources.REG_ADDR_ERROR);
					return false;
				}
				// fill the form
				$cache.addressBeforeFields.filter("[name$='_addressid']").val(data.address.ID);
				$cache.addressBeforeFields.filter("[name$='_firstname']").val(data.address.firstName);
				$cache.addressBeforeFields.filter("[name$='_lastname']").val(data.address.lastName);
				$cache.addressBeforeFields.filter("[name$='_streetNb']").val(data.address.streetNb);
				$cache.addressBeforeFields.filter("[name$='_address1']").val(data.address.address1);
				$cache.addressBeforeFields.filter("[name$='_address2']").val(data.address.address2);
				$cache.addressBeforeFields.filter("[name$='_city']").val(data.address.city);
				$cache.addressBeforeFields.filter("[name$='_zip']").val(data.address.postalCode);
				$cache.addressBeforeFields.filter("[name$='_state']").val(data.address.stateCode);
				$cache.addressBeforeFields.filter("[name$='_country']").val(data.address.countryCode);
				$cache.addressBeforeFields.filter("[name$='_qualityCode']").val(data.address.addressQualityCode);
				$cache.addressBeforeFields.filter("[name$='_phone']").val(data.address.phone);
				$cache.registryForm.validate().form();
			}
		});
	}

	/**
	 * @function
	 * @description Loads address details to a given address and fills the "Post-Event-Shipping" address form
	 * @param {String} addressID The ID of the address to which data will be loaded
	 */
	function populateAfterAddressForm(addressID) {
		// load address details
		var url = app.urls.giftRegAdd + addressID;
		 app.ajax.getJson({
			url: url,
			callback: function (data) {
				if(!data || !data.address) {
					window.alert(app.resources.REG_ADDR_ERROR);
					return false;
				}
				// fill the form
				$cache.addressAfterFields.filter("[name$='_addressid']").val(data.address.ID);
				$cache.addressAfterFields.filter("[name$='_firstname']").val(data.address.firstName);
				$cache.addressAfterFields.filter("[name$='_lastname']").val(data.address.lastName);
				$cache.addressAfterFields.filter("[name$='_streetNb']").val(data.address.streetNb);
				$cache.addressAfterFields.filter("[name$='_address1']").val(data.address.address1);
				$cache.addressAfterFields.filter("[name$='_address2']").val(data.address.address2);
				$cache.addressAfterFields.filter("[name$='_city']").val(data.address.city);
				$cache.addressAfterFields.filter("[name$='_zip']").val(data.address.postalCode);
				$cache.addressAfterFields.filter("[name$='_state']").val(data.address.stateCode);
				$cache.addressAfterFields.filter("[name$='_country']").val(data.address.countryCode);
				$cache.addressAfterFields.filter("[name$='_qualityCode']").val(data.address.addressQualityCode);
				$cache.addressAfterFields.filter("[name$='_phone']").val(data.address.phone);
				$cache.registryForm.validate().form();
			}
		});
	}
	/**
	 * @function
	 * @description copy pre-event address fields to post-event address fields
	 */
	function copyBeforeAddress() {
		$cache.addressBeforeFields.each(function () {
			var fieldName = $(this).attr("name");
			var afterField = $cache.addressAfterFields.filter("[name='"+fieldName.replace("Before","After")+"']");
			afterField.val($(this).val());
		});
	}

	/**
	 * @function
	 * @description Disables or enables the post-event address fields depending on a given boolean
	 * @param {Boolean} disabled True to disable; False to enables
	 */
	function setAfterAddressDisabled(disabled) {
		if (disabled) {
			$cache.addressAfterFields.attr("disabled", "disabled");
		}
		else {
			$cache.addressAfterFields.removeAttr("disabled");
		}
	}
	/**
	 * @private
	 * @function
	 * @description Cache initialization of the gift registration
	 */
	function initializeCache() {
		$cache = {
			registryForm : $("form[name$='_giftregistry']"),
			registryItemsTable : $("form[name$='_giftregistry_items']"),
			registryTable : $("#registry-results")
		};
		$cache.copyAddress = $cache.registryForm.find("input[name$='_copyAddress']");
		$cache.addressBeforeFields = $cache.registryForm.find("fieldset[name='address-before'] input:not(:checkbox), fieldset[name='address-before'] select");
		$cache.addressAfterFields = $cache.registryForm.find("fieldset[name='address-after'] input:not(:checkbox), fieldset[name='address-after'] select");
	}
	/**
	 * @private
	 * @function
	 * @description DOM-Object initialization of the gift registration
	 */
	function initializeDom() {
		$cache.addressBeforeFields.filter("[name$='_country']").data("stateField", $cache.addressBeforeFields.filter("[name$='_state']"));
		$cache.addressAfterFields.filter("[name$='_country']").data("stateField", $cache.addressAfterFields.filter("[name$='_state']"));

		if ($cache.copyAddress.length && $cache.copyAddress[0].checked) {
			// fill the address after fields
			copyBeforeAddress();
			setAfterAddressDisabled(true);
		}
	}
	/**
	 * @private
	 * @function
	 * @description Initializes events for the gift registration
	 */
	function initializeEvents() {
		app.sendToFriend.initializeDialog("div.list-table-header", ".send-to-friend");
		app.util.setDeleteConfirmation("table.item-list", String.format(app.resources.CONFIRM_DELETE, app.resources.TITLE_GIFTREGISTRY));

		$cache.copyAddress.on("click", function () {
			if (this.checked) {
				// fill the address after fields
				copyBeforeAddress();
			}
		});
		$cache.registryForm.on("change", "select[name$='_addressBeforeList']", function (e) {
			var addressID = $(this).val();
			if (addressID.length===0) { return; }
			populateBeforeAddressForm(addressID);
			if ($cache.copyAddress[0].checked) {
				copyBeforeAddress();
			}
		})
		.on("change", "select[name$='_addressAfterList']", function (e) {
			var addressID = $(this).val();
			if (addressID.length===0) { return; }
			populateAfterAddressForm(addressID);
		})
		.on("change", $cache.addressBeforeFields.filter(":not([name$='_country'])"), function (e) {
			if (!$cache.copyAddress[0].checked) { return; }
			copyBeforeAddress();
		});


		$("form").on("change", "select[name$='_country']", function(e) {
			app.util.updateStateOptions(this);

			if ($cache.copyAddress.length > 0 && $cache.copyAddress[0].checked && this.id.indexOf("_addressBefore") > 0) {
				copyBeforeAddress();
				$cache.addressAfterFields.filter("[name$='_country']").trigger("change");
			}
		});

		$cache.registryItemsTable.on("click", ".item-details a", function (e) {
			e.preventDefault();
			var productListID = $('input[name=productListID]').val();
			app.quickView.show({
				url : e.target.href,
				source : "giftregistry",
				productlistid : productListID
			});

		});
	}

	/******* app.registry public object ********/
	app.registry = {
		init : function () {
			initializeCache();
			initializeDom();
			initializeEvents();
			app.product.initAddToCart();

		}

	};

}(window.app = window.app || {}, jQuery));

/**
 * @class app.progress
 */
(function (app, $) {
	var loader;
	app.progress = {
		/**
		 * @function
		 * @description Shows an AJAX-loader on top of a given container
		 * @param {Element} container The Element on top of which the AJAX-Loader will be shown
		 */
		show: function (container) {
			var target = (!container || $(container).length===0) ? $("body") : $(container);
			loader = loader || $(".loader");

			if (loader.length===0) {
				loader = $("<div/>").addClass("loader")
									.append($("<div/>").addClass("loader-indicator"), $("<div/>").addClass("loader-bg"));

			}
			return loader.appendTo(target).show();
		},
		/**
		 * @function
		 * @description Hides an AJAX-loader
		 */
		hide: function () {
			if (loader) { loader.hide(); }
		}
	};
}(window.app = window.app || {}, jQuery));

/**
 * @class app.components
 */
(function (app, dw, $) {
	/**
	 * @function
	 * @description capture recommendation of each product when it becomes visible in the carousel
	 * @param c TBD
	 * @param {Element} li The visible product element in the carousel
	 * @param index TBD
	 * @param state TBD
	 */
	function captureCarouselRecommendations(c, li, index, state) {
		if (!dw) { return; }

		$(li).find(".capture-product-id").each(function () {
			dw.ac.capture({
				id : $(this).text(),
				type : dw.ac.EV_PRD_RECOMMENDATION
			});
		});
	}

	/******* app.components public object ********/
	app.components = {
		carouselSettings : {
			scroll : 1,
			itemFallbackDimension: '100%',
			itemVisibleInCallback : app.captureCarouselRecommendations
		},
		init : function () {
			setTimeout(function(){
			// renders horizontal/vertical carousels for product slots
			$('#vertical-carousel').jcarousel($.extend({vertical : true}, app.components.carouselSettings));
			$('#horizontal-carousel').jcarousel(app.components.carouselSettings);
			}, 1000);
		}
	};
}(window.app = window.app || {}, window.dw, jQuery));

/**
 * @class app.cart
 */
(function (app, $) {
	var $cache = {};
	/**
	 * @private
	 * @function
	 * @description Updates the cart with new data
	 * @param {Object} postdata An Object representing the the new or uptodate data
	 * @param {Object} A callback function to be called
	 */
	function updateCart(postdata, callback) {
		var url = app.util.ajaxUrl(app.urls.addProduct);
		$.post(url, postdata, callback || app.cart.refresh);
	}
	/**
	 * @private
	 * @function
	 * @description Cache initialization of the cart page
	 */
	function initializeCache() {
		$cache = {
			cartTable : $("#cart-items-form"),
			itemsForm : $("#cart-items-form"),
			addCoupon : $("#add-coupon"),
			couponCode : $("form input[name$='_couponCode']"),
			crmCouponCode: $(".cart-block-container .hidden-crm-coupon"),
			selectCrmCoupon: $(".cart-block-container .crm_coupon"),
			submitCRMCoupon: $(".cart-block-container #button-apply-crm-coupon"),

		};
	}
	/**
	 * @private
	 * @function
	 * @description Binds events to the cart page (edit item's details, bonus item's actions, coupon code entry )
	 */
	function initializeEvents() {
		$cache.cartTable.on("click", ".item-edit-details a, .unavailable-pdt .item-quantity a", function (e) {

			if(!$(this).hasClass('delPop')) {

				e.preventDefault();
				var element= $(this);
				if(element.hasClass('add-Wish')) {

					$.ajax({
						url : element.attr('href'),
						success : function(response) {
							if (response.Result != 'null' && response.Result == 'ok') {
								var myResult = $('<p>').addClass('wishlist-succeed').text(response.Message).css('display', 'none').css('position', 'absolute');
							} else {
								var myResult = $('<p>').addClass('wishlist-failed').text(response.Message).css('display', 'none').css('position', 'absolute');
							}

							element.closest('.item-edit-details').append(myResult);
							element.fadeOut(function() {
								myResult.fadeIn();
							});

							setTimeout( function() {
								myResult.fadeOut(function() {
									element.fadeIn();
								}).remove(function() {

								});

							}, 4000);
						}
					});

				} else {
	 			var myWidth,
					inWidth = $(this).data('width');
				if($(window).width() > 767 && inWidth !== undefined) {
					myWidth = inWidth;
				}else{
					myWidth = 310;
				}
					app.quickView.show({
						url : e.target.href,
						source : "cart",
						width: myWidth
					});
					Sandro.product.bindAddToWishlist();
					$(document).on('click', '.add-to-cart-disabled', function(){
						Sandro.product.cannotaddtocart(this);
					});


				}
			}

		})
		.on("click", ".bonus-item-actions a", function (e) {
			e.preventDefault();
			app.bonusProductsView.show(this.href);
		});

		// override enter key for coupon code entry
		$cache.couponCode.on("keydown", function (e) {
			if (e.which === 13) {
				if ($(this).val().length===0) { return false; }
				e.preventDefault();
				$cache.addCoupon.click();
			}
		});
		$cache.selectCrmCoupon.on("change", function(e) {
			var couponVal = $(this).val();
			$(".cart-block-container .hidden-crm-coupon").val(couponVal);
		});
		$cache.submitCRMCoupon.on("click", function(e) {
			var couponVal = $(".cart-block-container .hidden-crm-coupon").val();
			if (couponVal != '') {
				$.ajax({
					url: app.urls.addCRMCoupon,
					cache: false,
					data: {couponCode: couponVal },
					type : "POST",
					dataType : "json",
					success: function(response) {
						if (response.response_code == 'OK') {
							location.reload();
						} else {
							console.log(app.resources[response.response_message]);
						}
					} 
				});
			}
		});
		

	}
	/******* app.cart public object ********/
	app.cart = {
		/**
		 * @function
		 * @description Adds new item to the cart
		 * @param {Object} postdata An Object representing the the new or uptodate data
		 * @param {Object} A callback function to be called
		 */
		add : function (postdata, callback) {
			updateCart(postdata, callback);
		},
		/**
		 * @function
		 * @description Hook for removing item from the cart
		 *
		 */
		remove : function () {
			return;
		},
		/**
		 * @function
		 * @description Updates the cart with new data
		 * @param {Object} postdata An Object representing the the new or uptodate data
		 * @param {Object} A callback function to be called
		 */
		update : function (postdata, callback) {
			updateCart(postdata, callback);
		},
		/**
		 * @function
		 * @description Refreshes the cart without posting
		 */
		refresh : function () {
			// refresh without posting
			app.page.refresh();
		},
		/**
		 * @function
		 * @description Initializes the functionality on the cart
		 */
		init : function () {
			// edit shopping cart line item
			initializeCache();
			initializeEvents();
		}
	};

}(window.app = window.app || {}, jQuery));

/**
 * @class app.account
 */
(function (app, $) {
	var $cache = {};
	/**
	 * @private
	 * @function
	 * @description Initializes the events on the address form (apply, cancel, delete)
	 * @param {Element} form The form which will be initialized
	 */
	function initializeAddressForm(form) {
		var form = $("#edit-address-form");

		form.find("input[name='format']").remove();
		app.tooltips.init();
		//$("<input/>").attr({type:"hidden", name:"format", value:"ajax"}).appendTo(form);

		form.on("click", ".apply-button", function(e) {
			e.preventDefault();
			var addressId = form.find("input[name$='_addressid']");
			addressId.val(addressId.val().replace(/[^\w+-]/g, "-"));
			if (!form.valid()) {
				return false;
			}
			var url = app.util.appendParamsToUrl(form.attr('action'),{format:"ajax"});
			var applyName = form.find('.apply-button').attr('name');
			var options = {
				url: url,
				data: form.serialize()+"&"+applyName+'=x',
				type: "POST"
			};
			$.ajax( options ).done(function(data){
				if( typeof(data)!=='string' ) {
					if ( data.success ) {
						app.dialog.close();
						app.page.refresh();
					} else {
						alert(data.message);
						return false;
					}
				} else {
					$('#dialog-container').html(data);
					app.account.init();
					app.tooltips.init();
				}
			});
		})
		.on("click", ".cancel-button, .close-button", function(e){
			e.preventDefault();
			app.dialog.close();
		})
		.on("click", ".delete-button", function(e){
			e.preventDefault();
			if (confirm(String.format(app.resources.CONFIRM_DELETE, app.resources.TITLE_ADDRESS))) {
				var url = app.util.appendParamsToUrl(app.urls.deleteAddress, {AddressID:form.find("#addressid").val(),format:"ajax"});
				$.ajax({
					url: url,
					method: "POST",
					dataType:"json"
				}).done(function(data){
					if (data.status.toLowerCase()==="ok") {
						app.dialog.close();
						app.page.refresh();
					}
					else if (data.message.length>0) {
						alert(data.message);
						return false;
					}
					else {
						app.dialog.close();
						app.page.refresh();
					}
				});
			}
		});

		$cache.countrySelect = form.find("select[id$='_country']");
		$cache.countrySelect.on("change", function(){
			app.util.updateStateOptions(this);
		});

		app.validator.init();
	}
	/**
	 * @private
	 * @function
	 * @description Toggles the list of Orders
	 */
	function toggleFullOrder () {
		$('.order-items')
			.find('li.hidden:first')
				.prev('li')
					.append('<a class="toggle">View All</a>')
					.children('.toggle')
						.click(function() {
							$(this).parent().siblings('li.hidden').show();
							$(this).remove();
						});
	}
	/**
	 * @private
	 * @function
	 * @description Binds the events on the address form (edit, create, delete)
	 */
	function initAddressEvents() {
		var addresses = $("#addresses");
		if (addresses.length===0) { return; }

		addresses.on("click", "a.address-edit, a.address-create", function(e){
			e.preventDefault();
			var options = {open: initializeAddressForm};
			app.dialog.open({url:this.href, options:options});
		}).on("click", ".delete", function(e){
			e.preventDefault();
			if (confirm(String.format(app.resources.CONFIRM_DELETE, app.resources.TITLE_ADDRESS))) {
				$.ajax({
					url: app.util.appendParamsToUrl($(this).attr("href"), {format:"ajax"}),
					dataType:"json"
				}).done(function(data){
					if (data.status.toLowerCase()==="ok") {
						app.page.redirect(app.urls.addressesList);
					}
					else if (data.message.length>0) {
						alert(data.message);
					}
					else {
						app.page.refresh();
					}
				});
			}
		});
	}
	/**
	 * @private
	 * @function
	 * @description Binds the events of the payment methods list (delete card)
	 */
	function initPaymentEvents() {
		var paymentList = $(".payment-list");
		if (paymentList.length===0) { return; }

		app.util.setDeleteConfirmation(paymentList, String.format(app.resources.CONFIRM_DELETE, app.resources.TITLE_CREDITCARD));

		$("form[name='payment-remove']").on("submit", function(e){
			e.preventDefault();
			// override form submission in order to prevent refresh issues
			var button = $(this).find("button.delete");
			$("<input/>").attr({type:"hidden", name:button.attr("name"), value:button.attr("value")||"delete card"}).appendTo($(this));
			var data = $(this).serialize();
			$.ajax({
				type: "POST",
				url: $(this).attr("action"),
				data: data.replace('&dwfrm_paymentinstruments_creditcards_removestoredcard=Delete', '')
			})
			.done(function(response) {
				app.page.redirect(app.urls.paymentsList);
			});
		});
	}
	/**
	 * @private
	 * @function
	 * @description Binds the events of the order, address and payment pages
	 */
	function initializeEvents() {
		toggleFullOrder();
		initAddressEvents();
		initPaymentEvents();
	}

	/******* app.account public object ********/
	app.account = {
		/**
		 * @function
		 * @description Binds the events of the order, address and payment pages
		 */
		init : function () {
			initializeEvents();

			app.giftcert.init();
		}
	};
}(window.app = window.app || {}, jQuery));

/**
 * @class app.wishlist
 */
(function (app, $) {
	var $cache = {};
	/**
	 * @private
	 * @function
	 * @description Binds the send to friend and address changed events to the wishlist page
	 */
	function initializeEvents() {
		app.sendToFriend.initializeDialog("div.list-table-header", ".send-to-friend");
		$cache.editAddress.on('change', function () {
			window.location.href = app.util.appendParamToURL(app.urls.wishlistAddress, "AddressID", $(this).val());

		});
	}


	/******* app.wishlist public object ********/
	app.wishlist = {
		/**
		 * @function
		 * @description Binds events to the wishlist page
		 */
		init : function () {
			//$cache.editAddress = $('#editAddress');
			$cache.wishlistTable = $('.pt_wish-list .item-list');
			app.product.initAddToCart();
			initializeEvents();

		}
	};
}(window.app = window.app || {}, jQuery));

/**
 * @class app.minicart
 */
(function (app, $) {
	// sub name space app.minicart.* provides functionality around the mini cart

	var $cache = {},
		initialized = false;

	var timer = {
		id : null,
		clear : function () {
			if(timer.id) {
				window.clearTimeout(timer.id);
				delete timer.id;
			}
		},
		start : function (duration) {
			timer.id = setTimeout(app.minicart.close, duration);
		}
	};
	/******* app.minicart public object ********/
	app.minicart = {
		url : "", // during page loading, the Demandware URL is stored here

		/**
		 * @function
		 * @description Cache initializations and event binding to the mimcart
		 */
		init : function () {
			$cache.minicart = $("#mini-cart");
			$cache.mcTotal = $cache.minicart.find(".mini-cart-total");
			$cache.mcContent = $cache.minicart.find(".mini-cart-content");
			$cache.mcClose = $cache.minicart.find(".mini-cart-close");
			$cache.mcProductList = $cache.minicart.find(".mini-cart-products");
			$cache.mcProducts = $cache.mcProductList.children(".mini-cart-product");
			$cache.wrapMiniCart = $(".wrapper-mini-cart");
			$cache.btnMiniCart = $(".mini-cart-link");

			/* btn : open mini cart */
			$cache.btnMiniCart.on("click", function(e) {
				e.preventDefault();
				app.minicart.open();
			});

			/* btn : close mini cart */
			$cache.mcClose.on("click", function(e) {
				e.preventDefault();
				app.minicart.close();
			});

			/* close mini cart on click on overlay */
			$(document).on("touchstart click", ".overlay", function() {
				if($cache.wrapMiniCart.hasClass("open-mini-cart")){
					app.minicart.close();
				}
			});
		},
		/**
		 * @function
		 * @description Shows the given content in the mini cart
		 * @param {String} A HTML string with the content which will be shown
		 */
		show : function (html) {
			$cache.wrapMiniCart.html(html);
			app.minicart.init();
			app.minicart.slide();
			app.bonusProductsView.loadBonusOption();
		},
		updateMiniCart : function (html) {
			$cache.wrapMiniCart.html(html);
			app.minicart.init();
			app.bonusProductsView.loadBonusOption();
		},
		open : function () {
			// hotfix ios focus point scroll issue
			if ($('#mini-cart').length > 0) {
				var y = $('#mini-cart').offset().top;
				if ($(window).width() <= 768 && $("html, body").scrollTop() < y)
					$("html, body").animate({ 'scrollTop': y }, 200);
				// end hotfix
			}
			

			$cache.wrapMiniCart.addClass("open-mini-cart");
			Sandro.header.overlay.create("black", ".mini-cart-content", "#mini-cart");
			$("body").addClass("noScroll");
		},
		/**
		 * @function
		 * @description Slides down and show the contents of the mini cart
		 */
		slide : function () {
			if(!initialized) {
				app.minicart.init();
			}

			if(app.minicart.suppressSlideDown && app.minicart.suppressSlideDown()) {
				return;
			}

			timer.clear();
			$cache.minicart.off('.holdup');

			// show the item
			app.minicart.open();

			// after a time out automatically close it
			timer.start(6000);

			// stop to autoclose minicart
			$cache.minicart.on('mouseenter.holdup touchstart.holdup', function(){
				timer.clear();
			});
		},
		/**
		 * @function
		 * @description Closes the mini cart with given delay
		 * @param {Number} delay The delay in milliseconds
		 */
		close : function (delay) {
			timer.clear();
			$cache.wrapMiniCart.removeClass("open-mini-cart");
			Sandro.header.overlay.destroy();
			$("body").removeClass("noScroll");
		},
		/**
		 * @function
		 * @description Hook which can be replaced by individual pages/page types (e.g. cart)
		 */
			suppressSlideDown : function () {
			return false;
		}
	};
}(window.app = window.app || {}, jQuery));

/**
 * @class app.dialog
 */
(function (app, $) {
	// private

	var $cache = {};
	// end private

	/******* app.dialog public object ********/
	app.dialog = {
		/**
		 * @function
		 * @description Appends a dialog to a given container (target)
		 * @param {Object} params  params.target can be an id selector or an jquery object
		 */
		create : function (params) {
			// options.target can be an id selector or an jquery object
			var target = $(params.target || "#dialog-container");

			// if no element found, create one
			if(target.length === 0) {
				if(target.selector && target.selector.charAt(0) === "#") {
					id = target.selector.substr(1);
				}
				target = $("<div>").attr("id", id).addClass("dialog-content").appendTo("body");
			}

			// create the dialog
			$cache.container=target;
			$cache.container.dialog($.extend(true, {}, app.dialog.settings, params.options || {}));
			return $cache.container;
		},
		/**
		 * @function
		 * @description Opens a dialog using the given url (params.url)
		 * @param {Object} params.url should contain the url
		 */
		open : function (params) {
			if (!params.url || params.url.length===0) { return; }

			$cache.container = app.dialog.create(params);
			params.url = app.util.appendParamsToUrl(params.url, {format:"ajax"});

			// finally load the dialog
			app.ajax.load({
				target : $cache.container,
				url : params.url,
				callback : function () {

					if($cache.container.dialog("isOpen")) {	return;	}
					$cache.container.dialog("open");
				}
			});

		},
		/**
		 * @function
		 * @description Closes the dialog and triggers the "close" event for the dialog
		 */
		close : function () {
			if(!$cache.container) {
				return;
			}
			$cache.container.dialog("close");
		},
		/**
		 * @function
		 * @description Triggers the "apply" event for the dialog
		 */
		triggerApply : function () {
			$(this).trigger("dialogApplied");
		},
		/**
		 * @function
		 * @description Attaches the given callback function upon dialog "apply" event
		 */
		onApply : function (callback) {
			if(callback) {
				$(this).bind("dialogApplied", callback);
			}
		},
		/**
		 * @function
		 * @description Triggers the "delete" event for the dialog
		 */
		triggerDelete : function () {
			$(this).trigger("dialogDeleted");
		},
		/**
		 * @function
		 * @description Attaches the given callback function upon dialog "delete" event
		 * @param {String} The callback function to be called
		 */
		onDelete : function (callback) {
			if(callback) {
				$(this).bind("dialogDeleted", callback);
			}
		},
		/**
		 * @function
		 * @description Submits the dialog form with the given action
		 * @param {String} The action which will be triggered upon form submit
		 */
		submit : function (action) {
			var form = $cache.container.find("form:first");
			// set the action
			$("<input/>").attr({
				name : action,
				type : "hidden"
			}).appendTo(form);

			// serialize the form and get the post url
			var post = form.serialize();
			var url = form.attr("action");

			// post the data and replace current content with response content
			$.ajax({
				type : "POST",
				url : url,
				data : post,
				dataType : "html",
				success : function (data) {
					$cache.container.html(data);
				},
				failure : function (data) {
					window.alert(app.resources.SERVER_ERROR);
				}
			});
		},
		settings : {
			autoOpen : false,
			resizable : false,
			bgiframe : true,
			modal : true,
			height : 'auto',
			width : '800',
			buttons : {},
			title : '',
			position : 'center',
			overlay : {
				opacity : 0.5,
				background : "black"
			},
			/**
			 * @function
			 * @description The close event
			 */
			close : function (event, ui) {
				$(this).dialog("destroy");
			},
			closeText : app.resources.CLOSE
		}
	};
}(window.app = window.app || {}, jQuery));

/**
 * @class app.ajax
 */
(function (app, $) {

	var currentRequests = [];
	// request cache

	// sub namespace app.ajax.* contains application specific ajax components
	app.ajax = {
		/**
		 * @function
		 * @description Ajax request to get json response
		 * @param {Boolean} async  Asynchronous or not
		 * @param {String} url URI for the request
		 * @param {Object} data Name/Value pair data request
		 * @param {Function} callback  Callback function to be called
		 */
		getJson : function (options) {
			options.url = app.util.toAbsoluteUrl(options.url);
			// return if no url exists or url matches a current request
			if(!options.url || currentRequests[options.url]) {
				return;
			}

			currentRequests[options.url] = true;

			// make the server call
			$.ajax({
				dataType : "json",
				url : options.url,
				async : (typeof options.async==="undefined" || options.async===null) ? true : options.async,
				data : options.data || {}
			})
			// success
			.done(function (response) {
				if(options.callback) {
					options.callback(response);
				}
			})
			// failed
			.fail(function (xhr, textStatus) {
				if(textStatus === "parsererror") {
					window.alert(app.resources.BAD_RESPONSE);
				}
				if(options.callback) {
					options.callback(null);
				}
			})
			// executed on success or fail
			.always(function () {
				// remove current request from hash
				if(currentRequests[options.url]) {
					delete currentRequests[options.url];
				}
				app.progress.hide();
			});
		},
		/**
		 * @function
		 * @description ajax request to load html response in a given container
		 * @param {String} url URI for the request
		 * @param {Object} data Name/Value pair data request
		 * @param {Function} callback  Callback function to be called
		 * @param {Object} target Selector or element that will receive content
		 */
		load : function (options) {
			options.url = app.util.toAbsoluteUrl(options.url);
			// return if no url exists or url matches a current request
			if(!options.url || currentRequests[options.url]) {
				return;
			}

			currentRequests[options.url] = true;

			// make the server call
			$.ajax({
				dataType : "html",
				url : app.util.appendParamToURL(options.url, "format", "ajax"),
				data : options.data
			})
			.done(function (response) {
				// success
				if(options.target) {
					$(options.target).empty().html(response);
				}
				if(options.callback) {
					options.callback(response);
				}

			})
			.fail(function (xhr, textStatus) {
				// failed
				if(textStatus === "parsererror") {
					window.alert(app.resources.BAD_RESPONSE);
				}
				options.callback(null, textStatus);
			})
			.always(function () {
				app.progress.hide();
				// remove current request from hash
				if(currentRequests[options.url]) {
					delete currentRequests[options.url];
				}
			});
		}
	};
}(window.app = window.app || {}, jQuery));

/**
 * @class app.searchsuggest
 */
(function (app, $) {
	var qlen = 0,
		listTotal = -1,
		listCurrent = -1,
		delay = 300,
		fieldDefault = null,
		suggestionsJson = null,
		$searchForm,
		$searchField,
		$searchContainer,
		$resultsContainer,
		changeGridEventsInitialized = false;
	
	/**
	 * @function
	 * @description Handles keyboard's arrow keys
	 * @param keyCode Code of an arrow key to be handled
	 */
	function handleArrowKeys(keyCode) {
		switch (keyCode) {
			case 38:
				// keyUp
				listCurrent = (listCurrent <= 0) ? (listTotal - 1) : (listCurrent - 1);
				break;
			case 40:
				// keyDown
				listCurrent = (listCurrent >= listTotal - 1) ? 0 : listCurrent + 1;
				break;
			default:
				// reset
				listCurrent = -1;
				return false;
		}

		$resultsContainer.children().removeClass("selected").eq(listCurrent).addClass("selected");
		$searchField.val($resultsContainer.find(".selected div.suggestionterm").first().text());
		return true;
	}

	/******* app.searchsuggest public object ********/
	app.searchsuggest = {
		/**
		 * @function
		 * @description Configures parameters and required object instances
		 */
		init : function (container, defaultValue) {
			// initialize vars
			$searchContainer = $(container);
			$searchForm = $searchContainer.find("form[name='simpleSearch']");
			$searchField = $searchForm.find("input[name='q']");
			fieldDefault = defaultValue;

			// disable browser auto complete
			$searchField.attr("autocomplete", "off");

			// on focus listener (clear default value)
			$searchField.focus(function () {
				if(!$resultsContainer) {
					// create results container if needed
					$resultsContainer = $("<div/>").attr("id", "suggestions").appendTo($searchContainer).css({
						"top" : $searchContainer[0].offsetHeight,
						"left" : 0,
						"width" : $searchField[0].offsetWidth
					});
				}
				if($searchField.val() === fieldDefault) {
					$searchField.val("");
				}
			});
			// on blur listener
			$searchField.blur(function () {
				setTimeout(app.searchsuggest.clearResults, 200);
			});
			// on key up listener
			$searchField.keyup(function (e) {

				// get keyCode (window.event is for IE)
				var keyCode = e.keyCode || window.event.keyCode;

				// check and treat up and down arrows
				if(handleArrowKeys(keyCode)) {
					return;
				}
				// check for an ENTER or ESC
				if(keyCode === 13 || keyCode === 27) {
					app.searchsuggest.clearResults();
					return;
				}

				var lastVal = $searchField.val();

				// if is text, call with delay
				setTimeout(function () { app.searchsuggest.suggest(lastVal); }, delay);
			});
			// on submit we do not submit the form, but change the window location
			// in order to avoid https to http warnings in the browser
			// only if it's not the default value and it's not empty
			$searchForm.submit(function (e) {
				e.preventDefault();
				var searchTerm = $searchField.val();
				if(searchTerm === fieldDefault || searchTerm.length === 0) {
					return false;
				}
				window.location = app.util.appendParamToURL($(this).attr("action"), "q", searchTerm);
			});
		},

		/**
		 * @function
		 * @description trigger suggest action
		 * @param lastValue
		 */
		suggest : function (lastValue) {
			// get the field value
			var part = $searchField.val();

			// if it's empty clear the resuts box and return
			if(part.length === 0) {
				app.searchsuggest.clearResults();
				return;
			}

			// if part is not equal to the value from the initiated call,
			// or there were no results in the last call and the query length
			// is longer than the last query length, return
			// #TODO: improve this to look at the query value and length
			if((lastValue !== part) || (listTotal === 0 && part.length > qlen)) {
				return;
			}
			qlen = part.length;

			// build the request url
			var reqUrl = app.util.appendParamToURL(app.urls.searchsuggest, "q", part);

			// get remote data as JSON
			$.getJSON(reqUrl, function (data) {
				// get the total of results
				var suggestions = data,
					ansLength = suggestions.length,
					listTotal = ansLength;

				// if there are results populate the results div
				if(ansLength === 0) {
					app.searchsuggest.clearResults();
					return;
				}
				suggestionsJson = suggestions;
				var html = "";
				var i, len=ansLength;
				for(i=0; i < len; i++) {
					html+='<div><div class="suggestionterm">'+suggestions[i].suggestion+'</div><span class="hits">'+suggestions[i].hits+'</span></div>';
				}

				// update the results div
				$resultsContainer.html(html).show().on("hover", "div", function () {
					$(this).toggleClass = "selected";
				}).on("click", "div", function () {
					// on click copy suggestion to search field, hide the list and submit the search
					$searchField.val($(this).children(".suggestionterm").text());
					app.searchsuggest.clearResults();
					$searchForm.trigger("submit");
				});
			});
		},
		changeGrid : function() {
			function deviceLoad() {
				var device = "";
				var sizeWindow = window.innerWidth;
				var breakPointMobile = 768;
				var breakPointDesktop = 1024;

				if (sizeWindow < breakPointMobile) {
					device = "Mobile";
				}
				else if (sizeWindow < breakPointDesktop && sizeWindow >= breakPointMobile) {
					device = "Tablet";
				}
				else if (sizeWindow >= breakPointDesktop) {
					device = "Desktop";
				}

				return device;
			}

			var searchResultItem = $("#main");
			var allBtn = $(".wrapper-btn-changegrid li");


			var gridHelper = {
				1 : "grid-one",
				2 : "grid-two",
				4 : "grid-four",
				6 : "grid-six"
			}

			function showGrid(grid) {
				if (!searchResultItem.find(".search-result-content").hasClass("visible")) {
					searchResultItem.find(".search-result-content").addClass("visible");
					searchResultItem.find(".search-result-content").animate({"opacity":1}, 500);
				}

				searchResultItem.removeClass("result-grid-one result-grid-two result-grid-four result-grid-six");
				allBtn.removeClass("active");
				searchResultItem.addClass("result-" + gridHelper[grid]);
				ruptureMerch(grid);
			}

			function calculGrid(device) {
				// These defaults are set in paginginformation.isml, and come from site custom prefs
				var gridDefault = {
					"Desktop" : $(".wrapper-btn-changegrid").data("griddesktop"),
					"Tablet" : $(".wrapper-btn-changegrid").data("gridtablet"),
					"Mobile" : $(".wrapper-btn-changegrid").data("gridmobile")
				}

				// If we have a stored value for the number of column, use this one.
				// Else, use the defaults
				var nbCol = $.cookie('gridSelected');
				if( nbCol && nbCol !== 'undefined' )
					var grid = nbCol;
				else
					var grid = gridDefault[device];

				showGrid(grid);

				// Not sure what the active class does, but the selected one is used to stylise the wanted grid option
				$("li." + gridHelper[grid]).addClass("active").addClass("selected");
			}

			if (!changeGridEventsInitialized) {
				changeGridEventsInitialized = true;

				$(window).on("resize", function() {
					var currentDevice = deviceLoad();
					calculGrid(currentDevice);
				});
			}

			$(window).resize();
		},
		/**
		 * @function
		 * @description
		 */
		clearResults : function () {
			if (!$resultsContainer) { return; }
			$resultsContainer.empty().hide();
		}
	};
}(window.app = window.app || {}, jQuery));

/**
 * @class app.searchplaceholder
 */
(function (app, $) {
	/**
	 * @private
	 * @function
	 * @description Binds event to the place holder (.blur)
	 */
	function initializeEvents() {

	}

	/******* app.searchplaceholder public object ********/
	app.searchplaceholder = {
		/**
		 * @function
		 * @description Binds event to the place holder (.blur)
		 */
		init : function () {
			initializeEvents();
		}
	};
}(window.app = window.app || {}, jQuery));

// jquery extensions
(function ($) {
	// params
	// toggleClass - required
	// triggerSelector - optional. the selector for the element that triggers the event handler. defaults to the child elements of the list.
	// eventName - optional. defaults to 'click'
	$.fn.toggledList = function (options) {
		if (!options.toggleClass) { return this; }

		var list = this;
		function handleToggle(e) {
			e.preventDefault();
			var classTarget = options.triggerSelector ? $(this).parent() : $(this);
			classTarget.toggleClass(options.toggleClass);
			// execute callback if exists
			if (options.callback) { options.callback(); }
		}

		return list.on(options.eventName || "click", options.triggerSelector || list.children(), handleToggle);
	};


}(jQuery));

// general extension functions
(function () {
	String.format = function() {
		var s = arguments[0];
		var i,len=arguments.length - 1;
		for (i = 0; i < len; i++) {
			var reg = new RegExp("\\{" + i + "\\}", "gm");
			s = s.replace(reg, arguments[i + 1]);
		}
		return s;
	};
})();

quickviewMobileCart = function(){
	// we verify if is page cart and device mobile

	if($('.pt_cart').length && $(window).width() < 767){

		// we get selector for move element of quickview
		var lastIndex = $('#QuickViewDialog').find('.product-detail').find('.product-price').size();
		productPrice = $('#QuickViewDialog').find('.product-detail').find('.product-price').eq(lastIndex-1);
		productDetail = $('#QuickViewDialog').find('.product-detail');

		QPATC = $('#QuickViewDialog').find('.product-add-to-cart');
		//we move price of QuickView
		productPrice.insertBefore(QPATC);

		// we get selector of main image product
		parentImage = $('#QuickViewDialog').find('.product-image-container').find('.productlargeimgdata');
		// we get image mobile
		getImage = parentImage.data('mobileimg').split('|');

		// we create element html (img)
		createImg = $(document.createElement('img')).addClass('quickImage');
		// we set a first image of data
		if($('#QuickViewDialog').find('.quickImage').length){
			$('#QuickViewDialog').find('.quickImage').remove();
		}
		createImg.attr('src', getImage[0]).prependTo(productDetail);

	}
}

// initialize app
jQuery(document).ready(function () {
	app.init();
});
